/* tslint:disable */
/* eslint-disable */
/**
 * MyAzimut
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Type of acceptance document.
 * @export
 * @enum {string}
 */

export const AcceptanceDocumentType = {
    TermsAndConditions: 'TERMS_AND_CONDITIONS'
} as const;

export type AcceptanceDocumentType = typeof AcceptanceDocumentType[keyof typeof AcceptanceDocumentType];


/**
 * Informazioni relative all\'utenza
 * @export
 * @interface AccountInfo
 */
export interface AccountInfo {
    /**
     * 
     * @type {string}
     * @memberof AccountInfo
     */
    'dataAttivazioneServizio'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountInfo
     */
    'statoUtenza'?: AccountInfoStatoUtenzaEnum;
    /**
     * 
     * @type {UtenteAccountInfo}
     * @memberof AccountInfo
     */
    'utente'?: UtenteAccountInfo;
}

export const AccountInfoStatoUtenzaEnum = {
    Attivo: 'ATTIVO',
    Bloccato: 'BLOCCATO'
} as const;

export type AccountInfoStatoUtenzaEnum = typeof AccountInfoStatoUtenzaEnum[keyof typeof AccountInfoStatoUtenzaEnum];

/**
 * 
 * @export
 * @interface ActivateDobUserRequest
 */
export interface ActivateDobUserRequest {
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'codiceUtente'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'tipoUtente'?: ActivateDobUserRequestTipoUtenteEnum;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'codiceCliente'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'nome'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'cognome'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'codiceFiscale'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'cellulare'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'codiceAccordoQuadro'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'codiceContrattoMyAzimut'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'digitalContractCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'codiceAgente'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'codiceProspect'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'codiceClienteRappresentante'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'idAddendum'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'ragioneSociale'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'codiceFiscaleRappresentante'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDobUserRequest
     */
    'codiceProspectRappresentante'?: string;
}

export const ActivateDobUserRequestTipoUtenteEnum = {
    Pf: 'PF',
    Pg: 'PG'
} as const;

export type ActivateDobUserRequestTipoUtenteEnum = typeof ActivateDobUserRequestTipoUtenteEnum[keyof typeof ActivateDobUserRequestTipoUtenteEnum];

/**
 * 
 * @export
 * @interface AggiornaCellulareError
 */
export interface AggiornaCellulareError {
    /**
     * 
     * @type {Array<string>}
     * @memberof AggiornaCellulareError
     */
    'campiNonValidi'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AggiornaCellulareError
     */
    'codiciErrore'?: Array<AggiornaCellulareErrorCodiciErroreEnum>;
}

export const AggiornaCellulareErrorCodiciErroreEnum = {
    CellulareNonUtilizzabile: 'CELLULARE_NON_UTILIZZABILE',
    CambioCellulareTroppoRecente: 'CAMBIO_CELLULARE_TROPPO_RECENTE'
} as const;

export type AggiornaCellulareErrorCodiciErroreEnum = typeof AggiornaCellulareErrorCodiciErroreEnum[keyof typeof AggiornaCellulareErrorCodiciErroreEnum];

/**
 * 
 * @export
 * @interface AggiornaCellulareErrorAllOf
 */
export interface AggiornaCellulareErrorAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof AggiornaCellulareErrorAllOf
     */
    'codiciErrore'?: Array<AggiornaCellulareErrorAllOfCodiciErroreEnum>;
}

export const AggiornaCellulareErrorAllOfCodiciErroreEnum = {
    CellulareNonUtilizzabile: 'CELLULARE_NON_UTILIZZABILE',
    CambioCellulareTroppoRecente: 'CAMBIO_CELLULARE_TROPPO_RECENTE'
} as const;

export type AggiornaCellulareErrorAllOfCodiciErroreEnum = typeof AggiornaCellulareErrorAllOfCodiciErroreEnum[keyof typeof AggiornaCellulareErrorAllOfCodiciErroreEnum];

/**
 * 
 * @export
 * @interface AggiornaEmailError
 */
export interface AggiornaEmailError {
    /**
     * 
     * @type {Array<string>}
     * @memberof AggiornaEmailError
     */
    'campiNonValidi'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AggiornaEmailError
     */
    'codiciErrore'?: Array<AggiornaEmailErrorCodiciErroreEnum>;
}

export const AggiornaEmailErrorCodiciErroreEnum = {
    EmailNonUtilizzabile: 'EMAIL_NON_UTILIZZABILE',
    DocumentoScaduto: 'DOCUMENTO_SCADUTO'
} as const;

export type AggiornaEmailErrorCodiciErroreEnum = typeof AggiornaEmailErrorCodiciErroreEnum[keyof typeof AggiornaEmailErrorCodiciErroreEnum];

/**
 * 
 * @export
 * @interface AggiornaEmailErrorAllOf
 */
export interface AggiornaEmailErrorAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof AggiornaEmailErrorAllOf
     */
    'codiciErrore'?: Array<AggiornaEmailErrorAllOfCodiciErroreEnum>;
}

export const AggiornaEmailErrorAllOfCodiciErroreEnum = {
    EmailNonUtilizzabile: 'EMAIL_NON_UTILIZZABILE',
    DocumentoScaduto: 'DOCUMENTO_SCADUTO'
} as const;

export type AggiornaEmailErrorAllOfCodiciErroreEnum = typeof AggiornaEmailErrorAllOfCodiciErroreEnum[keyof typeof AggiornaEmailErrorAllOfCodiciErroreEnum];

/**
 * 
 * @export
 * @interface AggiornamentoCredenzialiError
 */
export interface AggiornamentoCredenzialiError {
    /**
     * 
     * @type {Array<string>}
     * @memberof AggiornamentoCredenzialiError
     */
    'campiNonValidi'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AggiornamentoCredenzialiError
     */
    'codiciErrore'?: Array<AggiornamentoCredenzialiErrorCodiciErroreEnum>;
}

export const AggiornamentoCredenzialiErrorCodiciErroreEnum = {
    CredenzialiUsateInPrecedenza: 'CREDENZIALI_USATE_IN_PRECEDENZA'
} as const;

export type AggiornamentoCredenzialiErrorCodiciErroreEnum = typeof AggiornamentoCredenzialiErrorCodiciErroreEnum[keyof typeof AggiornamentoCredenzialiErrorCodiciErroreEnum];

/**
 * 
 * @export
 * @interface AggiornamentoCredenzialiErrorAllOf
 */
export interface AggiornamentoCredenzialiErrorAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof AggiornamentoCredenzialiErrorAllOf
     */
    'codiciErrore'?: Array<AggiornamentoCredenzialiErrorAllOfCodiciErroreEnum>;
}

export const AggiornamentoCredenzialiErrorAllOfCodiciErroreEnum = {
    CredenzialiUsateInPrecedenza: 'CREDENZIALI_USATE_IN_PRECEDENZA'
} as const;

export type AggiornamentoCredenzialiErrorAllOfCodiciErroreEnum = typeof AggiornamentoCredenzialiErrorAllOfCodiciErroreEnum[keyof typeof AggiornamentoCredenzialiErrorAllOfCodiciErroreEnum];

/**
 * Payload utilizzato per il cambio password
 * @export
 * @interface AggiornamentoCredenzialiRequest
 */
export interface AggiornamentoCredenzialiRequest {
    /**
     * 
     * @type {string}
     * @memberof AggiornamentoCredenzialiRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof AggiornamentoCredenzialiRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof AggiornamentoCredenzialiRequest
     */
    'nuovaPassword': string;
}
/**
 * 
 * @export
 * @interface AggiornamentoCredenzialiRequestAllOf
 */
export interface AggiornamentoCredenzialiRequestAllOf {
    /**
     * 
     * @type {string}
     * @memberof AggiornamentoCredenzialiRequestAllOf
     */
    'nuovaPassword': string;
}
/**
 * 
 * @export
 * @interface AmlTemplate
 */
export interface AmlTemplate {
    /**
     * 
     * @type {string}
     * @memberof AmlTemplate
     */
    'titoloSezione'?: string;
    /**
     * 
     * @type {string}
     * @memberof AmlTemplate
     */
    'titoloSubSezione'?: string;
    /**
     * 
     * @type {string}
     * @memberof AmlTemplate
     */
    'titoloSubSubSezione'?: string;
    /**
     * 
     * @type {string}
     * @memberof AmlTemplate
     */
    'labelClienteNonProfilato'?: string;
    /**
     * 
     * @type {Array<Sezione>}
     * @memberof AmlTemplate
     */
    'sezioni'?: Array<Sezione>;
    /**
     * 
     * @type {StatusResponse}
     * @memberof AmlTemplate
     */
    'statusResponse'?: StatusResponse;
}
/**
 * 
 * @export
 * @interface Amministrativo
 */
export interface Amministrativo {
    /**
     * 
     * @type {Array<CategoriaAmministrativo>}
     * @memberof Amministrativo
     */
    'categorie'?: Array<CategoriaAmministrativo>;
    /**
     * 
     * @type {Importo}
     * @memberof Amministrativo
     */
    'totale'?: Importo;
}
/**
 * 
 * @export
 * @interface AnnullaCambioContatto
 */
export interface AnnullaCambioContatto {
    /**
     * 
     * @type {string}
     * @memberof AnnullaCambioContatto
     */
    'tipo_contatto'?: AnnullaCambioContattoTipoContattoEnum;
}

export const AnnullaCambioContattoTipoContattoEnum = {
    Email: 'EMAIL',
    Phone: 'PHONE'
} as const;

export type AnnullaCambioContattoTipoContattoEnum = typeof AnnullaCambioContattoTipoContattoEnum[keyof typeof AnnullaCambioContattoTipoContattoEnum];

/**
 * 
 * @export
 * @interface AssicurativoFinanziario
 */
export interface AssicurativoFinanziario {
    /**
     * 
     * @type {CategoriaUnitLinkedPrezzo}
     * @memberof AssicurativoFinanziario
     */
    'unitLinkedPrezzo'?: CategoriaUnitLinkedPrezzo;
    /**
     * 
     * @type {CategoriePolizzeTradizionaliRivalutate}
     * @memberof AssicurativoFinanziario
     */
    'polizzeTradizionaliRivalutate'?: CategoriePolizzeTradizionaliRivalutate;
    /**
     * 
     * @type {CategoriaUnitLinked}
     * @memberof AssicurativoFinanziario
     */
    'unitLinked'?: CategoriaUnitLinked;
    /**
     * 
     * @type {Importo}
     * @memberof AssicurativoFinanziario
     */
    'totale'?: Importo;
}
/**
 * 
 * @export
 * @interface AssicurativoTradizionale
 */
export interface AssicurativoTradizionale {
    /**
     * 
     * @type {Array<CategoriaAssicurativoTradizionale>}
     * @memberof AssicurativoTradizionale
     */
    'categorie'?: Array<CategoriaAssicurativoTradizionale>;
}
/**
 * 
 * @export
 * @interface AziendeSottostantiResponse
 */
export interface AziendeSottostantiResponse {
    /**
     * 
     * @type {string}
     * @memberof AziendeSottostantiResponse
     */
    'esito'?: string;
    /**
     * 
     * @type {string}
     * @memberof AziendeSottostantiResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AziendeSottostantiResponse
     */
    'messages'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AziendeSottostantiResponse
     */
    'residue'?: number;
    /**
     * 
     * @type {Array<EcrProduct>}
     * @memberof AziendeSottostantiResponse
     */
    'items'?: Array<EcrProduct>;
}
/**
 * 
 * @export
 * @interface BundleId
 */
export interface BundleId {
    /**
     * Identificativo del documento da firmare se è in corso un cambio email o cellulare
     * @type {string}
     * @memberof BundleId
     */
    'bundleId'?: string;
}
/**
 * 
 * @export
 * @interface CancellaUtenteTmpRequest
 */
export interface CancellaUtenteTmpRequest {
    /**
     * Codice utente da eliminare
     * @type {string}
     * @memberof CancellaUtenteTmpRequest
     */
    'codiceUtente': string;
}
/**
 * 
 * @export
 * @interface CategoriaAmministrativo
 */
export interface CategoriaAmministrativo {
    /**
     * 
     * @type {string}
     * @memberof CategoriaAmministrativo
     */
    'nome'?: string;
    /**
     * 
     * @type {Array<ProdottoAmministrativo>}
     * @memberof CategoriaAmministrativo
     */
    'prodotti'?: Array<ProdottoAmministrativo>;
    /**
     * 
     * @type {Importo}
     * @memberof CategoriaAmministrativo
     */
    'totale'?: Importo;
}
/**
 * 
 * @export
 * @interface CategoriaAssicurativoTradizionale
 */
export interface CategoriaAssicurativoTradizionale {
    /**
     * 
     * @type {string}
     * @memberof CategoriaAssicurativoTradizionale
     */
    'nome'?: string;
    /**
     * 
     * @type {Array<ProdottoAssicurativoTradizionale>}
     * @memberof CategoriaAssicurativoTradizionale
     */
    'prodotti'?: Array<ProdottoAssicurativoTradizionale>;
    /**
     * 
     * @type {Importo}
     * @memberof CategoriaAssicurativoTradizionale
     */
    'totale'?: Importo;
}
/**
 * 
 * @export
 * @interface CategoriaEconomiaReale
 */
export interface CategoriaEconomiaReale {
    /**
     * 
     * @type {string}
     * @memberof CategoriaEconomiaReale
     */
    'nome'?: string;
    /**
     * 
     * @type {Array<MacroProdottoEconomiaReale>}
     * @memberof CategoriaEconomiaReale
     */
    'macroProdotti'?: Array<MacroProdottoEconomiaReale>;
    /**
     * 
     * @type {Importo}
     * @memberof CategoriaEconomiaReale
     */
    'totale'?: Importo;
}
/**
 * 
 * @export
 * @interface CategoriaGestito
 */
export interface CategoriaGestito {
    /**
     * 
     * @type {string}
     * @memberof CategoriaGestito
     */
    'nome'?: string;
    /**
     * 
     * @type {Array<MacroProdottoGestito>}
     * @memberof CategoriaGestito
     */
    'macroProdotti'?: Array<MacroProdottoGestito>;
    /**
     * 
     * @type {Importo}
     * @memberof CategoriaGestito
     */
    'totale'?: Importo;
}
/**
 * 
 * @export
 * @interface CategoriaLiquidita
 */
export interface CategoriaLiquidita {
    /**
     * 
     * @type {string}
     * @memberof CategoriaLiquidita
     */
    'nome'?: string;
    /**
     * 
     * @type {Array<ProdottoLiquidita>}
     * @memberof CategoriaLiquidita
     */
    'prodotti'?: Array<ProdottoLiquidita>;
    /**
     * 
     * @type {Importo}
     * @memberof CategoriaLiquidita
     */
    'totale'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof CategoriaLiquidita
     */
    'totaleSaldoContabile'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof CategoriaLiquidita
     */
    'totaleSaldoDisponibile'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof CategoriaLiquidita
     */
    'totaleSaldoLiquido'?: Importo;
}
/**
 * 
 * @export
 * @interface CategoriaPrevidenza
 */
export interface CategoriaPrevidenza {
    /**
     * 
     * @type {string}
     * @memberof CategoriaPrevidenza
     */
    'nome'?: string;
    /**
     * 
     * @type {Array<ProdottoPrevidenza>}
     * @memberof CategoriaPrevidenza
     */
    'prodotti'?: Array<ProdottoPrevidenza>;
    /**
     * 
     * @type {Importo}
     * @memberof CategoriaPrevidenza
     */
    'totale'?: Importo;
}
/**
 * 
 * @export
 * @interface CategoriaUnitLinked
 */
export interface CategoriaUnitLinked {
    /**
     * 
     * @type {Array<ProdottoUnitLinked>}
     * @memberof CategoriaUnitLinked
     */
    'prodotti'?: Array<ProdottoUnitLinked>;
    /**
     * 
     * @type {Importo}
     * @memberof CategoriaUnitLinked
     */
    'totale'?: Importo;
}
/**
 * 
 * @export
 * @interface CategoriaUnitLinkedPrezzo
 */
export interface CategoriaUnitLinkedPrezzo {
    /**
     * 
     * @type {Array<ProdottoUnitLinkedPrezzo>}
     * @memberof CategoriaUnitLinkedPrezzo
     */
    'prodotti'?: Array<ProdottoUnitLinkedPrezzo>;
    /**
     * 
     * @type {Importo}
     * @memberof CategoriaUnitLinkedPrezzo
     */
    'totale'?: Importo;
}
/**
 * 
 * @export
 * @interface CategoriePolizzeTradizionaliRivalutate
 */
export interface CategoriePolizzeTradizionaliRivalutate {
    /**
     * 
     * @type {Array<ProdottoPolizzeTradizionaliRivalutate>}
     * @memberof CategoriePolizzeTradizionaliRivalutate
     */
    'prodotti'?: Array<ProdottoPolizzeTradizionaliRivalutate>;
    /**
     * 
     * @type {Importo}
     * @memberof CategoriePolizzeTradizionaliRivalutate
     */
    'totale'?: Importo;
}
/**
 * 
 * @export
 * @interface Cellulare
 */
export interface Cellulare {
    /**
     * Phone number in international E.164 format (e.g. +393331234567, +447429310834).  Numbers with grouping spaces are also accepted (e.g. +39 320 123 4567); the  backend normalises to E.164 without spaces.
     * @type {string}
     * @memberof Cellulare
     */
    'cellulare': string;
}
/**
 * 
 * @export
 * @interface ClientsConfigResponse
 */
export interface ClientsConfigResponse {
    /**
     * 
     * @type {ConfigStatus}
     * @memberof ClientsConfigResponse
     */
    'status'?: ConfigStatus;
    /**
     * 
     * @type {ConfigData}
     * @memberof ClientsConfigResponse
     */
    'data'?: ConfigData;
}
/**
 * 
 * @export
 * @interface CodiceClienteRappresentante
 */
export interface CodiceClienteRappresentante {
    /**
     * 
     * @type {string}
     * @memberof CodiceClienteRappresentante
     */
    'codiceClienteRappresentante'?: string;
}
/**
 * 
 * @export
 * @interface CodiceDiVerifica
 */
export interface CodiceDiVerifica {
    /**
     * 
     * @type {string}
     * @memberof CodiceDiVerifica
     */
    'codiceDiVerifica': string;
}
/**
 * 
 * @export
 * @interface CodiceFiscaleRappresentante
 */
export interface CodiceFiscaleRappresentante {
    /**
     * Codice Fiscale
     * @type {string}
     * @memberof CodiceFiscaleRappresentante
     */
    'codiceFiscaleRappresentante': string;
}
/**
 * 
 * @export
 * @interface CodiceMifid
 */
export interface CodiceMifid {
    /**
     * Identificativo del questionario mifid portato a termine
     * @type {string}
     * @memberof CodiceMifid
     */
    'codiceMifid'?: string;
}
/**
 * 
 * @export
 * @interface CodiciDiVerificaCambioContatti
 */
export interface CodiciDiVerificaCambioContatti {
    /**
     * 
     * @type {string}
     * @memberof CodiciDiVerificaCambioContatti
     */
    'codiceDiVerificaEmail': string;
    /**
     * 
     * @type {string}
     * @memberof CodiciDiVerificaCambioContatti
     */
    'codiceDiVerificaCellulare': string;
}
/**
 * Cointestatario di un dossier
 * @export
 * @interface Cointestatario
 */
export interface Cointestatario {
    /**
     * 
     * @type {string}
     * @memberof Cointestatario
     */
    'nominativo'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cointestatario
     */
    'codiceCliente'?: string;
}
/**
 * 
 * @export
 * @interface ConfigData
 */
export interface ConfigData {
    /**
     * 
     * @type {boolean}
     * @memberof ConfigData
     */
    'maintenance'?: boolean;
    /**
     * 
     * @type {Array<LoginMessage>}
     * @memberof ConfigData
     */
    'loginMessages'?: Array<LoginMessage>;
    /**
     * 
     * @type {DateRange}
     * @memberof ConfigData
     */
    'signingAreaDateRange'?: DateRange;
}
/**
 * 
 * @export
 * @interface ConfigStatus
 */
export interface ConfigStatus {
    /**
     * 
     * @type {string}
     * @memberof ConfigStatus
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigStatus
     */
    'description'?: string;
}
/**
 * Payload utilizzato per aggiornare il consenso al trattamento dei dati
 * @export
 * @interface ConsensoPrivacy
 */
export interface ConsensoPrivacy {
    /**
     * 
     * @type {boolean}
     * @memberof ConsensoPrivacy
     */
    'consensoTrattamentoDati': boolean;
}
/**
 * Contatore dei tentativi rimasti per errori di inoltro degli OTP
 * @export
 * @interface ContatoreTentativiOTP
 */
export interface ContatoreTentativiOTP {
    /**
     * 
     * @type {number}
     * @memberof ContatoreTentativiOTP
     */
    'tentativiRimastiOTP'?: number;
}
/**
 * Contatore dei tentativi rimasti per errori di inoltro degli OTP
 * @export
 * @interface ContatoriTentativiOTP
 */
export interface ContatoriTentativiOTP {
    /**
     * 
     * @type {number}
     * @memberof ContatoriTentativiOTP
     */
    'tentativiRimastiOTPEmail'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContatoriTentativiOTP
     */
    'tentativiRimastiOTPCellulare'?: number;
}
/**
 * ContextRequest
 * @export
 * @interface ContextRequest
 */
export interface ContextRequest {
    /**
     * 
     * @type {string}
     * @memberof ContextRequest
     */
    'codiceRubrica'?: string;
}
/**
 * 
 * @export
 * @interface Costituzione
 */
export interface Costituzione {
    /**
     * 
     * @type {string}
     * @memberof Costituzione
     */
    'dataCostituzione'?: string;
    /**
     * 
     * @type {IndirizzoNFE}
     * @memberof Costituzione
     */
    'indirizzo'?: IndirizzoNFE;
}
/**
 * Le credenziali per il login
 * @export
 * @interface Credenziali
 */
export interface Credenziali {
    /**
     * 
     * @type {string}
     * @memberof Credenziali
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof Credenziali
     */
    'password': string;
}
/**
 * Le credenziali per il login
 * @export
 * @interface Credenziali2
 */
export interface Credenziali2 {
    /**
     * 
     * @type {string}
     * @memberof Credenziali2
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof Credenziali2
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface CurrentDocumentVersion
 */
export interface CurrentDocumentVersion {
    /**
     * Technical identifier of the version; to be sent back when accepting it.
     * @type {number}
     * @memberof CurrentDocumentVersion
     */
    'documentVersionId': number;
    /**
     * 
     * @type {AcceptanceDocumentType}
     * @memberof CurrentDocumentVersion
     */
    'documentType': AcceptanceDocumentType;
    /**
     * Business version number, incremented by one for each new version of the document type.
     * @type {number}
     * @memberof CurrentDocumentVersion
     */
    'versionNumber': number;
    /**
     * Public URL of the PDF document.
     * @type {string}
     * @memberof CurrentDocumentVersion
     */
    'url': string;
    /**
     * Whether the authenticated user has accepted this version.
     * @type {boolean}
     * @memberof CurrentDocumentVersion
     */
    'accepted': boolean;
}
/**
 * 
 * @export
 * @interface DateRange
 */
export interface DateRange {
    /**
     * Start of the range (UTC, ISO 8601 with milliseconds)
     * @type {string}
     * @memberof DateRange
     */
    'from'?: string;
    /**
     * End of the range (UTC, ISO 8601 with milliseconds)
     * @type {string}
     * @memberof DateRange
     */
    'to'?: string;
}
/**
 * Maggiori dettagli sull\'errore
 * @export
 * @interface DettagliErrore
 */
export interface DettagliErrore {
    /**
     * 
     * @type {Array<string>}
     * @memberof DettagliErrore
     */
    'campiNonValidi'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DettaglioOrdineRto
 */
export interface DettaglioOrdineRto {
    /**
     * response code
     * @type {string}
     * @memberof DettaglioOrdineRto
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof DettaglioOrdineRto
     */
    'message'?: string;
    /**
     * 
     * @type {OrdineRto}
     * @memberof DettaglioOrdineRto
     */
    'result'?: OrdineRto;
}
/**
 * 
 * @export
 * @interface Dipendenza
 */
export interface Dipendenza {
    /**
     * 
     * @type {number}
     * @memberof Dipendenza
     */
    'idDomandaDipendenza'?: number;
    /**
     * 
     * @type {number}
     * @memberof Dipendenza
     */
    'idRispostaDipendenza'?: number;
    /**
     * 
     * @type {string}
     * @memberof Dipendenza
     */
    'idRispostaEsternaDipendenza'?: string;
    /**
     * 
     * @type {string}
     * @memberof Dipendenza
     */
    'tipoDipendenza'?: string;
}
/**
 * 
 * @export
 * @interface DocumentAcceptanceRequest
 */
export interface DocumentAcceptanceRequest {
    /**
     * Identifier of the document version to accept, as returned by the GET.
     * @type {number}
     * @memberof DocumentAcceptanceRequest
     */
    'documentVersionId': number;
}
/**
 * 
 * @export
 * @interface Documento
 */
export interface Documento {
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'tipoDocumento'?: string;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'numeroDocumento'?: string;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'dataEmissione'?: string;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'dataScadenza'?: string;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'desLocalitaEmissione'?: string;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'codNazioneEmissione'?: string;
}
/**
 * Documento Area Firma
 * @export
 * @interface DocumentoFirma
 */
export interface DocumentoFirma {
    /**
     * 
     * @type {string}
     * @memberof DocumentoFirma
     */
    'titoloPratica'?: string;
    /**
     * Qui vengono riportati nomi e cognomi dell intestatario e/o cointestatari
     * @type {string}
     * @memberof DocumentoFirma
     */
    'cliente'?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentoFirma
     */
    'totaleModuli'?: number;
    /**
     * Se il documento deve comparire nel TAB [In Scadenza]
     * @type {boolean}
     * @memberof DocumentoFirma
     */
    'inScadenzaPerMe'?: boolean;
    /**
     * Se il documento è in attesa della firma di un altro sottoscrittore
     * @type {string}
     * @memberof DocumentoFirma
     */
    'prossimoFirmatario'?: string;
    /**
     * Se il documento è da firmare, e l utente loggato è il prossimo firmatario e il documento deve comparire nel TAB [In Scadenza]
     * @type {boolean}
     * @memberof DocumentoFirma
     */
    'richiestaMiaFirma'?: boolean;
}
/**
 * 
 * @export
 * @interface DocumentoScadutoError
 */
export interface DocumentoScadutoError {
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentoScadutoError
     */
    'campiNonValidi'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentoScadutoError
     */
    'codiciErrore'?: Array<DocumentoScadutoErrorCodiciErroreEnum>;
}

export const DocumentoScadutoErrorCodiciErroreEnum = {
    DocumentoScaduto: 'DOCUMENTO_SCADUTO'
} as const;

export type DocumentoScadutoErrorCodiciErroreEnum = typeof DocumentoScadutoErrorCodiciErroreEnum[keyof typeof DocumentoScadutoErrorCodiciErroreEnum];

/**
 * 
 * @export
 * @interface DocumentoScadutoErrorAllOf
 */
export interface DocumentoScadutoErrorAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentoScadutoErrorAllOf
     */
    'codiciErrore'?: Array<DocumentoScadutoErrorAllOfCodiciErroreEnum>;
}

export const DocumentoScadutoErrorAllOfCodiciErroreEnum = {
    DocumentoScaduto: 'DOCUMENTO_SCADUTO'
} as const;

export type DocumentoScadutoErrorAllOfCodiciErroreEnum = typeof DocumentoScadutoErrorAllOfCodiciErroreEnum[keyof typeof DocumentoScadutoErrorAllOfCodiciErroreEnum];

/**
 * 
 * @export
 * @interface Domanda
 */
export interface Domanda {
    /**
     * 
     * @type {number}
     * @memberof Domanda
     */
    'idDomanda'?: number;
    /**
     * 
     * @type {string}
     * @memberof Domanda
     */
    'testoDomanda'?: string;
    /**
     * 
     * @type {string}
     * @memberof Domanda
     */
    'subTestoDomanda'?: string;
    /**
     * 
     * @type {string}
     * @memberof Domanda
     */
    'inputType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Domanda
     */
    'tipoDominio'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Domanda
     */
    'flagDipendenza'?: boolean;
    /**
     * 
     * @type {Array<Dipendenza>}
     * @memberof Domanda
     */
    'listaDipendenze'?: Array<Dipendenza>;
    /**
     * 
     * @type {Array<Risposta>}
     * @memberof Domanda
     */
    'listaRisposte'?: Array<Risposta>;
    /**
     * 
     * @type {StrutturaInternaDomande}
     * @memberof Domanda
     */
    'strutturaInternaDomande'?: StrutturaInternaDomande;
    /**
     * 
     * @type {boolean}
     * @memberof Domanda
     */
    'flagMandatory'?: boolean;
    /**
     * 
     * @type {Array<Validator>}
     * @memberof Domanda
     */
    'validators'?: Array<Validator>;
    /**
     * 
     * @type {string}
     * @memberof Domanda
     */
    'pathImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Domanda
     */
    'numDomanda'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Domanda
     */
    'flagCoerenzaIp'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Domanda
     */
    'disable'?: boolean;
}
/**
 * 
 * @export
 * @interface DominioRisposte
 */
export interface DominioRisposte {
    /**
     * 
     * @type {string}
     * @memberof DominioRisposte
     */
    'descrizione'?: string;
    /**
     * 
     * @type {Array<Risposta>}
     * @memberof DominioRisposte
     */
    'risposte'?: Array<Risposta>;
}
/**
 * Dossier radice
 * @export
 * @interface DossierItem
 */
export interface DossierItem {
    /**
     * Indica se il dossier è aperto o chiuso
     * @type {boolean}
     * @memberof DossierItem
     */
    'aperto'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DossierItem
     */
    'codiceDossier'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierItem
     */
    'tipoConsulenza'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierItem
     */
    'numeroContrattoServizio'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierItem
     */
    'cointestatari'?: Array<string>;
    /**
     * cointestatari del dossier con nominativo e codice cliente; i nominativi sono riportati anche in cointestatari per le app già installate
     * @type {Array<Cointestatario>}
     * @memberof DossierItem
     */
    'cointestatariDettaglio'?: Array<Cointestatario>;
    /**
     * se true indica che l\'utente loggato è il primo intestatario del dossier. Se non ci sono cointestatari implica che l\'utente loggato è il primo intestatario
     * @type {boolean}
     * @memberof DossierItem
     */
    'utenteIsPrimoIntestatario'?: boolean;
    /**
     * 
     * @type {Array<SottoDossier>}
     * @memberof DossierItem
     */
    'sottoDossier'?: Array<SottoDossier>;
}
/**
 * 
 * @export
 * @interface DtaAccount
 */
export interface DtaAccount {
    /**
     * 
     * @type {DtaContact}
     * @memberof DtaAccount
     */
    'contact': DtaContact;
    /**
     * 
     * @type {DtaTrustCompany}
     * @memberof DtaAccount
     */
    'trustCompany': DtaTrustCompany;
    /**
     * 
     * @type {DtaActingPerson}
     * @memberof DtaAccount
     */
    'actingPerson': DtaActingPerson;
    /**
     * Code of the address book the login is bound to.
     * @type {string}
     * @memberof DtaAccount
     */
    'addressBook': string;
    /**
     * Generated login username, FDN plus six digits.
     * @type {string}
     * @memberof DtaAccount
     */
    'username': string;
    /**
     * Temporary password shown to the operator once. It is not stored.
     * @type {string}
     * @memberof DtaAccount
     */
    'temporaryPassword': string;
}
/**
 * The direct trust account could not be opened.
 * @export
 * @interface DtaAccountError
 */
export interface DtaAccountError {
    /**
     * 
     * @type {Array<string>}
     * @memberof DtaAccountError
     */
    'campiNonValidi'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DtaAccountError
     */
    'codiciErrore'?: Array<DtaAccountErrorCodiciErroreEnum>;
}

export const DtaAccountErrorCodiciErroreEnum = {
    EmailAlreadyInUse: 'EMAIL_ALREADY_IN_USE'
} as const;

export type DtaAccountErrorCodiciErroreEnum = typeof DtaAccountErrorCodiciErroreEnum[keyof typeof DtaAccountErrorCodiciErroreEnum];

/**
 * 
 * @export
 * @interface DtaAccountRequest
 */
export interface DtaAccountRequest {
    /**
     * 
     * @type {DtaContact}
     * @memberof DtaAccountRequest
     */
    'contact': DtaContact;
    /**
     * 
     * @type {DtaTrustCompany}
     * @memberof DtaAccountRequest
     */
    'trustCompany': DtaTrustCompany;
    /**
     * 
     * @type {DtaActingPerson}
     * @memberof DtaAccountRequest
     */
    'actingPerson': DtaActingPerson;
    /**
     * Code of the address book the login is bound to.
     * @type {string}
     * @memberof DtaAccountRequest
     */
    'addressBook': string;
}
/**
 * 
 * @export
 * @interface DtaAccountResponse
 */
export interface DtaAccountResponse {
    /**
     * 
     * @type {DtaAccount}
     * @memberof DtaAccountResponse
     */
    'data': DtaAccount;
}
/**
 * 
 * @export
 * @interface DtaAccountSearchCriterion
 */
export interface DtaAccountSearchCriterion {
    /**
     * NAME, SURNAME, COMPANY_NAME, LEGAL_ENTITY_CODE, CODICE_FISCALE, ACTING_PERSON_CODICE_FISCALE, ADDRESS_BOOK, or PARTITA_IVA. 
     * @type {string}
     * @memberof DtaAccountSearchCriterion
     */
    'scheme': string;
    /**
     * Text to match. NAME, SURNAME, and COMPANY_NAME need at least 2 characters.
     * @type {string}
     * @memberof DtaAccountSearchCriterion
     */
    'value': string;
}
/**
 * The page to return. paginaCorrente starts at 1.
 * @export
 * @interface DtaAccountSearchPagination
 */
export interface DtaAccountSearchPagination {
    /**
     * Page to return, starting at 1.
     * @type {number}
     * @memberof DtaAccountSearchPagination
     */
    'paginaCorrente'?: number;
    /**
     * Number of accounts on the page.
     * @type {number}
     * @memberof DtaAccountSearchPagination
     */
    'elementiPerPagina'?: number;
}
/**
 * 
 * @export
 * @interface DtaAccountSearchRequest
 */
export interface DtaAccountSearchRequest {
    /**
     * Filters combined with AND. Empty returns every account.
     * @type {Array<DtaAccountSearchCriterion>}
     * @memberof DtaAccountSearchRequest
     */
    'criteria'?: Array<DtaAccountSearchCriterion>;
    /**
     * 
     * @type {DtaAccountSearchPagination}
     * @memberof DtaAccountSearchRequest
     */
    'pagination'?: DtaAccountSearchPagination;
}
/**
 * 
 * @export
 * @interface DtaAccountSearchResponse
 */
export interface DtaAccountSearchResponse {
    /**
     * 
     * @type {Array<DtaListedAccount>}
     * @memberof DtaAccountSearchResponse
     */
    'data': Array<DtaListedAccount>;
    /**
     * 
     * @type {InfoDiPaginazione}
     * @memberof DtaAccountSearchResponse
     */
    'pagination': InfoDiPaginazione;
}
/**
 * 
 * @export
 * @interface DtaActingPerson
 */
export interface DtaActingPerson {
    /**
     * Name of the acting person.
     * @type {string}
     * @memberof DtaActingPerson
     */
    'name': string;
    /**
     * Surname of the acting person.
     * @type {string}
     * @memberof DtaActingPerson
     */
    'surname': string;
    /**
     * Codice Fiscale of the acting person.
     * @type {string}
     * @memberof DtaActingPerson
     */
    'codiceFiscale': string;
}
/**
 * 
 * @export
 * @interface DtaContact
 */
export interface DtaContact {
    /**
     * Email of the acting person.
     * @type {string}
     * @memberof DtaContact
     */
    'email': string;
    /**
     * Phone number of the acting person.
     * @type {string}
     * @memberof DtaContact
     */
    'phone': string;
}
/**
 * A direct trust account that exists. The temporary password is not included.
 * @export
 * @interface DtaListedAccount
 */
export interface DtaListedAccount {
    /**
     * Login username, FDN plus six digits.
     * @type {string}
     * @memberof DtaListedAccount
     */
    'username': string;
    /**
     * 
     * @type {DtaContact}
     * @memberof DtaListedAccount
     */
    'contact': DtaContact;
    /**
     * 
     * @type {DtaTrustCompany}
     * @memberof DtaListedAccount
     */
    'trustCompany': DtaTrustCompany;
    /**
     * 
     * @type {DtaActingPerson}
     * @memberof DtaListedAccount
     */
    'actingPerson': DtaActingPerson;
    /**
     * Code of the address book the login is bound to.
     * @type {string}
     * @memberof DtaListedAccount
     */
    'addressBook': string;
}
/**
 * Trust company. Exactly one of partitaIva and codiceFiscale is required.
 * @export
 * @interface DtaTrustCompany
 */
export interface DtaTrustCompany {
    /**
     * Code of the trust company.
     * @type {string}
     * @memberof DtaTrustCompany
     */
    'code': string;
    /**
     * Company name of the trust company.
     * @type {string}
     * @memberof DtaTrustCompany
     */
    'name': string;
    /**
     * Four-digit agent.
     * @type {string}
     * @memberof DtaTrustCompany
     */
    'agent': string;
    /**
     * Italian VAT number of the trust company.
     * @type {string}
     * @memberof DtaTrustCompany
     */
    'partitaIva'?: string;
    /**
     * Fiscal code of the trust company.
     * @type {string}
     * @memberof DtaTrustCompany
     */
    'codiceFiscale'?: string;
}
/**
 * 
 * @export
 * @interface EconomiaReale
 */
export interface EconomiaReale {
    /**
     * 
     * @type {Array<CategoriaEconomiaReale>}
     * @memberof EconomiaReale
     */
    'categorie'?: Array<CategoriaEconomiaReale>;
    /**
     * 
     * @type {Importo}
     * @memberof EconomiaReale
     */
    'totale'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof EconomiaReale
     */
    'commitment'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof EconomiaReale
     */
    'quoteEmissione'?: Importo;
}
/**
 * 
 * @export
 * @interface EcrCompany
 */
export interface EcrCompany {
    /**
     * 
     * @type {string}
     * @memberof EcrCompany
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EcrCompany
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EcrCompany
     */
    'attachmentUrl'?: string;
}
/**
 * 
 * @export
 * @interface EcrProduct
 */
export interface EcrProduct {
    /**
     * 
     * @type {string}
     * @memberof EcrProduct
     */
    'code'?: string;
    /**
     * 
     * @type {Array<EcrCompany>}
     * @memberof EcrProduct
     */
    'companies'?: Array<EcrCompany>;
}
/**
 * Il singolo elemento della tabella Performance
 * @export
 * @interface ElementoPerformance
 */
export interface ElementoPerformance {
    /**
     * 
     * @type {string}
     * @memberof ElementoPerformance
     */
    'descrizioneProdotto'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ElementoPerformance
     */
    'prodottoOggettoDiFusione'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ElementoPerformance
     */
    'tipoProdotto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ElementoPerformance
     */
    'contratto'?: string;
    /**
     * 
     * @type {number}
     * @memberof ElementoPerformance
     */
    'investito'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElementoPerformance
     */
    'switchIn'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElementoPerformance
     */
    'prelevato'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElementoPerformance
     */
    'dividendi'?: number;
    /**
     * Somma di prelevato e dividendi, espressa come flusso negativo. Null solo quando entrambi i valori sorgente sono null.
     * @type {number}
     * @memberof ElementoPerformance
     */
    'prelevatoEDividendi'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElementoPerformance
     */
    'switchOut'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElementoPerformance
     */
    'giacenzaMedia'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElementoPerformance
     */
    'importo'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElementoPerformance
     */
    'plusMinus'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElementoPerformance
     */
    'rendimento'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ElementoPerformance
     */
    'isFiaMultirichiamo'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementoPerformance
     */
    'isMergingFund'?: boolean;
}
/**
 * 
 * @export
 * @interface Email
 */
export interface Email {
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ErrorCallbackDetails
 */
export interface ErrorCallbackDetails {
    /**
     * 
     * @type {number}
     * @memberof ErrorCallbackDetails
     */
    'http_code'?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorCallbackDetails
     */
    'error_code'?: string;
    /**
     * 
     * @type {any}
     * @memberof ErrorCallbackDetails
     */
    'message_error'?: any;
    /**
     * 
     * @type {any}
     * @memberof ErrorCallbackDetails
     */
    'more_info'?: any;
}
/**
 * Dati dell\'utente
 * @export
 * @interface FiguraAccessoria
 */
export interface FiguraAccessoria {
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'nome'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'cognome'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'cellulare'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'codRuolo'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'codiceFiscale'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'dataNascita'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'comuneNascita'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'provinciaNascita'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'nazioneNascita'?: string;
    /**
     * 
     * @type {IndirizzoNFE}
     * @memberof FiguraAccessoria
     */
    'residenza'?: IndirizzoNFE;
    /**
     * 
     * @type {Documento}
     * @memberof FiguraAccessoria
     */
    'documento'?: Documento;
}
/**
 * 
 * @export
 * @interface Gestito
 */
export interface Gestito {
    /**
     * 
     * @type {Array<CategoriaGestito>}
     * @memberof Gestito
     */
    'categorie'?: Array<CategoriaGestito>;
    /**
     * 
     * @type {Importo}
     * @memberof Gestito
     */
    'totale'?: Importo;
}
/**
 * Status of DIY onboarding activities
 * @export
 * @interface GetTasksResponse
 */
export interface GetTasksResponse {
    /**
     * 
     * @type {Status}
     * @memberof GetTasksResponse
     */
    'status': Status;
    /**
     * Status of the AML/FATCA/CRS questionnaire
     * @type {string}
     * @memberof GetTasksResponse
     */
    'amlAndFatcaCrsState': GetTasksResponseAmlAndFatcaCrsStateEnum;
    /**
     * Status of the MiFID questionnaire
     * @type {string}
     * @memberof GetTasksResponse
     */
    'mifidState': GetTasksResponseMifidStateEnum;
    /**
     * 
     * @type {SpecimenState}
     * @memberof GetTasksResponse
     */
    'specimenState': SpecimenState;
}

export const GetTasksResponseAmlAndFatcaCrsStateEnum = {
    Completed: 'Completed',
    ToComplete: 'ToComplete',
    NotFillable: 'NotFillable'
} as const;

export type GetTasksResponseAmlAndFatcaCrsStateEnum = typeof GetTasksResponseAmlAndFatcaCrsStateEnum[keyof typeof GetTasksResponseAmlAndFatcaCrsStateEnum];
export const GetTasksResponseMifidStateEnum = {
    Completed: 'Completed',
    ToComplete: 'ToComplete',
    NotFillable: 'NotFillable'
} as const;

export type GetTasksResponseMifidStateEnum = typeof GetTasksResponseMifidStateEnum[keyof typeof GetTasksResponseMifidStateEnum];

/**
 * 
 * @export
 * @interface Importo
 */
export interface Importo {
    /**
     * 
     * @type {number}
     * @memberof Importo
     */
    'valore'?: number;
    /**
     * 
     * @type {string}
     * @memberof Importo
     */
    'divisa'?: string;
}
/**
 * 
 * @export
 * @interface IndirizzoNFE
 */
export interface IndirizzoNFE {
    /**
     * 
     * @type {string}
     * @memberof IndirizzoNFE
     */
    'codNazione'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndirizzoNFE
     */
    'codProvincia'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndirizzoNFE
     */
    'cap'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndirizzoNFE
     */
    'indirizzo'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndirizzoNFE
     */
    'desLocalita'?: string;
}
/**
 * Informazioni di paginazione
 * @export
 * @interface InfoDiPaginazione
 */
export interface InfoDiPaginazione {
    /**
     * La pagina attualmente restituita nella risposta
     * @type {number}
     * @memberof InfoDiPaginazione
     */
    'paginaCorrente'?: number;
    /**
     * Il numero di pagine totali disponibili
     * @type {number}
     * @memberof InfoDiPaginazione
     */
    'pagineTotali'?: number;
    /**
     * Il numero di elementi restituiti per singola pagina
     * @type {number}
     * @memberof InfoDiPaginazione
     */
    'elementiPerPagina'?: number;
}
/**
 * Wrapper delle liste di movimenti e sottostanti (info necessarie per generare il nome dei file da salvare lato client)
 * @export
 * @interface InfoProdotto
 */
export interface InfoProdotto {
    /**
     * 
     * @type {string}
     * @memberof InfoProdotto
     */
    'societaProdotto'?: string;
    /**
     * 
     * @type {string}
     * @memberof InfoProdotto
     */
    'prodottoGruppo'?: string;
    /**
     * 
     * @type {string}
     * @memberof InfoProdotto
     */
    'sottoprodotto'?: string;
    /**
     * 
     * @type {string}
     * @memberof InfoProdotto
     */
    'isin'?: string;
    /**
     * 
     * @type {string}
     * @memberof InfoProdotto
     */
    'codiceRP'?: string;
    /**
     * 
     * @type {string}
     * @memberof InfoProdotto
     */
    'valuta'?: string;
    /**
     * 
     * @type {string}
     * @memberof InfoProdotto
     */
    'codiceContratto'?: string;
    /**
     * 
     * @type {string}
     * @memberof InfoProdotto
     */
    'codiceDossier'?: string;
}
/**
 * codice cliente della figura accessoria se PersonaGiuridica
 * @export
 * @interface LegaleRappresentante
 */
export interface LegaleRappresentante {
    /**
     * 
     * @type {string}
     * @memberof LegaleRappresentante
     */
    'codiceClienteRappresentante'?: string;
}
/**
 * 
 * @export
 * @interface Liquidita
 */
export interface Liquidita {
    /**
     * 
     * @type {Array<CategoriaLiquidita>}
     * @memberof Liquidita
     */
    'categorie'?: Array<CategoriaLiquidita>;
    /**
     * 
     * @type {Importo}
     * @memberof Liquidita
     */
    'totale'?: Importo;
}
/**
 * 
 * @export
 * @interface LoginError
 */
export interface LoginError {
    /**
     * 
     * @type {Array<string>}
     * @memberof LoginError
     */
    'campiNonValidi'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LoginError
     */
    'codiciErrore'?: Array<LoginErrorCodiciErroreEnum>;
}

export const LoginErrorCodiciErroreEnum = {
    CredenzialiNonValide: 'CREDENZIALI_NON_VALIDE',
    PasswordErrata: 'PASSWORD_ERRATA',
    CodiceUtenteErrato: 'CODICE_UTENTE_ERRATO',
    PasswordVecchiaNonValida: 'PASSWORD_VECCHIA_NON_VALIDA',
    UtenzaBloccata: 'UTENZA_BLOCCATA',
    UtenzaNonMigrata: 'UTENZA_NON_MIGRATA',
    CampiRichiesti: 'CAMPI_RICHIESTI',
    TroppiTentativi: 'TROPPI_TENTATIVI'
} as const;

export type LoginErrorCodiciErroreEnum = typeof LoginErrorCodiciErroreEnum[keyof typeof LoginErrorCodiciErroreEnum];

/**
 * 
 * @export
 * @interface LoginErrorAllOf
 */
export interface LoginErrorAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof LoginErrorAllOf
     */
    'codiciErrore'?: Array<LoginErrorAllOfCodiciErroreEnum>;
}

export const LoginErrorAllOfCodiciErroreEnum = {
    CredenzialiNonValide: 'CREDENZIALI_NON_VALIDE',
    PasswordErrata: 'PASSWORD_ERRATA',
    CodiceUtenteErrato: 'CODICE_UTENTE_ERRATO',
    PasswordVecchiaNonValida: 'PASSWORD_VECCHIA_NON_VALIDA',
    UtenzaBloccata: 'UTENZA_BLOCCATA',
    UtenzaNonMigrata: 'UTENZA_NON_MIGRATA',
    CampiRichiesti: 'CAMPI_RICHIESTI',
    TroppiTentativi: 'TROPPI_TENTATIVI'
} as const;

export type LoginErrorAllOfCodiciErroreEnum = typeof LoginErrorAllOfCodiciErroreEnum[keyof typeof LoginErrorAllOfCodiciErroreEnum];

/**
 * 
 * @export
 * @interface LoginMessage
 */
export interface LoginMessage {
    /**
     * 
     * @type {string}
     * @memberof LoginMessage
     */
    'severity'?: LoginMessageSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof LoginMessage
     */
    'message'?: string;
}

export const LoginMessageSeverityEnum = {
    Info: 'INFO',
    Warning: 'WARNING'
} as const;

export type LoginMessageSeverityEnum = typeof LoginMessageSeverityEnum[keyof typeof LoginMessageSeverityEnum];

/**
 * 
 * @export
 * @interface Logout200Response
 */
export interface Logout200Response {
    /**
     * 
     * @type {boolean}
     * @memberof Logout200Response
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface LogoutError
 */
export interface LogoutError {
    /**
     * 
     * @type {Array<string>}
     * @memberof LogoutError
     */
    'campiNonValidi'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LogoutError
     */
    'codiciErrore'?: Array<LogoutErrorCodiciErroreEnum>;
}

export const LogoutErrorCodiciErroreEnum = {
    LogoutFailed: 'LOGOUT_FAILED'
} as const;

export type LogoutErrorCodiciErroreEnum = typeof LogoutErrorCodiciErroreEnum[keyof typeof LogoutErrorCodiciErroreEnum];

/**
 * 
 * @export
 * @interface LogoutErrorAllOf
 */
export interface LogoutErrorAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof LogoutErrorAllOf
     */
    'codiciErrore'?: Array<LogoutErrorAllOfCodiciErroreEnum>;
}

export const LogoutErrorAllOfCodiciErroreEnum = {
    LogoutFailed: 'LOGOUT_FAILED'
} as const;

export type LogoutErrorAllOfCodiciErroreEnum = typeof LogoutErrorAllOfCodiciErroreEnum[keyof typeof LogoutErrorAllOfCodiciErroreEnum];

/**
 * 
 * @export
 * @interface MacroCategorie
 */
export interface MacroCategorie {
    /**
     * 
     * @type {Gestito}
     * @memberof MacroCategorie
     */
    'gestito'?: Gestito;
    /**
     * 
     * @type {EconomiaReale}
     * @memberof MacroCategorie
     */
    'economiaReale'?: EconomiaReale;
    /**
     * 
     * @type {AssicurativoFinanziario}
     * @memberof MacroCategorie
     */
    'assicurativoFinanziario'?: AssicurativoFinanziario;
    /**
     * 
     * @type {Previdenza}
     * @memberof MacroCategorie
     */
    'previdenza'?: Previdenza;
    /**
     * 
     * @type {AssicurativoTradizionale}
     * @memberof MacroCategorie
     */
    'assicurativoTradizionale'?: AssicurativoTradizionale;
    /**
     * 
     * @type {Amministrativo}
     * @memberof MacroCategorie
     */
    'amministrativo'?: Amministrativo;
    /**
     * 
     * @type {Liquidita}
     * @memberof MacroCategorie
     */
    'liquidita'?: Liquidita;
    /**
     * 
     * @type {TotalFia}
     * @memberof MacroCategorie
     */
    'totalFia'?: TotalFia;
    /**
     * 
     * @type {TotalePortafoglio}
     * @memberof MacroCategorie
     */
    'totalePortafoglio'?: TotalePortafoglio;
}
/**
 * 
 * @export
 * @interface MacroProdottoEconomiaReale
 */
export interface MacroProdottoEconomiaReale {
    /**
     * 
     * @type {string}
     * @memberof MacroProdottoEconomiaReale
     */
    'nome'?: string;
    /**
     * 
     * @type {Array<ProdottoEconomiaReale>}
     * @memberof MacroProdottoEconomiaReale
     */
    'prodotti'?: Array<ProdottoEconomiaReale>;
    /**
     * 
     * @type {Importo}
     * @memberof MacroProdottoEconomiaReale
     */
    'totale'?: Importo;
}
/**
 * 
 * @export
 * @interface MacroProdottoGestito
 */
export interface MacroProdottoGestito {
    /**
     * 
     * @type {string}
     * @memberof MacroProdottoGestito
     */
    'nome'?: string;
    /**
     * 
     * @type {Array<ProdottoGestito>}
     * @memberof MacroProdottoGestito
     */
    'prodotti'?: Array<ProdottoGestito>;
    /**
     * 
     * @type {Importo}
     * @memberof MacroProdottoGestito
     */
    'totale'?: Importo;
}
/**
 * 
 * @export
 * @interface MarketplaceBaseRequest
 */
export interface MarketplaceBaseRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceBaseRequest
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface MifidPrecompile
 */
export interface MifidPrecompile {
    /**
     * Indica se ci sono dati precompilati da AML
     * @type {boolean}
     * @memberof MifidPrecompile
     */
    'precompilato'?: boolean;
    /**
     * 
     * @type {Array<ResponseMifidPrecompile>}
     * @memberof MifidPrecompile
     */
    'risposte'?: Array<ResponseMifidPrecompile>;
}
/**
 * Movimento di un prodotto
 * @export
 * @interface MovimentoProdotto
 */
export interface MovimentoProdotto {
    /**
     * 
     * @type {string}
     * @memberof MovimentoProdotto
     */
    'dataOperazione'?: string;
    /**
     * 
     * @type {string}
     * @memberof MovimentoProdotto
     */
    'dataRegolamento'?: string;
    /**
     * 
     * @type {string}
     * @memberof MovimentoProdotto
     */
    'dataValuta'?: string;
    /**
     * 
     * @type {string}
     * @memberof MovimentoProdotto
     */
    'categoria'?: string;
    /**
     * 
     * @type {string}
     * @memberof MovimentoProdotto
     */
    'causale'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof MovimentoProdotto
     */
    'importoRegolato'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof MovimentoProdotto
     */
    'commissioni'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof MovimentoProdotto
     */
    'spese'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof MovimentoProdotto
     */
    'bolli'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof MovimentoProdotto
     */
    'controvalore'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof MovimentoProdotto
     */
    'quantita'?: number;
    /**
     * 
     * @type {Importo}
     * @memberof MovimentoProdotto
     */
    'prezzo'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof MovimentoProdotto
     */
    'cambio'?: number;
    /**
     * 
     * @type {Importo}
     * @memberof MovimentoProdotto
     */
    'prezzoDivisa'?: Importo;
    /**
     * 
     * @type {string}
     * @memberof MovimentoProdotto
     */
    'dataCambio'?: string;
}
/**
 * Payload utilizzato per la notifica di lettura dei documenti
 * @export
 * @interface NotificaLetturaRequest
 */
export interface NotificaLetturaRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificaLetturaRequest
     */
    'documentId': string;
}
/**
 * oggetto risultante
 * @export
 * @interface OrdineRto
 */
export interface OrdineRto {
    /**
     * customer code
     * @type {string}
     * @memberof OrdineRto
     */
    'codiceCliente'?: string;
    /**
     * customer nominative
     * @type {string}
     * @memberof OrdineRto
     */
    'nominativoCliente'?: string;
    /**
     * complexity
     * @type {string}
     * @memberof OrdineRto
     */
    'complessita'?: string;
    /**
     * bailIn
     * @type {string}
     * @memberof OrdineRto
     */
    'bailIn'?: string;
    /**
     * illiquidity
     * @type {string}
     * @memberof OrdineRto
     */
    'illiquidity'?: string;
    /**
     * flag appropriate
     * @type {boolean}
     * @memberof OrdineRto
     */
    'flagAppropriato'?: boolean;
    /**
     * flag conflict of interest
     * @type {boolean}
     * @memberof OrdineRto
     */
    'flagConflittoInteresse'?: boolean;
    /**
     * isin code
     * @type {string}
     * @memberof OrdineRto
     */
    'isin'?: string;
    /**
     * product name
     * @type {string}
     * @memberof OrdineRto
     */
    'nomeProdotto'?: string;
    /**
     * product type
     * @type {string}
     * @memberof OrdineRto
     */
    'tipoProdotto'?: string;
    /**
     * quantity
     * @type {number}
     * @memberof OrdineRto
     */
    'quantita'?: number;
    /**
     * price limit
     * @type {number}
     * @memberof OrdineRto
     */
    'limitePrezzo'?: number;
    /**
     * price mode
     * @type {string}
     * @memberof OrdineRto
     */
    'parametroPrezzo'?: string;
    /**
     * validity
     * @type {string}
     * @memberof OrdineRto
     */
    'parametroTempo'?: string;
}
/**
 * Tabella delle Performance
 * @export
 * @interface Performance
 */
export interface Performance {
    /**
     * 
     * @type {Importo}
     * @memberof Performance
     */
    'totaleImporto'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof Performance
     */
    'totaleRendimento'?: number;
    /**
     * 
     * @type {Array<ElementoPerformance>}
     * @memberof Performance
     */
    'elementi'?: Array<ElementoPerformance>;
}
/**
 * Contiene i campi comuni a PersonaFisica e PersonaGiuridica
 * @export
 * @interface Persona
 */
export interface Persona {
    /**
     * Indica se persona fisica o persona giuridica. Da mantenere a causa di bug sul generatore Java
     * @type {string}
     * @memberof Persona
     */
    'tipo': PersonaTipoEnum;
    /**
     * Indica se persona fisica o persona giuridica. Da mantenere a causa di bug sul generatore Java
     * @type {string}
     * @memberof Persona
     */
    'tipoUtente'?: PersonaTipoUtenteEnum;
    /**
     * Identificativo dell\'utente
     * @type {string}
     * @memberof Persona
     */
    'codiceUtente'?: string;
    /**
     * Identificativo del cliente
     * @type {string}
     * @memberof Persona
     */
    'codiceCliente'?: string;
    /**
     * 
     * @type {string}
     * @memberof Persona
     */
    'nome'?: string;
    /**
     * 
     * @type {string}
     * @memberof Persona
     */
    'cognome'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Persona
     */
    'definitivo'?: boolean;
}

export const PersonaTipoEnum = {
    Pf: 'PF',
    Pg: 'PG'
} as const;

export type PersonaTipoEnum = typeof PersonaTipoEnum[keyof typeof PersonaTipoEnum];
export const PersonaTipoUtenteEnum = {
    Pf: 'PF',
    Pg: 'PG'
} as const;

export type PersonaTipoUtenteEnum = typeof PersonaTipoUtenteEnum[keyof typeof PersonaTipoUtenteEnum];

/**
 * 
 * @export
 * @interface PersonaFisica
 */
export interface PersonaFisica extends Persona {
    /**
     * Codice Fiscale
     * @type {string}
     * @memberof PersonaFisica
     */
    'codiceFiscale'?: string;
}


/**
 * 
 * @export
 * @interface PersonaFisicaAllOf
 */
export interface PersonaFisicaAllOf {
    /**
     * Codice Fiscale
     * @type {string}
     * @memberof PersonaFisicaAllOf
     */
    'codiceFiscale'?: string;
}
/**
 * 
 * @export
 * @interface PersonaGiuridica
 */
export interface PersonaGiuridica extends Persona {
    /**
     * Partita IVA o Codice Fiscale della persona giuridica
     * @type {string}
     * @memberof PersonaGiuridica
     */
    'partitaIva'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonaGiuridica
     */
    'codiceFiscaleRappresentante'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PersonaGiuridica
     */
    'fiduciaria'?: boolean;
}


/**
 * 
 * @export
 * @interface PersonaGiuridicaAllOf
 */
export interface PersonaGiuridicaAllOf {
    /**
     * Partita IVA o Codice Fiscale della persona giuridica
     * @type {string}
     * @memberof PersonaGiuridicaAllOf
     */
    'partitaIva'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonaGiuridicaAllOf
     */
    'codiceFiscaleRappresentante'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PersonaGiuridicaAllOf
     */
    'fiduciaria'?: boolean;
}
/**
 * Dati dell\'azienda
 * @export
 * @interface PersonaGiuridicaMkt
 */
export interface PersonaGiuridicaMkt {
    /**
     * 
     * @type {string}
     * @memberof PersonaGiuridicaMkt
     */
    'denominazione'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonaGiuridicaMkt
     */
    'pIva'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonaGiuridicaMkt
     */
    'codSpecieGiuridica'?: string;
    /**
     * 
     * @type {IndirizzoNFE}
     * @memberof PersonaGiuridicaMkt
     */
    'residenza'?: IndirizzoNFE;
    /**
     * 
     * @type {Costituzione}
     * @memberof PersonaGiuridicaMkt
     */
    'costituzione'?: Costituzione;
}
/**
 * Portafoglio
 * @export
 * @interface Portafoglio
 */
export interface Portafoglio {
    /**
     * 
     * @type {MacroCategorie}
     * @memberof Portafoglio
     */
    'elencoPosizioni'?: MacroCategorie;
    /**
     * 
     * @type {PortfolioSummary}
     * @memberof Portafoglio
     */
    'summary'?: PortfolioSummary;
}
/**
 * Payload utilizzato per la richiesta del portafoglio
 * @export
 * @interface PortafoglioRequest
 */
export interface PortafoglioRequest {
    /**
     * Periodo per il quale eseguire la query
     * @type {string}
     * @memberof PortafoglioRequest
     */
    'periodo'?: PortafoglioRequestPeriodoEnum;
    /**
     * Estremo sinistro dell\'intervallo temporale custom se il parametro periodo=INTERVALLO
     * @type {string}
     * @memberof PortafoglioRequest
     */
    'dal'?: string;
    /**
     * Estremo destro dell\'intervallo temporale custom se il parametro periodo=INTERVALLO
     * @type {string}
     * @memberof PortafoglioRequest
     */
    'al'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortafoglioRequest
     */
    'dossier'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortafoglioRequest
     */
    'contratti'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PortafoglioRequest
     */
    'cointestati'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortafoglioRequest
     */
    'posizioniChiuse'?: boolean;
}

export const PortafoglioRequestPeriodoEnum = {
    DaInizioAnno: 'DA_INIZIO_ANNO',
    UltimoAnno: 'ULTIMO_ANNO',
    DaApertura: 'DA_APERTURA',
    Intervallo: 'INTERVALLO'
} as const;

export type PortafoglioRequestPeriodoEnum = typeof PortafoglioRequestPeriodoEnum[keyof typeof PortafoglioRequestPeriodoEnum];

/**
 * I valori delle card in Portfolio Summary
 * @export
 * @interface PortfolioSummary
 */
export interface PortfolioSummary {
    /**
     * 
     * @type {Importo}
     * @memberof PortfolioSummary
     */
    'totalePortafoglio'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof PortfolioSummary
     */
    'totaleComplessivoPortafoglio'?: Importo;
    /**
     * 
     * @type {PortfolioSummaryItem}
     * @memberof PortfolioSummary
     */
    'gestitoAssFin'?: PortfolioSummaryItem;
    /**
     * 
     * @type {PortfolioSummaryItem}
     * @memberof PortfolioSummary
     */
    'economiaReale'?: PortfolioSummaryItem;
    /**
     * 
     * @type {PortfolioSummaryItem}
     * @memberof PortfolioSummary
     */
    'previdenza'?: PortfolioSummaryItem;
    /**
     * 
     * @type {PortfolioSummaryItem}
     * @memberof PortfolioSummary
     */
    'amministrato'?: PortfolioSummaryItem;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSummary
     */
    'liquidita'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSummary
     */
    'totalFia'?: number;
    /**
     * 
     * @type {Importo}
     * @memberof PortfolioSummary
     */
    'totaleRichiamiInAttesa'?: Importo;
}
/**
 * Il singolo item tra le card del Portfolio Summary
 * @export
 * @interface PortfolioSummaryItem
 */
export interface PortfolioSummaryItem {
    /**
     * 
     * @type {Importo}
     * @memberof PortfolioSummaryItem
     */
    'controvalore'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSummaryItem
     */
    'rendimentoPercentuale'?: number;
}
/**
 * 
 * @export
 * @interface PreparaCambioContatto
 */
export interface PreparaCambioContatto {
    /**
     * 
     * @type {string}
     * @memberof PreparaCambioContatto
     */
    'contatto'?: string;
    /**
     * 
     * @type {string}
     * @memberof PreparaCambioContatto
     */
    'vecchio_contatto'?: string;
    /**
     * 
     * @type {string}
     * @memberof PreparaCambioContatto
     */
    'tipo_contatto'?: PreparaCambioContattoTipoContattoEnum;
}

export const PreparaCambioContattoTipoContattoEnum = {
    Email: 'EMAIL',
    Phone: 'PHONE'
} as const;

export type PreparaCambioContattoTipoContattoEnum = typeof PreparaCambioContattoTipoContattoEnum[keyof typeof PreparaCambioContattoTipoContattoEnum];

/**
 * Restituisce un messaggio di conferma se l\'operazione ha avuto successo
 * @export
 * @interface PreparaCambioContattoResponse
 */
export interface PreparaCambioContattoResponse {
    /**
     * 
     * @type {string}
     * @memberof PreparaCambioContattoResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface Previdenza
 */
export interface Previdenza {
    /**
     * 
     * @type {Array<CategoriaPrevidenza>}
     * @memberof Previdenza
     */
    'categorie'?: Array<CategoriaPrevidenza>;
    /**
     * 
     * @type {Importo}
     * @memberof Previdenza
     */
    'totale'?: Importo;
}
/**
 * Token contenente **soltanto** l\'access token (schema HTTP Bearer)
 * @export
 * @interface PrevinetAccessToken
 */
export interface PrevinetAccessToken {
    /**
     * Access token, claims criptati con algoritmo ES512
     * @type {string}
     * @memberof PrevinetAccessToken
     */
    'accessToken'?: string;
}
/**
 * 
 * @export
 * @interface ProdottoAmministrativo
 */
export interface ProdottoAmministrativo {
    /**
     * 
     * @type {string}
     * @memberof ProdottoAmministrativo
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoAmministrativo
     */
    'prodotto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoAmministrativo
     */
    'contratto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoAmministrativo
     */
    'suppCompanyRefNum'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProdottoAmministrativo
     */
    'quantita'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProdottoAmministrativo
     */
    'divisa'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoAmministrativo
     */
    'valoreQuotaDivisa'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof ProdottoAmministrativo
     */
    'cambio'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProdottoAmministrativo
     */
    'isin'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoAmministrativo
     */
    'data'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoAmministrativo
     */
    'controvalore'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoAmministrativo
     */
    'rendimento'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof ProdottoAmministrativo
     */
    'rendimentoPercentuale'?: number;
    /**
     * Lista di cointestatari del dossier
     * @type {Array<string>}
     * @memberof ProdottoAmministrativo
     */
    'cointestatari'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoAmministrativo
     */
    'priips'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoAmministrativo
     */
    'esistenzaKid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProdottoAmministrativo
     */
    'rp'?: string;
}
/**
 * 
 * @export
 * @interface ProdottoAssicurativoTradizionale
 */
export interface ProdottoAssicurativoTradizionale {
    /**
     * 
     * @type {string}
     * @memberof ProdottoAssicurativoTradizionale
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoAssicurativoTradizionale
     */
    'prodotto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoAssicurativoTradizionale
     */
    'contratto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoAssicurativoTradizionale
     */
    'suppCompanyRefNum'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoAssicurativoTradizionale
     */
    'data'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoAssicurativoTradizionale
     */
    'isin'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoAssicurativoTradizionale
     */
    'totalePremiVersati'?: Importo;
    /**
     * Lista di cointestatari del dossier
     * @type {Array<string>}
     * @memberof ProdottoAssicurativoTradizionale
     */
    'cointestatari'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoAssicurativoTradizionale
     */
    'priips'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoAssicurativoTradizionale
     */
    'esistenzaKid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProdottoAssicurativoTradizionale
     */
    'rp'?: string;
}
/**
 * Prodotto che fa parte della macro categoria Economia Reale
 * @export
 * @interface ProdottoEconomiaReale
 */
export interface ProdottoEconomiaReale {
    /**
     * 
     * @type {string}
     * @memberof ProdottoEconomiaReale
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoEconomiaReale
     */
    'prodotto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoEconomiaReale
     */
    'isin'?: string;
    /**
     * Lista di cointestatari del dossier
     * @type {Array<string>}
     * @memberof ProdottoEconomiaReale
     */
    'cointestatari'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProdottoEconomiaReale
     */
    'contratto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoEconomiaReale
     */
    'suppCompanyRefNum'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoEconomiaReale
     */
    'commitment'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoEconomiaReale
     */
    'versatoAvvalorato'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoEconomiaReale
     */
    'versatoDaAvvalorare'?: Importo;
    /**
     * 
     * @type {string}
     * @memberof ProdottoEconomiaReale
     */
    'data'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoEconomiaReale
     */
    'controvalore'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoEconomiaReale
     */
    'proventi'?: Importo;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoEconomiaReale
     */
    'priips'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoEconomiaReale
     */
    'esistenzaKid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProdottoEconomiaReale
     */
    'rp'?: string;
}
/**
 * Prodotto che fa parte della macro categoria Gestito
 * @export
 * @interface ProdottoGestito
 */
export interface ProdottoGestito {
    /**
     * 
     * @type {string}
     * @memberof ProdottoGestito
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoGestito
     */
    'prodotto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoGestito
     */
    'isin'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoGestito
     */
    'contratto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoGestito
     */
    'suppCompanyRefNum'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProdottoGestito
     */
    'quantita'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProdottoGestito
     */
    'divisa'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoGestito
     */
    'prezzoMedioDiCarico'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof ProdottoGestito
     */
    'caricoMedioCambio'?: number;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoGestito
     */
    'valoreQuotaDivisa'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof ProdottoGestito
     */
    'cambio'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProdottoGestito
     */
    'data'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoGestito
     */
    'controvalore'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoGestito
     */
    'rendimentoValuta'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof ProdottoGestito
     */
    'rendimentoPercentuale'?: number;
    /**
     * se true bisogna mostrare il disclaimer in app
     * @type {boolean}
     * @memberof ProdottoGestito
     */
    'disclaimer'?: boolean;
    /**
     * Lista di cointestatari del dossier
     * @type {Array<string>}
     * @memberof ProdottoGestito
     */
    'cointestatari'?: Array<string>;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoGestito
     */
    'richiamiInAttesa'?: Importo;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoGestito
     */
    'priips'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoGestito
     */
    'esistenzaKid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProdottoGestito
     */
    'rp'?: string;
}
/**
 * 
 * @export
 * @interface ProdottoLiquidita
 */
export interface ProdottoLiquidita {
    /**
     * 
     * @type {string}
     * @memberof ProdottoLiquidita
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoLiquidita
     */
    'prodotto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoLiquidita
     */
    'isin'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoLiquidita
     */
    'contratto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoLiquidita
     */
    'suppCompanyRefNum'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoLiquidita
     */
    'saldoContabile'?: Importo;
    /**
     * 
     * @type {string}
     * @memberof ProdottoLiquidita
     */
    'dataSaldoContabile'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoLiquidita
     */
    'saldoLiquido'?: Importo;
    /**
     * 
     * @type {string}
     * @memberof ProdottoLiquidita
     */
    'dataSaldoLiquido'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoLiquidita
     */
    'saldoDisponibile'?: Importo;
    /**
     * 
     * @type {string}
     * @memberof ProdottoLiquidita
     */
    'dataSaldoDisponibile'?: string;
    /**
     * Lista di cointestatari del dossier
     * @type {Array<string>}
     * @memberof ProdottoLiquidita
     */
    'cointestatari'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoLiquidita
     */
    'priips'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoLiquidita
     */
    'esistenzaKid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProdottoLiquidita
     */
    'rp'?: string;
}
/**
 * 
 * @export
 * @interface ProdottoPolizzeTradizionaliRivalutate
 */
export interface ProdottoPolizzeTradizionaliRivalutate {
    /**
     * 
     * @type {string}
     * @memberof ProdottoPolizzeTradizionaliRivalutate
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoPolizzeTradizionaliRivalutate
     */
    'prodotto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoPolizzeTradizionaliRivalutate
     */
    'contratto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoPolizzeTradizionaliRivalutate
     */
    'suppCompanyRefNum'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoPolizzeTradizionaliRivalutate
     */
    'isin'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoPolizzeTradizionaliRivalutate
     */
    'codice'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoPolizzeTradizionaliRivalutate
     */
    'controvalore'?: Importo;
    /**
     * Lista di cointestatari del dossier
     * @type {Array<string>}
     * @memberof ProdottoPolizzeTradizionaliRivalutate
     */
    'cointestatari'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoPolizzeTradizionaliRivalutate
     */
    'priips'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoPolizzeTradizionaliRivalutate
     */
    'esistenzaKid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProdottoPolizzeTradizionaliRivalutate
     */
    'rp'?: string;
}
/**
 * 
 * @export
 * @interface ProdottoPrevidenza
 */
export interface ProdottoPrevidenza {
    /**
     * 
     * @type {string}
     * @memberof ProdottoPrevidenza
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoPrevidenza
     */
    'prodotto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoPrevidenza
     */
    'contratto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoPrevidenza
     */
    'suppCompanyRefNum'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoPrevidenza
     */
    'data'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoPrevidenza
     */
    'isin'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoPrevidenza
     */
    'controvalore'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoPrevidenza
     */
    'partiteViaggianti'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoPrevidenza
     */
    'saldoPosizione'?: Importo;
    /**
     * Lista di cointestatari del dossier
     * @type {Array<string>}
     * @memberof ProdottoPrevidenza
     */
    'cointestatari'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoPrevidenza
     */
    'priips'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoPrevidenza
     */
    'esistenzaKid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProdottoPrevidenza
     */
    'rp'?: string;
}
/**
 * 
 * @export
 * @interface ProdottoUnitLinked
 */
export interface ProdottoUnitLinked {
    /**
     * 
     * @type {string}
     * @memberof ProdottoUnitLinked
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoUnitLinked
     */
    'prodotto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoUnitLinked
     */
    'contratto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoUnitLinked
     */
    'suppCompanyRefNum'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoUnitLinked
     */
    'isin'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoUnitLinked
     */
    'data'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoUnitLinked
     */
    'controvalore'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoUnitLinked
     */
    'rendimento'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof ProdottoUnitLinked
     */
    'rendimentoPercentuale'?: number;
    /**
     * Lista di cointestatari del dossier
     * @type {Array<string>}
     * @memberof ProdottoUnitLinked
     */
    'cointestatari'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoUnitLinked
     */
    'priips'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoUnitLinked
     */
    'esistenzaKid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProdottoUnitLinked
     */
    'rp'?: string;
}
/**
 * 
 * @export
 * @interface ProdottoUnitLinkedPrezzo
 */
export interface ProdottoUnitLinkedPrezzo {
    /**
     * 
     * @type {string}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'prodotto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'contratto'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'suppCompanyRefNum'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'isin'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'quantita'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'divisa'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'prezzoMedioDiCarico'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'caricoMedioCambio'?: number;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'valoreQuotaDivisa'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'cambio'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'data'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'controvalore'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'rendimento'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'rendimentoPercentuale'?: number;
    /**
     * Lista di cointestatari del dossier
     * @type {Array<string>}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'cointestatari'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'priips'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'esistenzaKid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProdottoUnitLinkedPrezzo
     */
    'rp'?: string;
}
/**
 * 
 * @export
 * @interface QuestionnairesStatus
 */
export interface QuestionnairesStatus {
    /**
     * State of the AML and FACTA/CRS questionnaire
     * @type {string}
     * @memberof QuestionnairesStatus
     */
    'amlAndFactaCrsState'?: string;
    /**
     * State of the MiFID questionnaire
     * @type {string}
     * @memberof QuestionnairesStatus
     */
    'mifidState'?: string;
}
/**
 * 
 * @export
 * @interface RagioneSociale
 */
export interface RagioneSociale {
    /**
     * Nel caso di una persona giuridica contiene la ragione sociale per la quale è figura accessoria
     * @type {string}
     * @memberof RagioneSociale
     */
    'ragioneSociale'?: string;
}
/**
 * 
 * @export
 * @interface Recapiti
 */
export interface Recapiti extends Persona {
    /**
     * 
     * @type {string}
     * @memberof Recapiti
     */
    'email': string;
    /**
     * Phone number in international E.164 format (e.g. +393331234567, +447429310834).  Numbers with grouping spaces are also accepted (e.g. +39 320 123 4567); the  backend normalises to E.164 without spaces.
     * @type {string}
     * @memberof Recapiti
     */
    'cellulare': string;
    /**
     * Phone number in international E.164 format (e.g. +393331234567, +447429310834).  Numbers with grouping spaces are also accepted (e.g. +39 320 123 4567); the  backend normalises to E.164 without spaces.
     * @type {string}
     * @memberof Recapiti
     */
    'cellulareSecondario'?: string;
    /**
     * Codice Fiscale
     * @type {string}
     * @memberof Recapiti
     */
    'codiceFiscale'?: string;
}


/**
 * 
 * @export
 * @interface RecapitiAllOf
 */
export interface RecapitiAllOf {
    /**
     * Phone number in international E.164 format (e.g. +393331234567, +447429310834).  Numbers with grouping spaces are also accepted (e.g. +39 320 123 4567); the  backend normalises to E.164 without spaces.
     * @type {string}
     * @memberof RecapitiAllOf
     */
    'cellulareSecondario'?: string;
    /**
     * Codice Fiscale
     * @type {string}
     * @memberof RecapitiAllOf
     */
    'codiceFiscale'?: string;
}
/**
 * Payload utilizzato per il recupero delle credenziali da console di admin
 * @export
 * @interface RecuperoCredenzialiRequest
 */
export interface RecuperoCredenzialiRequest {
    /**
     * 
     * @type {string}
     * @memberof RecuperoCredenzialiRequest
     */
    'codiceUtente': string;
    /**
     * 
     * @type {string}
     * @memberof RecuperoCredenzialiRequest
     */
    'datoDaRecuperare': RecuperoCredenzialiRequestDatoDaRecuperareEnum;
    /**
     * 
     * @type {string}
     * @memberof RecuperoCredenzialiRequest
     */
    'canaleDiRecupero': RecuperoCredenzialiRequestCanaleDiRecuperoEnum;
}

export const RecuperoCredenzialiRequestDatoDaRecuperareEnum = {
    Password: 'password',
    CodiceUtente: 'codiceUtente'
} as const;

export type RecuperoCredenzialiRequestDatoDaRecuperareEnum = typeof RecuperoCredenzialiRequestDatoDaRecuperareEnum[keyof typeof RecuperoCredenzialiRequestDatoDaRecuperareEnum];
export const RecuperoCredenzialiRequestCanaleDiRecuperoEnum = {
    Email: 'email',
    Sms: 'sms'
} as const;

export type RecuperoCredenzialiRequestCanaleDiRecuperoEnum = typeof RecuperoCredenzialiRequestCanaleDiRecuperoEnum[keyof typeof RecuperoCredenzialiRequestCanaleDiRecuperoEnum];

/**
 * 
 * @export
 * @interface RecuperoPasswordError
 */
export interface RecuperoPasswordError {
    /**
     * 
     * @type {Array<string>}
     * @memberof RecuperoPasswordError
     */
    'campiNonValidi'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RecuperoPasswordError
     */
    'codiciErrore'?: Array<RecuperoPasswordErrorCodiciErroreEnum>;
}

export const RecuperoPasswordErrorCodiciErroreEnum = {
    UtenzaNonMigrata: 'UTENZA_NON_MIGRATA',
    CodiceUtenteErrato: 'CODICE_UTENTE_ERRATO',
    TroppiTentativi: 'TROPPI_TENTATIVI'
} as const;

export type RecuperoPasswordErrorCodiciErroreEnum = typeof RecuperoPasswordErrorCodiciErroreEnum[keyof typeof RecuperoPasswordErrorCodiciErroreEnum];

/**
 * 
 * @export
 * @interface RecuperoPasswordErrorAllOf
 */
export interface RecuperoPasswordErrorAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof RecuperoPasswordErrorAllOf
     */
    'codiciErrore'?: Array<RecuperoPasswordErrorAllOfCodiciErroreEnum>;
}

export const RecuperoPasswordErrorAllOfCodiciErroreEnum = {
    UtenzaNonMigrata: 'UTENZA_NON_MIGRATA',
    CodiceUtenteErrato: 'CODICE_UTENTE_ERRATO',
    TroppiTentativi: 'TROPPI_TENTATIVI'
} as const;

export type RecuperoPasswordErrorAllOfCodiciErroreEnum = typeof RecuperoPasswordErrorAllOfCodiciErroreEnum[keyof typeof RecuperoPasswordErrorAllOfCodiciErroreEnum];

/**
 * Payload utilizzato per il recupero della password
 * @export
 * @interface RecuperoPasswordRequest
 */
export interface RecuperoPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof RecuperoPasswordRequest
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecuperoPasswordRequest
     */
    'sendTo': RecuperoPasswordRequestSendToEnum;
}

export const RecuperoPasswordRequestSendToEnum = {
    Email: 'email',
    Sms: 'sms'
} as const;

export type RecuperoPasswordRequestSendToEnum = typeof RecuperoPasswordRequestSendToEnum[keyof typeof RecuperoPasswordRequestSendToEnum];

/**
 * 
 * @export
 * @interface RecuperoUsernameError
 */
export interface RecuperoUsernameError {
    /**
     * 
     * @type {Array<string>}
     * @memberof RecuperoUsernameError
     */
    'campiNonValidi'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RecuperoUsernameError
     */
    'codiciErrore'?: Array<RecuperoUsernameErrorCodiciErroreEnum>;
}

export const RecuperoUsernameErrorCodiciErroreEnum = {
    CorrispondenzaMultipla: 'CORRISPONDENZA_MULTIPLA',
    NessunaUtenzaAssociata: 'NESSUNA_UTENZA_ASSOCIATA',
    TroppiTentativi: 'TROPPI_TENTATIVI'
} as const;

export type RecuperoUsernameErrorCodiciErroreEnum = typeof RecuperoUsernameErrorCodiciErroreEnum[keyof typeof RecuperoUsernameErrorCodiciErroreEnum];

/**
 * 
 * @export
 * @interface RecuperoUsernameErrorAllOf
 */
export interface RecuperoUsernameErrorAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof RecuperoUsernameErrorAllOf
     */
    'codiciErrore'?: Array<RecuperoUsernameErrorAllOfCodiciErroreEnum>;
}

export const RecuperoUsernameErrorAllOfCodiciErroreEnum = {
    CorrispondenzaMultipla: 'CORRISPONDENZA_MULTIPLA',
    NessunaUtenzaAssociata: 'NESSUNA_UTENZA_ASSOCIATA',
    TroppiTentativi: 'TROPPI_TENTATIVI'
} as const;

export type RecuperoUsernameErrorAllOfCodiciErroreEnum = typeof RecuperoUsernameErrorAllOfCodiciErroreEnum[keyof typeof RecuperoUsernameErrorAllOfCodiciErroreEnum];

/**
 * Payload utilizzato per il recupero dello username
 * @export
 * @interface RecuperoUsernameRequest
 */
export interface RecuperoUsernameRequest {
    /**
     * 
     * @type {string}
     * @memberof RecuperoUsernameRequest
     */
    'email'?: string;
    /**
     * Phone number in international E.164 format (e.g. +393331234567, +447429310834).  Numbers with grouping spaces are also accepted (e.g. +39 320 123 4567); the  backend normalises to E.164 without spaces.
     * @type {string}
     * @memberof RecuperoUsernameRequest
     */
    'cellulare'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecuperoUsernameRequest
     */
    'codiceUtente'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecuperoUsernameRequest
     */
    'codiceAccordoQuadro'?: string;
}
/**
 * 
 * @export
 * @interface ResetDocumentsQuestionnaireRequest
 */
export interface ResetDocumentsQuestionnaireRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetDocumentsQuestionnaireRequest
     */
    'codiceUtente': string;
    /**
     * 
     * @type {string}
     * @memberof ResetDocumentsQuestionnaireRequest
     */
    'docType': string;
}
/**
 * 
 * @export
 * @interface ResponseMifidPrecompile
 */
export interface ResponseMifidPrecompile {
    /**
     * ID della domanda MIFID
     * @type {number}
     * @memberof ResponseMifidPrecompile
     */
    'idDomanda'?: number;
    /**
     * Array di ID risposte (singolo per RADIO_BUTTON, multiplo per CHECKBOX)
     * @type {Array<number>}
     * @memberof ResponseMifidPrecompile
     */
    'idRisposte'?: Array<number>;
    /**
     * Origine del dato precompilato
     * @type {string}
     * @memberof ResponseMifidPrecompile
     */
    'fonte'?: ResponseMifidPrecompileFonteEnum;
}

export const ResponseMifidPrecompileFonteEnum = {
    Aml: 'AML'
} as const;

export type ResponseMifidPrecompileFonteEnum = typeof ResponseMifidPrecompileFonteEnum[keyof typeof ResponseMifidPrecompileFonteEnum];

/**
 * Lista di utenti che rispettano i parametri di ricerca (console di admin)
 * @export
 * @interface RicercaUtentiResponse
 */
export interface RicercaUtentiResponse {
    /**
     * 
     * @type {Array<AccountInfo>}
     * @memberof RicercaUtentiResponse
     */
    'data'?: Array<AccountInfo>;
    /**
     * 
     * @type {InfoDiPaginazione}
     * @memberof RicercaUtentiResponse
     */
    'pagination'?: InfoDiPaginazione;
}
/**
 * 
 * @export
 * @interface Risposta
 */
export interface Risposta {
    /**
     * 
     * @type {number}
     * @memberof Risposta
     */
    'idRisposta'?: number;
    /**
     * 
     * @type {string}
     * @memberof Risposta
     */
    'descRisposta'?: string;
    /**
     * 
     * @type {string}
     * @memberof Risposta
     */
    'descSubRisposta'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Risposta
     */
    'flagDipendenza'?: boolean;
    /**
     * 
     * @type {Array<Dipendenza>}
     * @memberof Risposta
     */
    'listaDipendenze'?: Array<Dipendenza>;
    /**
     * 
     * @type {boolean}
     * @memberof Risposta
     */
    'flagCoerenzaIp'?: boolean;
}
/**
 * 
 * @export
 * @interface Rubrica
 */
export interface Rubrica {
    /**
     * 
     * @type {string}
     * @memberof Rubrica
     */
    'codiceRubrica'?: string;
    /**
     * 
     * @type {string}
     * @memberof Rubrica
     */
    'nominative'?: string;
}
/**
 * Rubriche
 * @export
 * @interface Rubriche
 */
export interface Rubriche {
    /**
     * 
     * @type {string}
     * @memberof Rubriche
     */
    'codiceCliente'?: string;
    /**
     * 
     * @type {Array<Rubrica>}
     * @memberof Rubriche
     */
    'rubriche'?: Array<Rubrica>;
}
/**
 * Errore relativo al recupero della scheda prodotto
 * @export
 * @interface SchedaProdottoError
 */
export interface SchedaProdottoError {
    /**
     * 
     * @type {Array<string>}
     * @memberof SchedaProdottoError
     */
    'campiNonValidi'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SchedaProdottoError
     */
    'codiciErrore'?: Array<SchedaProdottoErrorCodiciErroreEnum>;
}

export const SchedaProdottoErrorCodiciErroreEnum = {
    DocumentoNonDisponibile: 'DOCUMENTO_NON_DISPONIBILE',
    IsinNonValido: 'ISIN_NON_VALIDO'
} as const;

export type SchedaProdottoErrorCodiciErroreEnum = typeof SchedaProdottoErrorCodiciErroreEnum[keyof typeof SchedaProdottoErrorCodiciErroreEnum];

/**
 * 
 * @export
 * @interface SchedaProdottoErrorAllOf
 */
export interface SchedaProdottoErrorAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof SchedaProdottoErrorAllOf
     */
    'codiciErrore'?: Array<SchedaProdottoErrorAllOfCodiciErroreEnum>;
}

export const SchedaProdottoErrorAllOfCodiciErroreEnum = {
    DocumentoNonDisponibile: 'DOCUMENTO_NON_DISPONIBILE',
    IsinNonValido: 'ISIN_NON_VALIDO'
} as const;

export type SchedaProdottoErrorAllOfCodiciErroreEnum = typeof SchedaProdottoErrorAllOfCodiciErroreEnum[keyof typeof SchedaProdottoErrorAllOfCodiciErroreEnum];

/**
 * 
 * @export
 * @interface Sezione
 */
export interface Sezione {
    /**
     * 
     * @type {string}
     * @memberof Sezione
     */
    'idSezione'?: string;
    /**
     * 
     * @type {string}
     * @memberof Sezione
     */
    'descSezione'?: string;
    /**
     * 
     * @type {Array<Domanda>}
     * @memberof Sezione
     */
    'listaDomande'?: Array<Domanda>;
}
/**
 * Token di login
 * @export
 * @interface SimpleToken
 */
export interface SimpleToken {
    /**
     * Il token necessario per autenticare le richieste
     * @type {string}
     * @memberof SimpleToken
     */
    'token'?: string;
}
/**
 * Dossier annidato in quello radice
 * @export
 * @interface SottoDossier
 */
export interface SottoDossier {
    /**
     * 
     * @type {string}
     * @memberof SottoDossier
     */
    'codiceContratto'?: string;
    /**
     * 
     * @type {string}
     * @memberof SottoDossier
     */
    'suppCompanyRefNum'?: string;
    /**
     * 
     * @type {string}
     * @memberof SottoDossier
     */
    'macroProdotto'?: string;
    /**
     * 
     * @type {string}
     * @memberof SottoDossier
     */
    'prodotto'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof SottoDossier
     */
    'controvalore'?: Importo;
    /**
     * 
     * @type {string}
     * @memberof SottoDossier
     */
    'commissionRegimeTypeCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SottoDossier
     */
    'commissionRegimeTypeDescription'?: string;
}
/**
 * I sottostanti di un prodotto gestito
 * @export
 * @interface SottostanteGestito
 */
export interface SottostanteGestito {
    /**
     * 
     * @type {string}
     * @memberof SottostanteGestito
     */
    'prodotto'?: string;
    /**
     * 
     * @type {number}
     * @memberof SottostanteGestito
     */
    'quantita'?: number;
    /**
     * 
     * @type {Importo}
     * @memberof SottostanteGestito
     */
    'prezzoMedioDiCarico'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof SottostanteGestito
     */
    'cambioMedioDiCarico'?: number;
    /**
     * 
     * @type {number}
     * @memberof SottostanteGestito
     */
    'rateo'?: number;
    /**
     * 
     * @type {Importo}
     * @memberof SottostanteGestito
     */
    'prezzoDiMercato'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof SottostanteGestito
     */
    'cambioDiMercato'?: number;
    /**
     * 
     * @type {Importo}
     * @memberof SottostanteGestito
     */
    'controvalore'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof SottostanteGestito
     */
    'percentualeInc'?: number;
    /**
     * 
     * @type {number}
     * @memberof SottostanteGestito
     */
    'percentualeCoeffRischio'?: number;
}
/**
 * I sottostanti di un prodotto UnitLinked
 * @export
 * @interface SottostanteUnitLinked
 */
export interface SottostanteUnitLinked {
    /**
     * 
     * @type {string}
     * @memberof SottostanteUnitLinked
     */
    'prodotto'?: string;
    /**
     * 
     * @type {number}
     * @memberof SottostanteUnitLinked
     */
    'percentuale'?: number;
    /**
     * 
     * @type {Importo}
     * @memberof SottostanteUnitLinked
     */
    'prezzoMedioDiCarico'?: Importo;
    /**
     * 
     * @type {number}
     * @memberof SottostanteUnitLinked
     */
    'quantita'?: number;
    /**
     * 
     * @type {Importo}
     * @memberof SottostanteUnitLinked
     */
    'prezzoDiMercato'?: Importo;
    /**
     * 
     * @type {string}
     * @memberof SottostanteUnitLinked
     */
    'dataPrezzoDiMercato'?: string;
    /**
     * 
     * @type {Importo}
     * @memberof SottostanteUnitLinked
     */
    'controvalore'?: Importo;
}
/**
 * Lista dei sottostanti
 * @export
 * @interface Sottostanti
 */
export interface Sottostanti {
    /**
     * 
     * @type {string}
     * @memberof Sottostanti
     */
    'macrocategoria'?: SottostantiMacrocategoriaEnum;
    /**
     * 
     * @type {string}
     * @memberof Sottostanti
     */
    'macrocategoriaDiscriminator'?: SottostantiMacrocategoriaDiscriminatorEnum;
    /**
     * 
     * @type {InfoProdotto}
     * @memberof Sottostanti
     */
    'info'?: InfoProdotto;
    /**
     * 
     * @type {Importo}
     * @memberof Sottostanti
     */
    'totale'?: Importo;
    /**
     * 
     * @type {Array<SottostantiGestitoWrapper>}
     * @memberof Sottostanti
     */
    'sottostantiGestito'?: Array<SottostantiGestitoWrapper>;
    /**
     * 
     * @type {Array<SottostantiUnitLinkedWrapper>}
     * @memberof Sottostanti
     */
    'sottostantiUnitLinked'?: Array<SottostantiUnitLinkedWrapper>;
}

export const SottostantiMacrocategoriaEnum = {
    Gestito: 'GESTITO',
    UnitLinked: 'UNIT_LINKED'
} as const;

export type SottostantiMacrocategoriaEnum = typeof SottostantiMacrocategoriaEnum[keyof typeof SottostantiMacrocategoriaEnum];
export const SottostantiMacrocategoriaDiscriminatorEnum = {
    Gestito: 'GESTITO',
    UnitLinked: 'UNIT_LINKED'
} as const;

export type SottostantiMacrocategoriaDiscriminatorEnum = typeof SottostantiMacrocategoriaDiscriminatorEnum[keyof typeof SottostantiMacrocategoriaDiscriminatorEnum];

/**
 * Wrapper della lista dei sottostanti
 * @export
 * @interface SottostantiGestito
 */
export interface SottostantiGestito {
    /**
     * 
     * @type {Array<SottostantiGestitoWrapper>}
     * @memberof SottostantiGestito
     */
    'sottostantiGestito'?: Array<SottostantiGestitoWrapper>;
}
/**
 * Raggruppa i prodotti in base alla categoria (e.g. ETF e altri strumenti)
 * @export
 * @interface SottostantiGestitoWrapper
 */
export interface SottostantiGestitoWrapper {
    /**
     * 
     * @type {string}
     * @memberof SottostantiGestitoWrapper
     */
    'categoria'?: string;
    /**
     * 
     * @type {Array<SottostanteGestito>}
     * @memberof SottostantiGestitoWrapper
     */
    'sottostanti'?: Array<SottostanteGestito>;
}
/**
 * Wrapper della lista dei sottostanti
 * @export
 * @interface SottostantiUnitLinked
 */
export interface SottostantiUnitLinked {
    /**
     * 
     * @type {Array<SottostantiUnitLinkedWrapper>}
     * @memberof SottostantiUnitLinked
     */
    'sottostantiUnitLinked'?: Array<SottostantiUnitLinkedWrapper>;
}
/**
 * Raggruppa i prodotti in base alla categoria (e.g. ETF e altri strumenti)
 * @export
 * @interface SottostantiUnitLinkedWrapper
 */
export interface SottostantiUnitLinkedWrapper {
    /**
     * 
     * @type {string}
     * @memberof SottostantiUnitLinkedWrapper
     */
    'categoria'?: string;
    /**
     * 
     * @type {Array<SottostanteUnitLinked>}
     * @memberof SottostantiUnitLinkedWrapper
     */
    'sottostanti'?: Array<SottostanteUnitLinked>;
}
/**
 * Signature specimen task status and data
 * @export
 * @interface SpecimenState
 */
export interface SpecimenState {
    /**
     * Status of the specimen upload task
     * @type {string}
     * @memberof SpecimenState
     */
    'status': SpecimenStateStatusEnum;
    /**
     * 
     * @type {SpecimenStateData}
     * @memberof SpecimenState
     */
    'data'?: SpecimenStateData;
}

export const SpecimenStateStatusEnum = {
    Completed: 'Completed',
    ToComplete: 'ToComplete'
} as const;

export type SpecimenStateStatusEnum = typeof SpecimenStateStatusEnum[keyof typeof SpecimenStateStatusEnum];

/**
 * Data for the specimen task
 * @export
 * @interface SpecimenStateData
 */
export interface SpecimenStateData {
    /**
     * Signature specimen image in base64
     * @type {string}
     * @memberof SpecimenStateData
     */
    'imageBase64'?: string | null;
    /**
     * Whether the disclaimer was accepted
     * @type {boolean}
     * @memberof SpecimenStateData
     */
    'disclaimerAccepted'?: boolean | null;
}
/**
 * Request for uploading the signature specimen
 * @export
 * @interface SpecimenUploadRequest
 */
export interface SpecimenUploadRequest {
    /**
     * Signature specimen image encoded in base64 (supported formats: PNG, JPEG, JPG, max 5MB)
     * @type {string}
     * @memberof SpecimenUploadRequest
     */
    'imageBase64': string;
    /**
     * Flag indicating if the disclaimer has been accepted by the user
     * @type {boolean}
     * @memberof SpecimenUploadRequest
     */
    'disclaimerAccepted': boolean;
}
/**
 * Response after uploading the signature specimen image
 * @export
 * @interface SpecimenUploadResponse
 */
export interface SpecimenUploadResponse {
    /**
     * 
     * @type {Status}
     * @memberof SpecimenUploadResponse
     */
    'status': Status;
}
/**
 * Status object indicating the result of an operation.
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * Overall outcome of the operation
     * @type {string}
     * @memberof Status
     */
    'code': StatusCodeEnum;
    /**
     * Error description (null if status is OK, error code if status is KO)
     * @type {string}
     * @memberof Status
     */
    'description': string | null;
}

export const StatusCodeEnum = {
    Ok: 'OK',
    Ko: 'KO'
} as const;

export type StatusCodeEnum = typeof StatusCodeEnum[keyof typeof StatusCodeEnum];

/**
 * Contiene informazioni sullo stato dell\'account
 * @export
 * @interface StatusDisposizioni
 */
export interface StatusDisposizioni {
    /**
     * E\' possibile effettuare un cambio contatti solo se il cliente è definitivo
     * @type {boolean}
     * @memberof StatusDisposizioni
     */
    'disponibileCambioContatti'?: boolean;
    /**
     * La modifica email è possibile solo se non risultano a sistema delle disposizioni da firmare
     * @type {boolean}
     * @memberof StatusDisposizioni
     */
    'disposizioniDaFirmare'?: boolean;
    /**
     * Necessario procedere alla firma della modifica dalla mail
     * @type {boolean}
     * @memberof StatusDisposizioni
     */
    'necessariaFirmaCambioEmail'?: boolean;
    /**
     * Valorizzato a null o stringa vuota se non è mai stato effettuato un aggiornamento
     * @type {string}
     * @memberof StatusDisposizioni
     */
    'ultimoAggiornamentoEmail'?: string;
    /**
     * Valorizzato a null o stringa vuota se non è mai stato effettuato un aggiornamento
     * @type {string}
     * @memberof StatusDisposizioni
     */
    'ultimoAggiornamentoCellulare'?: string;
    /**
     * Necessario procedere alla firma della modifica del cellulare
     * @type {boolean}
     * @memberof StatusDisposizioni
     */
    'necessariaFirmaCambioCellulare'?: boolean;
    /**
     * Identificativo del documento da firmare se è in corso un cambio email o cellulare
     * @type {string}
     * @memberof StatusDisposizioni
     */
    'bundleId'?: string;
    /**
     * Codice del consulente finanziario
     * @type {string}
     * @memberof StatusDisposizioni
     */
    'codiceAgente'?: string;
    /**
     * Indica se il cliente ha documenti scaduti o in scadenza
     * @type {boolean}
     * @memberof StatusDisposizioni
     */
    'documentiScaduti'?: boolean;
}
/**
 * 
 * @export
 * @interface StatusRegistrazione
 */
export interface StatusRegistrazione {
    /**
     * Final customer code of the legal representative (if applicable).
     * @type {string}
     * @memberof StatusRegistrazione
     */
    'representativeCustomerCode'?: string;
    /**
     * Identificativo del bundle SignRoom per la firma
     * @type {string}
     * @memberof StatusRegistrazione
     */
    'bundleId'?: string;
    /**
     * Token temporaneo per accedere all\'area firma
     * @type {string}
     * @memberof StatusRegistrazione
     */
    'temporaryToken'?: string;
    /**
     * Stato della registrazione self
     * @type {string}
     * @memberof StatusRegistrazione
     */
    'status'?: StatusRegistrazioneStatusEnum;
}

export const StatusRegistrazioneStatusEnum = {
    NessunaRegistrazione: 'NESSUNA_REGISTRAZIONE',
    RegistrazioneInCorso: 'REGISTRAZIONE_IN_CORSO',
    BundleAttivo: 'BUNDLE_ATTIVO',
    RegistrazioneCompletata: 'REGISTRAZIONE_COMPLETATA'
} as const;

export type StatusRegistrazioneStatusEnum = typeof StatusRegistrazioneStatusEnum[keyof typeof StatusRegistrazioneStatusEnum];

/**
 * 
 * @export
 * @interface StatusResponse
 */
export interface StatusResponse {
    /**
     * 
     * @type {string}
     * @memberof StatusResponse
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusResponse
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface StatusUtente
 */
export interface StatusUtente extends Recapiti {
    /**
     * E\' possibile effettuare un cambio contatti solo se il cliente è definitivo
     * @type {boolean}
     * @memberof StatusUtente
     */
    'disponibileCambioContatti'?: boolean;
    /**
     * La modifica email è possibile solo se non risultano a sistema delle disposizioni da firmare
     * @type {boolean}
     * @memberof StatusUtente
     */
    'disposizioniDaFirmare'?: boolean;
    /**
     * Necessario procedere alla firma della modifica dalla mail
     * @type {boolean}
     * @memberof StatusUtente
     */
    'necessariaFirmaCambioEmail'?: boolean;
    /**
     * Valorizzato a null o stringa vuota se non è mai stato effettuato un aggiornamento
     * @type {string}
     * @memberof StatusUtente
     */
    'ultimoAggiornamentoEmail'?: string;
    /**
     * Valorizzato a null o stringa vuota se non è mai stato effettuato un aggiornamento
     * @type {string}
     * @memberof StatusUtente
     */
    'ultimoAggiornamentoCellulare'?: string;
    /**
     * Necessario procedere alla firma della modifica del cellulare
     * @type {boolean}
     * @memberof StatusUtente
     */
    'necessariaFirmaCambioCellulare'?: boolean;
    /**
     * Identificativo del documento da firmare se è in corso un cambio email o cellulare
     * @type {string}
     * @memberof StatusUtente
     */
    'bundleId'?: string;
    /**
     * Codice del consulente finanziario
     * @type {string}
     * @memberof StatusUtente
     */
    'codiceAgente'?: string;
    /**
     * Indica se il cliente ha documenti scaduti o in scadenza
     * @type {boolean}
     * @memberof StatusUtente
     */
    'documentiScaduti'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StatusUtente
     */
    'codiceClienteRappresentante'?: string;
    /**
     * Nel caso di una persona giuridica contiene la ragione sociale per la quale è figura accessoria
     * @type {string}
     * @memberof StatusUtente
     */
    'ragioneSociale'?: string;
    /**
     * Temporary prospect code (format PDOB-<9 digits>) associated with the user, populated only until the identity has been reconciled with the final customer code. Allows the frontend to query documents on Zenith using both the customer code and the prospect code, so documents signed before reconciliation are not lost.
     * @type {string}
     * @memberof StatusUtente
     */
    'codiceProspect'?: string;
    /**
     * Temporary prospect code of the legal representative (PG). Same purpose as codiceProspect, but refers to the person representing the legal entity.
     * @type {string}
     * @memberof StatusUtente
     */
    'codiceProspectRappresentante'?: string;
}


/**
 * 
 * @export
 * @interface StatusUtenteAllOf
 */
export interface StatusUtenteAllOf {
    /**
     * Temporary prospect code (format PDOB-<9 digits>) associated with the user, populated only until the identity has been reconciled with the final customer code. Allows the frontend to query documents on Zenith using both the customer code and the prospect code, so documents signed before reconciliation are not lost.
     * @type {string}
     * @memberof StatusUtenteAllOf
     */
    'codiceProspect'?: string;
    /**
     * Temporary prospect code of the legal representative (PG). Same purpose as codiceProspect, but refers to the person representing the legal entity.
     * @type {string}
     * @memberof StatusUtenteAllOf
     */
    'codiceProspectRappresentante'?: string;
}
/**
 * 
 * @export
 * @interface StrutturaInternaDomande
 */
export interface StrutturaInternaDomande {
    /**
     * 
     * @type {Array<Domanda>}
     * @memberof StrutturaInternaDomande
     */
    'domande'?: Array<Domanda>;
    /**
     * 
     * @type {Array<DominioRisposte>}
     * @memberof StrutturaInternaDomande
     */
    'listaDominiRisposte'?: Array<DominioRisposte>;
}
/**
 * 
 * @export
 * @interface TemporaryToken
 */
export interface TemporaryToken {
    /**
     * Temporary Token to finalize Digital OnBoarding
     * @type {string}
     * @memberof TemporaryToken
     */
    'temporaryToken'?: string;
}
/**
 * Indica la data-ora di scadenza dei codici di verifica inviati via email/sms
 * @export
 * @interface TimeoutOTP
 */
export interface TimeoutOTP {
    /**
     * 
     * @type {string}
     * @memberof TimeoutOTP
     */
    'timeoutOTP'?: string;
}
/**
 * 
 * @export
 * @interface Token
 */
export interface Token {
    /**
     * Il token necessario per autenticare le richieste
     * @type {string}
     * @memberof Token
     */
    'token'?: string;
    /**
     * Se il flag è presente ed è true significa che bisogna attivare il flusso di primo accesso
     * @type {boolean}
     * @memberof Token
     */
    'primoAccesso'?: boolean;
}
/**
 * Token di login contenente anche il campo del prospect
 * @export
 * @interface Token2
 */
export interface Token2 {
    /**
     * Il token necessario per autenticare le richieste
     * @type {string}
     * @memberof Token2
     */
    'token'?: string;
    /**
     * Se il flag è presente ed è true significa che bisogna attivare il flusso di primo accesso
     * @type {boolean}
     * @memberof Token2
     */
    'primoAccesso'?: boolean;
    /**
     * Boolean necessario per riconoscere se l\'utente è un prospect
     * @type {boolean}
     * @memberof Token2
     */
    'isProspect'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Token2
     */
    'referral'?: string;
    /**
     * Codice utente associato all\'email in caso di login con email come username
     * @type {string}
     * @memberof Token2
     */
    'codiceCliente'?: string;
    /**
     * Se il flag è true, è necessaria la selezione della rubrica
     * @type {boolean}
     * @memberof Token2
     */
    'fiduciaria'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Token2
     */
    'codiceProspect'?: string;
    /**
     * 
     * @type {string}
     * @memberof Token2
     */
    'codiceProspectRappresentante'?: string;
    /**
     * JWT whose identity claims contain the temporary PDOB codes (codice_cliente/codice_rappresentante). Present when the user is still a prospect (same value as token) or after reconciliation when a distinct PDOB is still stored, so the frontend can query Zenith documents under both the final and the prospect identity.
     * @type {string}
     * @memberof Token2
     */
    'prospectToken'?: string;
}
/**
 * 
 * @export
 * @interface TotalFia
 */
export interface TotalFia {
    /**
     * 
     * @type {Importo}
     * @memberof TotalFia
     */
    'totale'?: Importo;
}
/**
 * 
 * @export
 * @interface TotalePortafoglio
 */
export interface TotalePortafoglio {
    /**
     * 
     * @type {Importo}
     * @memberof TotalePortafoglio
     */
    'totale'?: Importo;
    /**
     * 
     * @type {Importo}
     * @memberof TotalePortafoglio
     */
    'totaleComplessivo'?: Importo;
}
/**
 * 
 * @export
 * @interface TrustCompany
 */
export interface TrustCompany {
    /**
     * 
     * @type {string}
     * @memberof TrustCompany
     */
    'agentCode'?: string;
}
/**
 * 
 * @export
 * @interface UpdateCustomerCodeRequest
 */
export interface UpdateCustomerCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerCodeRequest
     */
    'oldCustomerCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerCodeRequest
     */
    'newCustomerCode'?: string;
}
/**
 * 
 * @export
 * @interface UtenteAccountInfo
 */
export interface UtenteAccountInfo extends Persona {
    /**
     * 
     * @type {string}
     * @memberof UtenteAccountInfo
     */
    'codiceClienteRappresentante'?: string;
    /**
     * Nel caso di una persona giuridica contiene la ragione sociale per la quale è figura accessoria
     * @type {string}
     * @memberof UtenteAccountInfo
     */
    'ragioneSociale'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtenteAccountInfo
     */
    'email': string;
    /**
     * Phone number in international E.164 format (e.g. +393331234567, +447429310834).  Numbers with grouping spaces are also accepted (e.g. +39 320 123 4567); the  backend normalises to E.164 without spaces.
     * @type {string}
     * @memberof UtenteAccountInfo
     */
    'cellulare': string;
}


/**
 * 
 * @export
 * @interface UtentiError
 */
export interface UtentiError {
    /**
     * 
     * @type {Array<string>}
     * @memberof UtentiError
     */
    'campiNonValidi'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UtentiError
     */
    'codiciErrore'?: Array<UtentiErrorCodiciErroreEnum>;
}

export const UtentiErrorCodiciErroreEnum = {
    UtenteGiaRegistrato: 'UTENTE_GIA_REGISTRATO',
    VincoliPresenti: 'VINCOLI_PRESENTI',
    DocumentoNonAmmesso: 'DOCUMENTO_NON_AMMESSO',
    DocumentoScaduto: 'DOCUMENTO_SCADUTO',
    AttivazioneImpossibile: 'ATTIVAZIONE_IMPOSSIBILE',
    UtenteInesistente: 'UTENTE_INESISTENTE',
    CfNonAssociato: 'CF_NON_ASSOCIATO',
    CfNonAssociatoFiduciaria: 'CF_NON_ASSOCIATO_FIDUCIARIA',
    PIvaNonAssociata: 'P_IVA_NON_ASSOCIATA',
    UtenzaNonMigrata: 'UTENZA_NON_MIGRATA',
    CfNoFiduciaria: 'CF_NO_FIDUCIARIA',
    UtenteNonValido: 'UTENTE_NON_VALIDO',
    NonFiduciaria: 'NON_FIDUCIARIA'
} as const;

export type UtentiErrorCodiciErroreEnum = typeof UtentiErrorCodiciErroreEnum[keyof typeof UtentiErrorCodiciErroreEnum];

/**
 * 
 * @export
 * @interface UtentiErrorAllOf
 */
export interface UtentiErrorAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof UtentiErrorAllOf
     */
    'codiciErrore'?: Array<UtentiErrorAllOfCodiciErroreEnum>;
}

export const UtentiErrorAllOfCodiciErroreEnum = {
    UtenteGiaRegistrato: 'UTENTE_GIA_REGISTRATO',
    VincoliPresenti: 'VINCOLI_PRESENTI',
    DocumentoNonAmmesso: 'DOCUMENTO_NON_AMMESSO',
    DocumentoScaduto: 'DOCUMENTO_SCADUTO',
    AttivazioneImpossibile: 'ATTIVAZIONE_IMPOSSIBILE',
    UtenteInesistente: 'UTENTE_INESISTENTE',
    CfNonAssociato: 'CF_NON_ASSOCIATO',
    CfNonAssociatoFiduciaria: 'CF_NON_ASSOCIATO_FIDUCIARIA',
    PIvaNonAssociata: 'P_IVA_NON_ASSOCIATA',
    UtenzaNonMigrata: 'UTENZA_NON_MIGRATA',
    CfNoFiduciaria: 'CF_NO_FIDUCIARIA',
    UtenteNonValido: 'UTENTE_NON_VALIDO',
    NonFiduciaria: 'NON_FIDUCIARIA'
} as const;

export type UtentiErrorAllOfCodiciErroreEnum = typeof UtentiErrorAllOfCodiciErroreEnum[keyof typeof UtentiErrorAllOfCodiciErroreEnum];

/**
 * Utente My Azimut
 * @export
 * @interface UtentiResponse
 */
export interface UtentiResponse {
    /**
     * 
     * @type {FiguraAccessoria}
     * @memberof UtentiResponse
     */
    'figuraAccessoria'?: FiguraAccessoria;
    /**
     * 
     * @type {PersonaGiuridicaMkt}
     * @memberof UtentiResponse
     */
    'personaGiuridica'?: PersonaGiuridicaMkt;
}
/**
 * 
 * @export
 * @interface Validator
 */
export interface Validator {
    /**
     * 
     * @type {number}
     * @memberof Validator
     */
    'idDomandaDipendenza'?: number;
    /**
     * 
     * @type {number}
     * @memberof Validator
     */
    'idRispostaDipendenza'?: number;
    /**
     * 
     * @type {string}
     * @memberof Validator
     */
    'idRispostaEsternaDipendenza'?: string;
    /**
     * 
     * @type {string}
     * @memberof Validator
     */
    'tipoDipendenza'?: string;
    /**
     * 
     * @type {number}
     * @memberof Validator
     */
    'idRisposta'?: number;
}
/**
 * 
 * @export
 * @interface VerificaCambioCellulare
 */
export interface VerificaCambioCellulare {
    /**
     * Phone number in international E.164 format (e.g. +393331234567, +447429310834).  Numbers with grouping spaces are also accepted (e.g. +39 320 123 4567); the  backend normalises to E.164 without spaces.
     * @type {string}
     * @memberof VerificaCambioCellulare
     */
    'cellulare': string;
    /**
     * 
     * @type {string}
     * @memberof VerificaCambioCellulare
     */
    'codiceDiVerificaEmail': string;
    /**
     * 
     * @type {string}
     * @memberof VerificaCambioCellulare
     */
    'codiceDiVerificaCellulare': string;
}
/**
 * 
 * @export
 * @interface VerificaCambioCellulareError
 */
export interface VerificaCambioCellulareError {
    /**
     * 
     * @type {Array<string>}
     * @memberof VerificaCambioCellulareError
     */
    'campiNonValidi'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof VerificaCambioCellulareError
     */
    'tentativiRimastiOTPEmail'?: number;
    /**
     * 
     * @type {number}
     * @memberof VerificaCambioCellulareError
     */
    'tentativiRimastiOTPCellulare'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof VerificaCambioCellulareError
     */
    'codiciErrore'?: Array<VerificaCambioCellulareErrorCodiciErroreEnum>;
}

export const VerificaCambioCellulareErrorCodiciErroreEnum = {
    CodiceDiVerificaScaduto: 'CODICE_DI_VERIFICA_SCADUTO',
    CodiceDiVerificaSbagliato: 'CODICE_DI_VERIFICA_SBAGLIATO',
    TroppiTentativi: 'TROPPI_TENTATIVI',
    CellulareNonUtilizzabile: 'CELLULARE_NON_UTILIZZABILE',
    CodiceDiVerificaCellulareSbagliato: 'CODICE_DI_VERIFICA_CELLULARE_SBAGLIATO',
    CodiceDiVerificaEmailSbagliato: 'CODICE_DI_VERIFICA_EMAIL_SBAGLIATO'
} as const;

export type VerificaCambioCellulareErrorCodiciErroreEnum = typeof VerificaCambioCellulareErrorCodiciErroreEnum[keyof typeof VerificaCambioCellulareErrorCodiciErroreEnum];

/**
 * 
 * @export
 * @interface VerificaCambioCellulareErrorAllOf
 */
export interface VerificaCambioCellulareErrorAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof VerificaCambioCellulareErrorAllOf
     */
    'codiciErrore'?: Array<VerificaCambioCellulareErrorAllOfCodiciErroreEnum>;
}

export const VerificaCambioCellulareErrorAllOfCodiciErroreEnum = {
    CodiceDiVerificaScaduto: 'CODICE_DI_VERIFICA_SCADUTO',
    CodiceDiVerificaSbagliato: 'CODICE_DI_VERIFICA_SBAGLIATO',
    TroppiTentativi: 'TROPPI_TENTATIVI',
    CellulareNonUtilizzabile: 'CELLULARE_NON_UTILIZZABILE',
    CodiceDiVerificaCellulareSbagliato: 'CODICE_DI_VERIFICA_CELLULARE_SBAGLIATO',
    CodiceDiVerificaEmailSbagliato: 'CODICE_DI_VERIFICA_EMAIL_SBAGLIATO'
} as const;

export type VerificaCambioCellulareErrorAllOfCodiciErroreEnum = typeof VerificaCambioCellulareErrorAllOfCodiciErroreEnum[keyof typeof VerificaCambioCellulareErrorAllOfCodiciErroreEnum];

/**
 * 
 * @export
 * @interface VerificaCambioEmail
 */
export interface VerificaCambioEmail {
    /**
     * 
     * @type {string}
     * @memberof VerificaCambioEmail
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof VerificaCambioEmail
     */
    'codiceDiVerificaEmail': string;
    /**
     * 
     * @type {string}
     * @memberof VerificaCambioEmail
     */
    'codiceDiVerificaCellulare': string;
}
/**
 * 
 * @export
 * @interface VerificaCambioEmailError
 */
export interface VerificaCambioEmailError {
    /**
     * 
     * @type {Array<string>}
     * @memberof VerificaCambioEmailError
     */
    'campiNonValidi'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof VerificaCambioEmailError
     */
    'tentativiRimastiOTPEmail'?: number;
    /**
     * 
     * @type {number}
     * @memberof VerificaCambioEmailError
     */
    'tentativiRimastiOTPCellulare'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof VerificaCambioEmailError
     */
    'codiciErrore'?: Array<VerificaCambioEmailErrorCodiciErroreEnum>;
}

export const VerificaCambioEmailErrorCodiciErroreEnum = {
    CodiceDiVerificaScaduto: 'CODICE_DI_VERIFICA_SCADUTO',
    CodiceDiVerificaSbagliato: 'CODICE_DI_VERIFICA_SBAGLIATO',
    TroppiTentativi: 'TROPPI_TENTATIVI',
    EmailNonUtilizzabile: 'EMAIL_NON_UTILIZZABILE',
    CodiceDiVerificaCellulareSbagliato: 'CODICE_DI_VERIFICA_CELLULARE_SBAGLIATO',
    CodiceDiVerificaEmailSbagliato: 'CODICE_DI_VERIFICA_EMAIL_SBAGLIATO'
} as const;

export type VerificaCambioEmailErrorCodiciErroreEnum = typeof VerificaCambioEmailErrorCodiciErroreEnum[keyof typeof VerificaCambioEmailErrorCodiciErroreEnum];

/**
 * 
 * @export
 * @interface VerificaCambioEmailErrorAllOf
 */
export interface VerificaCambioEmailErrorAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof VerificaCambioEmailErrorAllOf
     */
    'codiciErrore'?: Array<VerificaCambioEmailErrorAllOfCodiciErroreEnum>;
}

export const VerificaCambioEmailErrorAllOfCodiciErroreEnum = {
    CodiceDiVerificaScaduto: 'CODICE_DI_VERIFICA_SCADUTO',
    CodiceDiVerificaSbagliato: 'CODICE_DI_VERIFICA_SBAGLIATO',
    TroppiTentativi: 'TROPPI_TENTATIVI',
    EmailNonUtilizzabile: 'EMAIL_NON_UTILIZZABILE',
    CodiceDiVerificaCellulareSbagliato: 'CODICE_DI_VERIFICA_CELLULARE_SBAGLIATO',
    CodiceDiVerificaEmailSbagliato: 'CODICE_DI_VERIFICA_EMAIL_SBAGLIATO'
} as const;

export type VerificaCambioEmailErrorAllOfCodiciErroreEnum = typeof VerificaCambioEmailErrorAllOfCodiciErroreEnum[keyof typeof VerificaCambioEmailErrorAllOfCodiciErroreEnum];

/**
 * 
 * @export
 * @interface VerificaCellulare
 */
export interface VerificaCellulare {
    /**
     * Phone number in international E.164 format (e.g. +393331234567, +447429310834).  Numbers with grouping spaces are also accepted (e.g. +39 320 123 4567); the  backend normalises to E.164 without spaces.
     * @type {string}
     * @memberof VerificaCellulare
     */
    'cellulare': string;
    /**
     * 
     * @type {string}
     * @memberof VerificaCellulare
     */
    'codiceDiVerifica': string;
}
/**
 * 
 * @export
 * @interface VerificaCellulareError
 */
export interface VerificaCellulareError {
    /**
     * 
     * @type {Array<string>}
     * @memberof VerificaCellulareError
     */
    'campiNonValidi'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof VerificaCellulareError
     */
    'tentativiRimastiOTP'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof VerificaCellulareError
     */
    'codiciErrore'?: Array<VerificaCellulareErrorCodiciErroreEnum>;
}

export const VerificaCellulareErrorCodiciErroreEnum = {
    CodiceDiVerificaSbagliato: 'CODICE_DI_VERIFICA_SBAGLIATO',
    TroppiTentativi: 'TROPPI_TENTATIVI',
    CellulareNonUtilizzabile: 'CELLULARE_NON_UTILIZZABILE',
    CodiceDiVerificaCellulareSbagliato: 'CODICE_DI_VERIFICA_CELLULARE_SBAGLIATO',
    CodiceDiVerificaEmailSbagliato: 'CODICE_DI_VERIFICA_EMAIL_SBAGLIATO',
    AccordoQuadroNonAttivo: 'ACCORDO_QUADRO_NON_ATTIVO',
    DocumentoScaduto: 'DOCUMENTO_SCADUTO'
} as const;

export type VerificaCellulareErrorCodiciErroreEnum = typeof VerificaCellulareErrorCodiciErroreEnum[keyof typeof VerificaCellulareErrorCodiciErroreEnum];

/**
 * 
 * @export
 * @interface VerificaCellulareErrorAllOf
 */
export interface VerificaCellulareErrorAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof VerificaCellulareErrorAllOf
     */
    'codiciErrore'?: Array<VerificaCellulareErrorAllOfCodiciErroreEnum>;
}

export const VerificaCellulareErrorAllOfCodiciErroreEnum = {
    CodiceDiVerificaSbagliato: 'CODICE_DI_VERIFICA_SBAGLIATO',
    TroppiTentativi: 'TROPPI_TENTATIVI',
    CellulareNonUtilizzabile: 'CELLULARE_NON_UTILIZZABILE',
    CodiceDiVerificaCellulareSbagliato: 'CODICE_DI_VERIFICA_CELLULARE_SBAGLIATO',
    CodiceDiVerificaEmailSbagliato: 'CODICE_DI_VERIFICA_EMAIL_SBAGLIATO',
    AccordoQuadroNonAttivo: 'ACCORDO_QUADRO_NON_ATTIVO',
    DocumentoScaduto: 'DOCUMENTO_SCADUTO'
} as const;

export type VerificaCellulareErrorAllOfCodiciErroreEnum = typeof VerificaCellulareErrorAllOfCodiciErroreEnum[keyof typeof VerificaCellulareErrorAllOfCodiciErroreEnum];

/**
 * Restituisce l\'identificativo del bundle con i documenti da firmare
 * @export
 * @interface VerificaCellulareResponse
 */
export interface VerificaCellulareResponse {
    /**
     * Identificativo del documento da firmare se è in corso un cambio email o cellulare
     * @type {string}
     * @memberof VerificaCellulareResponse
     */
    'bundleId'?: string;
    /**
     * Temporary Token to finalize Digital OnBoarding
     * @type {string}
     * @memberof VerificaCellulareResponse
     */
    'temporaryToken'?: string;
}
/**
 * 
 * @export
 * @interface VerificaEmail
 */
export interface VerificaEmail {
    /**
     * 
     * @type {string}
     * @memberof VerificaEmail
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof VerificaEmail
     */
    'codiceDiVerifica': string;
}
/**
 * 
 * @export
 * @interface VerificaEmailError
 */
export interface VerificaEmailError {
    /**
     * 
     * @type {Array<string>}
     * @memberof VerificaEmailError
     */
    'campiNonValidi'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof VerificaEmailError
     */
    'tentativiRimastiOTP'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof VerificaEmailError
     */
    'codiciErrore'?: Array<VerificaEmailErrorCodiciErroreEnum>;
}

export const VerificaEmailErrorCodiciErroreEnum = {
    CodiceDiVerificaSbagliato: 'CODICE_DI_VERIFICA_SBAGLIATO',
    TroppiTentativi: 'TROPPI_TENTATIVI',
    EmailNonUtilizzabile: 'EMAIL_NON_UTILIZZABILE',
    EmailConContrattoInCorso: 'EMAIL_CON_CONTRATTO_IN_CORSO',
    CodiceDiVerificaCellulareSbagliato: 'CODICE_DI_VERIFICA_CELLULARE_SBAGLIATO',
    CodiceDiVerificaEmailSbagliato: 'CODICE_DI_VERIFICA_EMAIL_SBAGLIATO',
    AccordoQuadroNonAttivo: 'ACCORDO_QUADRO_NON_ATTIVO',
    DocumentoScaduto: 'DOCUMENTO_SCADUTO'
} as const;

export type VerificaEmailErrorCodiciErroreEnum = typeof VerificaEmailErrorCodiciErroreEnum[keyof typeof VerificaEmailErrorCodiciErroreEnum];

/**
 * 
 * @export
 * @interface VerificaEmailErrorAllOf
 */
export interface VerificaEmailErrorAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof VerificaEmailErrorAllOf
     */
    'codiciErrore'?: Array<VerificaEmailErrorAllOfCodiciErroreEnum>;
}

export const VerificaEmailErrorAllOfCodiciErroreEnum = {
    CodiceDiVerificaSbagliato: 'CODICE_DI_VERIFICA_SBAGLIATO',
    TroppiTentativi: 'TROPPI_TENTATIVI',
    EmailNonUtilizzabile: 'EMAIL_NON_UTILIZZABILE',
    EmailConContrattoInCorso: 'EMAIL_CON_CONTRATTO_IN_CORSO',
    CodiceDiVerificaCellulareSbagliato: 'CODICE_DI_VERIFICA_CELLULARE_SBAGLIATO',
    CodiceDiVerificaEmailSbagliato: 'CODICE_DI_VERIFICA_EMAIL_SBAGLIATO',
    AccordoQuadroNonAttivo: 'ACCORDO_QUADRO_NON_ATTIVO',
    DocumentoScaduto: 'DOCUMENTO_SCADUTO'
} as const;

export type VerificaEmailErrorAllOfCodiciErroreEnum = typeof VerificaEmailErrorAllOfCodiciErroreEnum[keyof typeof VerificaEmailErrorAllOfCodiciErroreEnum];

/**
 * Restituisce cellulare e l\'identificativo del bundle con i documenti da firmare
 * @export
 * @interface VerificaEmailResponse
 */
export interface VerificaEmailResponse {
    /**
     * Phone number in international E.164 format (e.g. +393331234567, +447429310834).  Numbers with grouping spaces are also accepted (e.g. +39 320 123 4567); the  backend normalises to E.164 without spaces.
     * @type {string}
     * @memberof VerificaEmailResponse
     */
    'cellulare': string;
    /**
     * Identificativo del documento da firmare se è in corso un cambio email o cellulare
     * @type {string}
     * @memberof VerificaEmailResponse
     */
    'bundleId'?: string;
    /**
     * Temporary Token to finalize Digital OnBoarding
     * @type {string}
     * @memberof VerificaEmailResponse
     */
    'temporaryToken'?: string;
}
/**
 * 
 * @export
 * @interface VideoMediaResponse
 */
export interface VideoMediaResponse {
    /**
     * 
     * @type {Array<VideoResponse>}
     * @memberof VideoMediaResponse
     */
    'featured'?: Array<VideoResponse>;
    /**
     * 
     * @type {Array<VideoResponse>}
     * @memberof VideoMediaResponse
     */
    'others'?: Array<VideoResponse>;
}
/**
 * 
 * @export
 * @interface VideoResponse
 */
export interface VideoResponse {
    /**
     * 
     * @type {string}
     * @memberof VideoResponse
     */
    'videoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof VideoResponse
     */
    'posterUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof VideoResponse
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof VideoResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof VideoResponse
     */
    'uploadDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof VideoResponse
     */
    'videoId'?: string;
}
/**
 * 
 * @export
 * @interface WebCollaborationAnswerRequest
 */
export interface WebCollaborationAnswerRequest {
    /**
     * 
     * @type {string}
     * @memberof WebCollaborationAnswerRequest
     */
    'answer'?: string;
}
/**
 * 
 * @export
 * @interface WebCollaborationCreateResponse
 */
export interface WebCollaborationCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof WebCollaborationCreateResponse
     */
    'roomId'?: string;
}
/**
 * 
 * @export
 * @interface WebCollaborationIceCandidateRequest
 */
export interface WebCollaborationIceCandidateRequest {
    /**
     * 
     * @type {string}
     * @memberof WebCollaborationIceCandidateRequest
     */
    'iceCandidate'?: string;
}
/**
 * 
 * @export
 * @interface WebCollaborationOfferRequest
 */
export interface WebCollaborationOfferRequest {
    /**
     * 
     * @type {string}
     * @memberof WebCollaborationOfferRequest
     */
    'offer'?: string;
}
/**
 * 
 * @export
 * @interface WebCollaborationRoomStatus
 */
export interface WebCollaborationRoomStatus {
    /**
     * 
     * @type {string}
     * @memberof WebCollaborationRoomStatus
     */
    'roomId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebCollaborationRoomStatus
     */
    'offer'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebCollaborationRoomStatus
     */
    'answer'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebCollaborationRoomStatus
     */
    'iceCandidate'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebCollaborationRoomStatus
     */
    'roomStatus'?: WebCollaborationRoomStatusRoomStatusEnum;
}

export const WebCollaborationRoomStatusRoomStatusEnum = {
    WaitOffer: 'WAIT_OFFER',
    WaitAnswer: 'WAIT_ANSWER',
    WaitHandshake: 'WAIT_HANDSHAKE',
    Connected: 'CONNECTED',
    Expired: 'EXPIRED'
} as const;

export type WebCollaborationRoomStatusRoomStatusEnum = typeof WebCollaborationRoomStatusRoomStatusEnum[keyof typeof WebCollaborationRoomStatusRoomStatusEnum];

/**
 * 
 * @export
 * @interface WrapperMovimenti
 */
export interface WrapperMovimenti {
    /**
     * 
     * @type {InfoProdotto}
     * @memberof WrapperMovimenti
     */
    'info'?: InfoProdotto;
    /**
     * 
     * @type {Array<MovimentoProdotto>}
     * @memberof WrapperMovimenti
     */
    'movimenti'?: Array<MovimentoProdotto>;
}

/**
 * AgentsApi - axios parameter creator
 * @export
 */
export const AgentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Verifica se un consulente finanziario è censito nel sistema
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgent: async (query: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchAgent', 'query', query)
            const localVarPath = `/agents/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentsApi - functional programming interface
 * @export
 */
export const AgentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Verifica se un consulente finanziario è censito nel sistema
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAgent(query: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgent(query, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgentsApi - factory interface
 * @export
 */
export const AgentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentsApiFp(configuration)
    return {
        /**
         * Verifica se un consulente finanziario è censito nel sistema
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgent(query: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.searchAgent(query, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for searchAgent operation in AgentsApi.
 * @export
 * @interface AgentsApiSearchAgentRequest
 */
export interface AgentsApiSearchAgentRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentsApiSearchAgent
     */
    readonly query: string
}

/**
 * AgentsApi - object-oriented interface
 * @export
 * @class AgentsApi
 * @extends {BaseAPI}
 */
export class AgentsApi extends BaseAPI {
    /**
     * Verifica se un consulente finanziario è censito nel sistema
     * @param {AgentsApiSearchAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public searchAgent(requestParameters: AgentsApiSearchAgentRequest, options?: AxiosRequestConfig) {
        return AgentsApiFp(this.configuration).searchAgent(requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AmlTemplateApi - axios parameter creator
 * @export
 */
export const AmlTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Richiesta template AML FACTA/CRS dalla pagina di compilazione
         * @param {string} tipoAml 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAmlTemplate: async (tipoAml: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tipoAml' is not null or undefined
            assertParamExists('getAmlTemplate', 'tipoAml', tipoAml)
            const localVarPath = `/utenti/aml/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tipoAml !== undefined) {
                localVarQueryParameter['tipoAml'] = tipoAml;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AmlTemplateApi - functional programming interface
 * @export
 */
export const AmlTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AmlTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * Richiesta template AML FACTA/CRS dalla pagina di compilazione
         * @param {string} tipoAml 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAmlTemplate(tipoAml: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AmlTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAmlTemplate(tipoAml, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AmlTemplateApi - factory interface
 * @export
 */
export const AmlTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AmlTemplateApiFp(configuration)
    return {
        /**
         * Richiesta template AML FACTA/CRS dalla pagina di compilazione
         * @param {string} tipoAml 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAmlTemplate(tipoAml: string, options?: any): AxiosPromise<AmlTemplate> {
            return localVarFp.getAmlTemplate(tipoAml, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAmlTemplate operation in AmlTemplateApi.
 * @export
 * @interface AmlTemplateApiGetAmlTemplateRequest
 */
export interface AmlTemplateApiGetAmlTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof AmlTemplateApiGetAmlTemplate
     */
    readonly tipoAml: string
}

/**
 * AmlTemplateApi - object-oriented interface
 * @export
 * @class AmlTemplateApi
 * @extends {BaseAPI}
 */
export class AmlTemplateApi extends BaseAPI {
    /**
     * Richiesta template AML FACTA/CRS dalla pagina di compilazione
     * @param {AmlTemplateApiGetAmlTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmlTemplateApi
     */
    public getAmlTemplate(requestParameters: AmlTemplateApiGetAmlTemplateRequest, options?: AxiosRequestConfig) {
        return AmlTemplateApiFp(this.configuration).getAmlTemplate(requestParameters.tipoAml, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AnagraficaApi - axios parameter creator
 * @export
 */
export const AnagraficaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Api per la lettura delle informazioni anagrafiche di una persona giuridica dato in input la corrispettiva email.
         * @summary Ricerca informazioni cliente per persona giuridica
         * @param {string} email email cliente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utentiMarketplaceGet: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('utentiMarketplaceGet', 'email', email)
            const localVarPath = `/utenti/marketplace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnagraficaApi - functional programming interface
 * @export
 */
export const AnagraficaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnagraficaApiAxiosParamCreator(configuration)
    return {
        /**
         * Api per la lettura delle informazioni anagrafiche di una persona giuridica dato in input la corrispettiva email.
         * @summary Ricerca informazioni cliente per persona giuridica
         * @param {string} email email cliente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utentiMarketplaceGet(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtentiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utentiMarketplaceGet(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AnagraficaApi - factory interface
 * @export
 */
export const AnagraficaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnagraficaApiFp(configuration)
    return {
        /**
         * Api per la lettura delle informazioni anagrafiche di una persona giuridica dato in input la corrispettiva email.
         * @summary Ricerca informazioni cliente per persona giuridica
         * @param {string} email email cliente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utentiMarketplaceGet(email: string, options?: any): AxiosPromise<UtentiResponse> {
            return localVarFp.utentiMarketplaceGet(email, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for utentiMarketplaceGet operation in AnagraficaApi.
 * @export
 * @interface AnagraficaApiUtentiMarketplaceGetRequest
 */
export interface AnagraficaApiUtentiMarketplaceGetRequest {
    /**
     * email cliente
     * @type {string}
     * @memberof AnagraficaApiUtentiMarketplaceGet
     */
    readonly email: string
}

/**
 * AnagraficaApi - object-oriented interface
 * @export
 * @class AnagraficaApi
 * @extends {BaseAPI}
 */
export class AnagraficaApi extends BaseAPI {
    /**
     * Api per la lettura delle informazioni anagrafiche di una persona giuridica dato in input la corrispettiva email.
     * @summary Ricerca informazioni cliente per persona giuridica
     * @param {AnagraficaApiUtentiMarketplaceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public utentiMarketplaceGet(requestParameters: AnagraficaApiUtentiMarketplaceGetRequest, options?: AxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).utentiMarketplaceGet(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AreaFirmaApi - axios parameter creator
 * @export
 */
export const AreaFirmaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lista dei documenti in area firma
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listaDocumentiAreaFirma: async (codiceUtente: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('listaDocumentiAreaFirma', 'codiceUtente', codiceUtente)
            const localVarPath = `/utenti/{codiceUtente}/documenti-firma`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AreaFirmaApi - functional programming interface
 * @export
 */
export const AreaFirmaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AreaFirmaApiAxiosParamCreator(configuration)
    return {
        /**
         * Lista dei documenti in area firma
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listaDocumentiAreaFirma(codiceUtente: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentoFirma>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listaDocumentiAreaFirma(codiceUtente, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AreaFirmaApi - factory interface
 * @export
 */
export const AreaFirmaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AreaFirmaApiFp(configuration)
    return {
        /**
         * Lista dei documenti in area firma
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listaDocumentiAreaFirma(codiceUtente: string, options?: any): AxiosPromise<Array<DocumentoFirma>> {
            return localVarFp.listaDocumentiAreaFirma(codiceUtente, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for listaDocumentiAreaFirma operation in AreaFirmaApi.
 * @export
 * @interface AreaFirmaApiListaDocumentiAreaFirmaRequest
 */
export interface AreaFirmaApiListaDocumentiAreaFirmaRequest {
    /**
     * 
     * @type {string}
     * @memberof AreaFirmaApiListaDocumentiAreaFirma
     */
    readonly codiceUtente: string
}

/**
 * AreaFirmaApi - object-oriented interface
 * @export
 * @class AreaFirmaApi
 * @extends {BaseAPI}
 */
export class AreaFirmaApi extends BaseAPI {
    /**
     * Lista dei documenti in area firma
     * @param {AreaFirmaApiListaDocumentiAreaFirmaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AreaFirmaApi
     */
    public listaDocumentiAreaFirma(requestParameters: AreaFirmaApiListaDocumentiAreaFirmaRequest, options?: AxiosRequestConfig) {
        return AreaFirmaApiFp(this.configuration).listaDocumentiAreaFirma(requestParameters.codiceUtente, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AzimutLifeApi - axios parameter creator
 * @export
 */
export const AzimutLifeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Richiesta per accesso SSO al portale Azimut Life
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAzimutLifePage: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/azimut-life-page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AzimutLifeApi - functional programming interface
 * @export
 */
export const AzimutLifeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AzimutLifeApiAxiosParamCreator(configuration)
    return {
        /**
         * Richiesta per accesso SSO al portale Azimut Life
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAzimutLifePage(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAzimutLifePage(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AzimutLifeApi - factory interface
 * @export
 */
export const AzimutLifeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AzimutLifeApiFp(configuration)
    return {
        /**
         * Richiesta per accesso SSO al portale Azimut Life
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAzimutLifePage(options?: any): AxiosPromise<string> {
            return localVarFp.getAzimutLifePage(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AzimutLifeApi - object-oriented interface
 * @export
 * @class AzimutLifeApi
 * @extends {BaseAPI}
 */
export class AzimutLifeApi extends BaseAPI {
    /**
     * Richiesta per accesso SSO al portale Azimut Life
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AzimutLifeApi
     */
    public getAzimutLifePage(options?: AxiosRequestConfig) {
        return AzimutLifeApiFp(this.configuration).getAzimutLifePage(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CambioContattiApi - axios parameter creator
 * @export
 */
export const CambioContattiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cambio del numero di cellulare dell\'utente
         * @param {string} codiceUtente 
         * @param {Cellulare} cellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cambioCellulare: async (codiceUtente: string, cellulare: Cellulare, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('cambioCellulare', 'codiceUtente', codiceUtente)
            // verify required parameter 'cellulare' is not null or undefined
            assertParamExists('cambioCellulare', 'cellulare', cellulare)
            const localVarPath = `/utenti/{codiceUtente}/cellulare`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cellulare, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cambio del numero di cellulare secondario dell\'utente
         * @param {string} codiceUtente 
         * @param {Cellulare} cellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cambioCellulareSecondario: async (codiceUtente: string, cellulare: Cellulare, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('cambioCellulareSecondario', 'codiceUtente', codiceUtente)
            // verify required parameter 'cellulare' is not null or undefined
            assertParamExists('cambioCellulareSecondario', 'cellulare', cellulare)
            const localVarPath = `/utenti/{codiceUtente}/cellulare-secondario`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cellulare, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cambio dell\'indirizzo email dell\'utente
         * @param {string} codiceUtente 
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cambioEmail: async (codiceUtente: string, email: Email, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('cambioEmail', 'codiceUtente', codiceUtente)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('cambioEmail', 'email', email)
            const localVarPath = `/utenti/{codiceUtente}/email`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(email, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifica del numero di cellulare dell\'utente
         * @param {string} codiceUtente 
         * @param {VerificaCambioCellulare} verificaCambioCellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificaCambioCellulare: async (codiceUtente: string, verificaCambioCellulare: VerificaCambioCellulare, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('verificaCambioCellulare', 'codiceUtente', codiceUtente)
            // verify required parameter 'verificaCambioCellulare' is not null or undefined
            assertParamExists('verificaCambioCellulare', 'verificaCambioCellulare', verificaCambioCellulare)
            const localVarPath = `/utenti/{codiceUtente}/verifica-cellulare`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verificaCambioCellulare, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifica dell\'indirizzo email dell\'utente
         * @param {string} codiceUtente 
         * @param {VerificaCambioEmail} verificaCambioEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificaCambioEmail: async (codiceUtente: string, verificaCambioEmail: VerificaCambioEmail, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('verificaCambioEmail', 'codiceUtente', codiceUtente)
            // verify required parameter 'verificaCambioEmail' is not null or undefined
            assertParamExists('verificaCambioEmail', 'verificaCambioEmail', verificaCambioEmail)
            const localVarPath = `/utenti/{codiceUtente}/verifica-email`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verificaCambioEmail, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CambioContattiApi - functional programming interface
 * @export
 */
export const CambioContattiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CambioContattiApiAxiosParamCreator(configuration)
    return {
        /**
         * Cambio del numero di cellulare dell\'utente
         * @param {string} codiceUtente 
         * @param {Cellulare} cellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cambioCellulare(codiceUtente: string, cellulare: Cellulare, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeoutOTP>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cambioCellulare(codiceUtente, cellulare, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Cambio del numero di cellulare secondario dell\'utente
         * @param {string} codiceUtente 
         * @param {Cellulare} cellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cambioCellulareSecondario(codiceUtente: string, cellulare: Cellulare, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cambioCellulareSecondario(codiceUtente, cellulare, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Cambio dell\'indirizzo email dell\'utente
         * @param {string} codiceUtente 
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cambioEmail(codiceUtente: string, email: Email, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeoutOTP>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cambioEmail(codiceUtente, email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verifica del numero di cellulare dell\'utente
         * @param {string} codiceUtente 
         * @param {VerificaCambioCellulare} verificaCambioCellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verificaCambioCellulare(codiceUtente: string, verificaCambioCellulare: VerificaCambioCellulare, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleId>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verificaCambioCellulare(codiceUtente, verificaCambioCellulare, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verifica dell\'indirizzo email dell\'utente
         * @param {string} codiceUtente 
         * @param {VerificaCambioEmail} verificaCambioEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verificaCambioEmail(codiceUtente: string, verificaCambioEmail: VerificaCambioEmail, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleId>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verificaCambioEmail(codiceUtente, verificaCambioEmail, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CambioContattiApi - factory interface
 * @export
 */
export const CambioContattiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CambioContattiApiFp(configuration)
    return {
        /**
         * Cambio del numero di cellulare dell\'utente
         * @param {string} codiceUtente 
         * @param {Cellulare} cellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cambioCellulare(codiceUtente: string, cellulare: Cellulare, options?: any): AxiosPromise<TimeoutOTP> {
            return localVarFp.cambioCellulare(codiceUtente, cellulare, options).then((request) => request(axios, basePath));
        },
        /**
         * Cambio del numero di cellulare secondario dell\'utente
         * @param {string} codiceUtente 
         * @param {Cellulare} cellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cambioCellulareSecondario(codiceUtente: string, cellulare: Cellulare, options?: any): AxiosPromise<void> {
            return localVarFp.cambioCellulareSecondario(codiceUtente, cellulare, options).then((request) => request(axios, basePath));
        },
        /**
         * Cambio dell\'indirizzo email dell\'utente
         * @param {string} codiceUtente 
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cambioEmail(codiceUtente: string, email: Email, options?: any): AxiosPromise<TimeoutOTP> {
            return localVarFp.cambioEmail(codiceUtente, email, options).then((request) => request(axios, basePath));
        },
        /**
         * Verifica del numero di cellulare dell\'utente
         * @param {string} codiceUtente 
         * @param {VerificaCambioCellulare} verificaCambioCellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificaCambioCellulare(codiceUtente: string, verificaCambioCellulare: VerificaCambioCellulare, options?: any): AxiosPromise<BundleId> {
            return localVarFp.verificaCambioCellulare(codiceUtente, verificaCambioCellulare, options).then((request) => request(axios, basePath));
        },
        /**
         * Verifica dell\'indirizzo email dell\'utente
         * @param {string} codiceUtente 
         * @param {VerificaCambioEmail} verificaCambioEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificaCambioEmail(codiceUtente: string, verificaCambioEmail: VerificaCambioEmail, options?: any): AxiosPromise<BundleId> {
            return localVarFp.verificaCambioEmail(codiceUtente, verificaCambioEmail, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cambioCellulare operation in CambioContattiApi.
 * @export
 * @interface CambioContattiApiCambioCellulareRequest
 */
export interface CambioContattiApiCambioCellulareRequest {
    /**
     * 
     * @type {string}
     * @memberof CambioContattiApiCambioCellulare
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {Cellulare}
     * @memberof CambioContattiApiCambioCellulare
     */
    readonly cellulare: Cellulare
}

/**
 * Request parameters for cambioCellulareSecondario operation in CambioContattiApi.
 * @export
 * @interface CambioContattiApiCambioCellulareSecondarioRequest
 */
export interface CambioContattiApiCambioCellulareSecondarioRequest {
    /**
     * 
     * @type {string}
     * @memberof CambioContattiApiCambioCellulareSecondario
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {Cellulare}
     * @memberof CambioContattiApiCambioCellulareSecondario
     */
    readonly cellulare: Cellulare
}

/**
 * Request parameters for cambioEmail operation in CambioContattiApi.
 * @export
 * @interface CambioContattiApiCambioEmailRequest
 */
export interface CambioContattiApiCambioEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof CambioContattiApiCambioEmail
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {Email}
     * @memberof CambioContattiApiCambioEmail
     */
    readonly email: Email
}

/**
 * Request parameters for verificaCambioCellulare operation in CambioContattiApi.
 * @export
 * @interface CambioContattiApiVerificaCambioCellulareRequest
 */
export interface CambioContattiApiVerificaCambioCellulareRequest {
    /**
     * 
     * @type {string}
     * @memberof CambioContattiApiVerificaCambioCellulare
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {VerificaCambioCellulare}
     * @memberof CambioContattiApiVerificaCambioCellulare
     */
    readonly verificaCambioCellulare: VerificaCambioCellulare
}

/**
 * Request parameters for verificaCambioEmail operation in CambioContattiApi.
 * @export
 * @interface CambioContattiApiVerificaCambioEmailRequest
 */
export interface CambioContattiApiVerificaCambioEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof CambioContattiApiVerificaCambioEmail
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {VerificaCambioEmail}
     * @memberof CambioContattiApiVerificaCambioEmail
     */
    readonly verificaCambioEmail: VerificaCambioEmail
}

/**
 * CambioContattiApi - object-oriented interface
 * @export
 * @class CambioContattiApi
 * @extends {BaseAPI}
 */
export class CambioContattiApi extends BaseAPI {
    /**
     * Cambio del numero di cellulare dell\'utente
     * @param {CambioContattiApiCambioCellulareRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CambioContattiApi
     */
    public cambioCellulare(requestParameters: CambioContattiApiCambioCellulareRequest, options?: AxiosRequestConfig) {
        return CambioContattiApiFp(this.configuration).cambioCellulare(requestParameters.codiceUtente, requestParameters.cellulare, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cambio del numero di cellulare secondario dell\'utente
     * @param {CambioContattiApiCambioCellulareSecondarioRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CambioContattiApi
     */
    public cambioCellulareSecondario(requestParameters: CambioContattiApiCambioCellulareSecondarioRequest, options?: AxiosRequestConfig) {
        return CambioContattiApiFp(this.configuration).cambioCellulareSecondario(requestParameters.codiceUtente, requestParameters.cellulare, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cambio dell\'indirizzo email dell\'utente
     * @param {CambioContattiApiCambioEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CambioContattiApi
     */
    public cambioEmail(requestParameters: CambioContattiApiCambioEmailRequest, options?: AxiosRequestConfig) {
        return CambioContattiApiFp(this.configuration).cambioEmail(requestParameters.codiceUtente, requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifica del numero di cellulare dell\'utente
     * @param {CambioContattiApiVerificaCambioCellulareRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CambioContattiApi
     */
    public verificaCambioCellulare(requestParameters: CambioContattiApiVerificaCambioCellulareRequest, options?: AxiosRequestConfig) {
        return CambioContattiApiFp(this.configuration).verificaCambioCellulare(requestParameters.codiceUtente, requestParameters.verificaCambioCellulare, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifica dell\'indirizzo email dell\'utente
     * @param {CambioContattiApiVerificaCambioEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CambioContattiApi
     */
    public verificaCambioEmail(requestParameters: CambioContattiApiVerificaCambioEmailRequest, options?: AxiosRequestConfig) {
        return CambioContattiApiFp(this.configuration).verificaCambioEmail(requestParameters.codiceUtente, requestParameters.verificaCambioEmail, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConfigApi - axios parameter creator
 * @export
 */
export const ConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get current client config (maintenance on/off)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientsConfig: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pub/clients/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigApi - functional programming interface
 * @export
 */
export const ConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get current client config (maintenance on/off)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientsConfig(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientsConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientsConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConfigApi - factory interface
 * @export
 */
export const ConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigApiFp(configuration)
    return {
        /**
         * 
         * @summary Get current client config (maintenance on/off)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientsConfig(options?: any): AxiosPromise<ClientsConfigResponse> {
            return localVarFp.getClientsConfig(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigApi - object-oriented interface
 * @export
 * @class ConfigApi
 * @extends {BaseAPI}
 */
export class ConfigApi extends BaseAPI {
    /**
     * 
     * @summary Get current client config (maintenance on/off)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    public getClientsConfig(options?: AxiosRequestConfig) {
        return ConfigApiFp(this.configuration).getClientsConfig(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConsoleDiAmministrazioneApi - axios parameter creator
 * @export
 */
export const ConsoleDiAmministrazioneApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Ricerca Utenti
         * @param {'CODICE_UTENTE' | 'NOME' | 'COGNOME' | 'RAGIONE_SOCIALE' | 'DATA_ATTIVAZIONE_SERVIZIO' | 'STATO' | 'EMAIL' | 'TELEFONO'} [ordinamentoUtenti] Il criterio di ordinamento della lista di Utenti
         * @param {boolean} [ordinamentoDecrescente] Ordinamento ascendente o discendente
         * @param {number} [page] Paginazione, quale pagina si desidera ricevere tra quelle disponibili
         * @param {string} [nome] ricerca nome PF e nome figura accessoria
         * @param {string} [cognome] ricerca cognome PF e cognome figura accessoria
         * @param {string} [ragioneSociale] ricerca PG
         * @param {string} [codiceUtente] Codice identificativo dell\&#39;utente
         * @param {'ATTIVO' | 'BLOCCATO'} [statoUtenza] ricerca account bloccati o attivi
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cercaUtenti: async (ordinamentoUtenti?: 'CODICE_UTENTE' | 'NOME' | 'COGNOME' | 'RAGIONE_SOCIALE' | 'DATA_ATTIVAZIONE_SERVIZIO' | 'STATO' | 'EMAIL' | 'TELEFONO', ordinamentoDecrescente?: boolean, page?: number, nome?: string, cognome?: string, ragioneSociale?: string, codiceUtente?: string, statoUtenza?: 'ATTIVO' | 'BLOCCATO', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utenti`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordinamentoUtenti !== undefined) {
                localVarQueryParameter['ordinamentoUtenti'] = ordinamentoUtenti;
            }

            if (ordinamentoDecrescente !== undefined) {
                localVarQueryParameter['ordinamentoDecrescente'] = ordinamentoDecrescente;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (nome !== undefined) {
                localVarQueryParameter['nome'] = nome;
            }

            if (cognome !== undefined) {
                localVarQueryParameter['cognome'] = cognome;
            }

            if (ragioneSociale !== undefined) {
                localVarQueryParameter['ragioneSociale'] = ragioneSociale;
            }

            if (codiceUtente !== undefined) {
                localVarQueryParameter['codiceUtente'] = codiceUtente;
            }

            if (statoUtenza !== undefined) {
                localVarQueryParameter['statoUtenza'] = statoUtenza;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Opens a direct trust access account for an acting person of a trust company. 
         * @param {DtaAccountRequest} dtaAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDtaAccount: async (dtaAccountRequest: DtaAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dtaAccountRequest' is not null or undefined
            assertParamExists('createDtaAccount', 'dtaAccountRequest', dtaAccountRequest)
            const localVarPath = `/admin/dta/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dtaAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the direct trust account with this username. The Firebase user is removed and its refresh tokens are revoked. 
         * @param {string} username Login username, FDN plus six digits.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDtaAccount: async (username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('deleteDtaAccount', 'username', username)
            const localVarPath = `/admin/dta/accounts/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generazione ed inoltro del codice di sblocco
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inizializzazioneSbloccoUtenzaDaConsole: async (codiceUtente: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('inizializzazioneSbloccoUtenzaDaConsole', 'codiceUtente', codiceUtente)
            const localVarPath = `/utenti/{codiceUtente}/sblocco`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera Credenziali da console di amministrazione
         * @param {RecuperoCredenzialiRequest} recuperoCredenzialiRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recuperaCredenziali: async (recuperoCredenzialiRequest: RecuperoCredenzialiRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recuperoCredenzialiRequest' is not null or undefined
            assertParamExists('recuperaCredenziali', 'recuperoCredenzialiRequest', recuperoCredenzialiRequest)
            const localVarPath = `/utenti/credenziali/recupero`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recuperoCredenzialiRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sblocco dell\'utenza
         * @param {string} codiceUtente 
         * @param {string} codice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sbloccoUtenzaDaConsole: async (codiceUtente: string, codice: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('sbloccoUtenzaDaConsole', 'codiceUtente', codiceUtente)
            // verify required parameter 'codice' is not null or undefined
            assertParamExists('sbloccoUtenzaDaConsole', 'codice', codice)
            const localVarPath = `/utenti/{codiceUtente}/sblocco/{codice}`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)))
                .replace(`{${"codice"}}`, encodeURIComponent(String(codice)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Searches the direct trust accounts that exist, ordered by username. Criteria are combined with AND. An empty criteria list returns every account, still paged. Repeating a scheme with a different value returns an empty page. 
         * @param {DtaAccountSearchRequest} dtaAccountSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDtaAccounts: async (dtaAccountSearchRequest: DtaAccountSearchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dtaAccountSearchRequest' is not null or undefined
            assertParamExists('searchDtaAccounts', 'dtaAccountSearchRequest', dtaAccountSearchRequest)
            const localVarPath = `/admin/dta/accounts/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dtaAccountSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConsoleDiAmministrazioneApi - functional programming interface
 * @export
 */
export const ConsoleDiAmministrazioneApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConsoleDiAmministrazioneApiAxiosParamCreator(configuration)
    return {
        /**
         * Ricerca Utenti
         * @param {'CODICE_UTENTE' | 'NOME' | 'COGNOME' | 'RAGIONE_SOCIALE' | 'DATA_ATTIVAZIONE_SERVIZIO' | 'STATO' | 'EMAIL' | 'TELEFONO'} [ordinamentoUtenti] Il criterio di ordinamento della lista di Utenti
         * @param {boolean} [ordinamentoDecrescente] Ordinamento ascendente o discendente
         * @param {number} [page] Paginazione, quale pagina si desidera ricevere tra quelle disponibili
         * @param {string} [nome] ricerca nome PF e nome figura accessoria
         * @param {string} [cognome] ricerca cognome PF e cognome figura accessoria
         * @param {string} [ragioneSociale] ricerca PG
         * @param {string} [codiceUtente] Codice identificativo dell\&#39;utente
         * @param {'ATTIVO' | 'BLOCCATO'} [statoUtenza] ricerca account bloccati o attivi
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cercaUtenti(ordinamentoUtenti?: 'CODICE_UTENTE' | 'NOME' | 'COGNOME' | 'RAGIONE_SOCIALE' | 'DATA_ATTIVAZIONE_SERVIZIO' | 'STATO' | 'EMAIL' | 'TELEFONO', ordinamentoDecrescente?: boolean, page?: number, nome?: string, cognome?: string, ragioneSociale?: string, codiceUtente?: string, statoUtenza?: 'ATTIVO' | 'BLOCCATO', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RicercaUtentiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cercaUtenti(ordinamentoUtenti, ordinamentoDecrescente, page, nome, cognome, ragioneSociale, codiceUtente, statoUtenza, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Opens a direct trust access account for an acting person of a trust company. 
         * @param {DtaAccountRequest} dtaAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDtaAccount(dtaAccountRequest: DtaAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DtaAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDtaAccount(dtaAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes the direct trust account with this username. The Firebase user is removed and its refresh tokens are revoked. 
         * @param {string} username Login username, FDN plus six digits.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDtaAccount(username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDtaAccount(username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generazione ed inoltro del codice di sblocco
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inizializzazioneSbloccoUtenzaDaConsole(codiceUtente: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inizializzazioneSbloccoUtenzaDaConsole(codiceUtente, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Recupera Credenziali da console di amministrazione
         * @param {RecuperoCredenzialiRequest} recuperoCredenzialiRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recuperaCredenziali(recuperoCredenzialiRequest: RecuperoCredenzialiRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recuperaCredenziali(recuperoCredenzialiRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sblocco dell\'utenza
         * @param {string} codiceUtente 
         * @param {string} codice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sbloccoUtenzaDaConsole(codiceUtente: string, codice: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sbloccoUtenzaDaConsole(codiceUtente, codice, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Searches the direct trust accounts that exist, ordered by username. Criteria are combined with AND. An empty criteria list returns every account, still paged. Repeating a scheme with a different value returns an empty page. 
         * @param {DtaAccountSearchRequest} dtaAccountSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDtaAccounts(dtaAccountSearchRequest: DtaAccountSearchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DtaAccountSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDtaAccounts(dtaAccountSearchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConsoleDiAmministrazioneApi - factory interface
 * @export
 */
export const ConsoleDiAmministrazioneApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConsoleDiAmministrazioneApiFp(configuration)
    return {
        /**
         * Ricerca Utenti
         * @param {'CODICE_UTENTE' | 'NOME' | 'COGNOME' | 'RAGIONE_SOCIALE' | 'DATA_ATTIVAZIONE_SERVIZIO' | 'STATO' | 'EMAIL' | 'TELEFONO'} [ordinamentoUtenti] Il criterio di ordinamento della lista di Utenti
         * @param {boolean} [ordinamentoDecrescente] Ordinamento ascendente o discendente
         * @param {number} [page] Paginazione, quale pagina si desidera ricevere tra quelle disponibili
         * @param {string} [nome] ricerca nome PF e nome figura accessoria
         * @param {string} [cognome] ricerca cognome PF e cognome figura accessoria
         * @param {string} [ragioneSociale] ricerca PG
         * @param {string} [codiceUtente] Codice identificativo dell\&#39;utente
         * @param {'ATTIVO' | 'BLOCCATO'} [statoUtenza] ricerca account bloccati o attivi
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cercaUtenti(ordinamentoUtenti?: 'CODICE_UTENTE' | 'NOME' | 'COGNOME' | 'RAGIONE_SOCIALE' | 'DATA_ATTIVAZIONE_SERVIZIO' | 'STATO' | 'EMAIL' | 'TELEFONO', ordinamentoDecrescente?: boolean, page?: number, nome?: string, cognome?: string, ragioneSociale?: string, codiceUtente?: string, statoUtenza?: 'ATTIVO' | 'BLOCCATO', options?: any): AxiosPromise<RicercaUtentiResponse> {
            return localVarFp.cercaUtenti(ordinamentoUtenti, ordinamentoDecrescente, page, nome, cognome, ragioneSociale, codiceUtente, statoUtenza, options).then((request) => request(axios, basePath));
        },
        /**
         * Opens a direct trust access account for an acting person of a trust company. 
         * @param {DtaAccountRequest} dtaAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDtaAccount(dtaAccountRequest: DtaAccountRequest, options?: any): AxiosPromise<DtaAccountResponse> {
            return localVarFp.createDtaAccount(dtaAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the direct trust account with this username. The Firebase user is removed and its refresh tokens are revoked. 
         * @param {string} username Login username, FDN plus six digits.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDtaAccount(username: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDtaAccount(username, options).then((request) => request(axios, basePath));
        },
        /**
         * Generazione ed inoltro del codice di sblocco
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inizializzazioneSbloccoUtenzaDaConsole(codiceUtente: string, options?: any): AxiosPromise<void> {
            return localVarFp.inizializzazioneSbloccoUtenzaDaConsole(codiceUtente, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera Credenziali da console di amministrazione
         * @param {RecuperoCredenzialiRequest} recuperoCredenzialiRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recuperaCredenziali(recuperoCredenzialiRequest: RecuperoCredenzialiRequest, options?: any): AxiosPromise<void> {
            return localVarFp.recuperaCredenziali(recuperoCredenzialiRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sblocco dell\'utenza
         * @param {string} codiceUtente 
         * @param {string} codice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sbloccoUtenzaDaConsole(codiceUtente: string, codice: string, options?: any): AxiosPromise<void> {
            return localVarFp.sbloccoUtenzaDaConsole(codiceUtente, codice, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches the direct trust accounts that exist, ordered by username. Criteria are combined with AND. An empty criteria list returns every account, still paged. Repeating a scheme with a different value returns an empty page. 
         * @param {DtaAccountSearchRequest} dtaAccountSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDtaAccounts(dtaAccountSearchRequest: DtaAccountSearchRequest, options?: any): AxiosPromise<DtaAccountSearchResponse> {
            return localVarFp.searchDtaAccounts(dtaAccountSearchRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cercaUtenti operation in ConsoleDiAmministrazioneApi.
 * @export
 * @interface ConsoleDiAmministrazioneApiCercaUtentiRequest
 */
export interface ConsoleDiAmministrazioneApiCercaUtentiRequest {
    /**
     * Il criterio di ordinamento della lista di Utenti
     * @type {'CODICE_UTENTE' | 'NOME' | 'COGNOME' | 'RAGIONE_SOCIALE' | 'DATA_ATTIVAZIONE_SERVIZIO' | 'STATO' | 'EMAIL' | 'TELEFONO'}
     * @memberof ConsoleDiAmministrazioneApiCercaUtenti
     */
    readonly ordinamentoUtenti?: 'CODICE_UTENTE' | 'NOME' | 'COGNOME' | 'RAGIONE_SOCIALE' | 'DATA_ATTIVAZIONE_SERVIZIO' | 'STATO' | 'EMAIL' | 'TELEFONO'

    /**
     * Ordinamento ascendente o discendente
     * @type {boolean}
     * @memberof ConsoleDiAmministrazioneApiCercaUtenti
     */
    readonly ordinamentoDecrescente?: boolean

    /**
     * Paginazione, quale pagina si desidera ricevere tra quelle disponibili
     * @type {number}
     * @memberof ConsoleDiAmministrazioneApiCercaUtenti
     */
    readonly page?: number

    /**
     * ricerca nome PF e nome figura accessoria
     * @type {string}
     * @memberof ConsoleDiAmministrazioneApiCercaUtenti
     */
    readonly nome?: string

    /**
     * ricerca cognome PF e cognome figura accessoria
     * @type {string}
     * @memberof ConsoleDiAmministrazioneApiCercaUtenti
     */
    readonly cognome?: string

    /**
     * ricerca PG
     * @type {string}
     * @memberof ConsoleDiAmministrazioneApiCercaUtenti
     */
    readonly ragioneSociale?: string

    /**
     * Codice identificativo dell\&#39;utente
     * @type {string}
     * @memberof ConsoleDiAmministrazioneApiCercaUtenti
     */
    readonly codiceUtente?: string

    /**
     * ricerca account bloccati o attivi
     * @type {'ATTIVO' | 'BLOCCATO'}
     * @memberof ConsoleDiAmministrazioneApiCercaUtenti
     */
    readonly statoUtenza?: 'ATTIVO' | 'BLOCCATO'
}

/**
 * Request parameters for createDtaAccount operation in ConsoleDiAmministrazioneApi.
 * @export
 * @interface ConsoleDiAmministrazioneApiCreateDtaAccountRequest
 */
export interface ConsoleDiAmministrazioneApiCreateDtaAccountRequest {
    /**
     * 
     * @type {DtaAccountRequest}
     * @memberof ConsoleDiAmministrazioneApiCreateDtaAccount
     */
    readonly dtaAccountRequest: DtaAccountRequest
}

/**
 * Request parameters for deleteDtaAccount operation in ConsoleDiAmministrazioneApi.
 * @export
 * @interface ConsoleDiAmministrazioneApiDeleteDtaAccountRequest
 */
export interface ConsoleDiAmministrazioneApiDeleteDtaAccountRequest {
    /**
     * Login username, FDN plus six digits.
     * @type {string}
     * @memberof ConsoleDiAmministrazioneApiDeleteDtaAccount
     */
    readonly username: string
}

/**
 * Request parameters for inizializzazioneSbloccoUtenzaDaConsole operation in ConsoleDiAmministrazioneApi.
 * @export
 * @interface ConsoleDiAmministrazioneApiInizializzazioneSbloccoUtenzaDaConsoleRequest
 */
export interface ConsoleDiAmministrazioneApiInizializzazioneSbloccoUtenzaDaConsoleRequest {
    /**
     * 
     * @type {string}
     * @memberof ConsoleDiAmministrazioneApiInizializzazioneSbloccoUtenzaDaConsole
     */
    readonly codiceUtente: string
}

/**
 * Request parameters for recuperaCredenziali operation in ConsoleDiAmministrazioneApi.
 * @export
 * @interface ConsoleDiAmministrazioneApiRecuperaCredenzialiRequest
 */
export interface ConsoleDiAmministrazioneApiRecuperaCredenzialiRequest {
    /**
     * 
     * @type {RecuperoCredenzialiRequest}
     * @memberof ConsoleDiAmministrazioneApiRecuperaCredenziali
     */
    readonly recuperoCredenzialiRequest: RecuperoCredenzialiRequest
}

/**
 * Request parameters for sbloccoUtenzaDaConsole operation in ConsoleDiAmministrazioneApi.
 * @export
 * @interface ConsoleDiAmministrazioneApiSbloccoUtenzaDaConsoleRequest
 */
export interface ConsoleDiAmministrazioneApiSbloccoUtenzaDaConsoleRequest {
    /**
     * 
     * @type {string}
     * @memberof ConsoleDiAmministrazioneApiSbloccoUtenzaDaConsole
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {string}
     * @memberof ConsoleDiAmministrazioneApiSbloccoUtenzaDaConsole
     */
    readonly codice: string
}

/**
 * Request parameters for searchDtaAccounts operation in ConsoleDiAmministrazioneApi.
 * @export
 * @interface ConsoleDiAmministrazioneApiSearchDtaAccountsRequest
 */
export interface ConsoleDiAmministrazioneApiSearchDtaAccountsRequest {
    /**
     * 
     * @type {DtaAccountSearchRequest}
     * @memberof ConsoleDiAmministrazioneApiSearchDtaAccounts
     */
    readonly dtaAccountSearchRequest: DtaAccountSearchRequest
}

/**
 * ConsoleDiAmministrazioneApi - object-oriented interface
 * @export
 * @class ConsoleDiAmministrazioneApi
 * @extends {BaseAPI}
 */
export class ConsoleDiAmministrazioneApi extends BaseAPI {
    /**
     * Ricerca Utenti
     * @param {ConsoleDiAmministrazioneApiCercaUtentiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsoleDiAmministrazioneApi
     */
    public cercaUtenti(requestParameters: ConsoleDiAmministrazioneApiCercaUtentiRequest = {}, options?: AxiosRequestConfig) {
        return ConsoleDiAmministrazioneApiFp(this.configuration).cercaUtenti(requestParameters.ordinamentoUtenti, requestParameters.ordinamentoDecrescente, requestParameters.page, requestParameters.nome, requestParameters.cognome, requestParameters.ragioneSociale, requestParameters.codiceUtente, requestParameters.statoUtenza, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Opens a direct trust access account for an acting person of a trust company. 
     * @param {ConsoleDiAmministrazioneApiCreateDtaAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsoleDiAmministrazioneApi
     */
    public createDtaAccount(requestParameters: ConsoleDiAmministrazioneApiCreateDtaAccountRequest, options?: AxiosRequestConfig) {
        return ConsoleDiAmministrazioneApiFp(this.configuration).createDtaAccount(requestParameters.dtaAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the direct trust account with this username. The Firebase user is removed and its refresh tokens are revoked. 
     * @param {ConsoleDiAmministrazioneApiDeleteDtaAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsoleDiAmministrazioneApi
     */
    public deleteDtaAccount(requestParameters: ConsoleDiAmministrazioneApiDeleteDtaAccountRequest, options?: AxiosRequestConfig) {
        return ConsoleDiAmministrazioneApiFp(this.configuration).deleteDtaAccount(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generazione ed inoltro del codice di sblocco
     * @param {ConsoleDiAmministrazioneApiInizializzazioneSbloccoUtenzaDaConsoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsoleDiAmministrazioneApi
     */
    public inizializzazioneSbloccoUtenzaDaConsole(requestParameters: ConsoleDiAmministrazioneApiInizializzazioneSbloccoUtenzaDaConsoleRequest, options?: AxiosRequestConfig) {
        return ConsoleDiAmministrazioneApiFp(this.configuration).inizializzazioneSbloccoUtenzaDaConsole(requestParameters.codiceUtente, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera Credenziali da console di amministrazione
     * @param {ConsoleDiAmministrazioneApiRecuperaCredenzialiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsoleDiAmministrazioneApi
     */
    public recuperaCredenziali(requestParameters: ConsoleDiAmministrazioneApiRecuperaCredenzialiRequest, options?: AxiosRequestConfig) {
        return ConsoleDiAmministrazioneApiFp(this.configuration).recuperaCredenziali(requestParameters.recuperoCredenzialiRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sblocco dell\'utenza
     * @param {ConsoleDiAmministrazioneApiSbloccoUtenzaDaConsoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsoleDiAmministrazioneApi
     */
    public sbloccoUtenzaDaConsole(requestParameters: ConsoleDiAmministrazioneApiSbloccoUtenzaDaConsoleRequest, options?: AxiosRequestConfig) {
        return ConsoleDiAmministrazioneApiFp(this.configuration).sbloccoUtenzaDaConsole(requestParameters.codiceUtente, requestParameters.codice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Searches the direct trust accounts that exist, ordered by username. Criteria are combined with AND. An empty criteria list returns every account, still paged. Repeating a scheme with a different value returns an empty page. 
     * @param {ConsoleDiAmministrazioneApiSearchDtaAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsoleDiAmministrazioneApi
     */
    public searchDtaAccounts(requestParameters: ConsoleDiAmministrazioneApiSearchDtaAccountsRequest, options?: AxiosRequestConfig) {
        return ConsoleDiAmministrazioneApiFp(this.configuration).searchDtaAccounts(requestParameters.dtaAccountSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContattoApi - axios parameter creator
 * @export
 */
export const ContattoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Annulla cambio contatto
         * @param {string} codiceUtente 
         * @param {AnnullaCambioContatto} annullaCambioContatto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annullaCambioContatto: async (codiceUtente: string, annullaCambioContatto: AnnullaCambioContatto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('annullaCambioContatto', 'codiceUtente', codiceUtente)
            // verify required parameter 'annullaCambioContatto' is not null or undefined
            assertParamExists('annullaCambioContatto', 'annullaCambioContatto', annullaCambioContatto)
            const localVarPath = `/utenti/{codiceUtente}/annulla-cambio-contatto`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(annullaCambioContatto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Prepara al cambio contatto
         * @param {string} codiceUtente 
         * @param {PreparaCambioContatto} preparaCambioContatto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preparaCambioContatto: async (codiceUtente: string, preparaCambioContatto: PreparaCambioContatto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('preparaCambioContatto', 'codiceUtente', codiceUtente)
            // verify required parameter 'preparaCambioContatto' is not null or undefined
            assertParamExists('preparaCambioContatto', 'preparaCambioContatto', preparaCambioContatto)
            const localVarPath = `/utenti/{codiceUtente}/prepara-cambio-contatto`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preparaCambioContatto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContattoApi - functional programming interface
 * @export
 */
export const ContattoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContattoApiAxiosParamCreator(configuration)
    return {
        /**
         * Annulla cambio contatto
         * @param {string} codiceUtente 
         * @param {AnnullaCambioContatto} annullaCambioContatto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async annullaCambioContatto(codiceUtente: string, annullaCambioContatto: AnnullaCambioContatto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.annullaCambioContatto(codiceUtente, annullaCambioContatto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Prepara al cambio contatto
         * @param {string} codiceUtente 
         * @param {PreparaCambioContatto} preparaCambioContatto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async preparaCambioContatto(codiceUtente: string, preparaCambioContatto: PreparaCambioContatto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreparaCambioContattoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.preparaCambioContatto(codiceUtente, preparaCambioContatto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContattoApi - factory interface
 * @export
 */
export const ContattoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContattoApiFp(configuration)
    return {
        /**
         * Annulla cambio contatto
         * @param {string} codiceUtente 
         * @param {AnnullaCambioContatto} annullaCambioContatto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annullaCambioContatto(codiceUtente: string, annullaCambioContatto: AnnullaCambioContatto, options?: any): AxiosPromise<void> {
            return localVarFp.annullaCambioContatto(codiceUtente, annullaCambioContatto, options).then((request) => request(axios, basePath));
        },
        /**
         * Prepara al cambio contatto
         * @param {string} codiceUtente 
         * @param {PreparaCambioContatto} preparaCambioContatto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preparaCambioContatto(codiceUtente: string, preparaCambioContatto: PreparaCambioContatto, options?: any): AxiosPromise<PreparaCambioContattoResponse> {
            return localVarFp.preparaCambioContatto(codiceUtente, preparaCambioContatto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for annullaCambioContatto operation in ContattoApi.
 * @export
 * @interface ContattoApiAnnullaCambioContattoRequest
 */
export interface ContattoApiAnnullaCambioContattoRequest {
    /**
     * 
     * @type {string}
     * @memberof ContattoApiAnnullaCambioContatto
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {AnnullaCambioContatto}
     * @memberof ContattoApiAnnullaCambioContatto
     */
    readonly annullaCambioContatto: AnnullaCambioContatto
}

/**
 * Request parameters for preparaCambioContatto operation in ContattoApi.
 * @export
 * @interface ContattoApiPreparaCambioContattoRequest
 */
export interface ContattoApiPreparaCambioContattoRequest {
    /**
     * 
     * @type {string}
     * @memberof ContattoApiPreparaCambioContatto
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {PreparaCambioContatto}
     * @memberof ContattoApiPreparaCambioContatto
     */
    readonly preparaCambioContatto: PreparaCambioContatto
}

/**
 * ContattoApi - object-oriented interface
 * @export
 * @class ContattoApi
 * @extends {BaseAPI}
 */
export class ContattoApi extends BaseAPI {
    /**
     * Annulla cambio contatto
     * @param {ContattoApiAnnullaCambioContattoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContattoApi
     */
    public annullaCambioContatto(requestParameters: ContattoApiAnnullaCambioContattoRequest, options?: AxiosRequestConfig) {
        return ContattoApiFp(this.configuration).annullaCambioContatto(requestParameters.codiceUtente, requestParameters.annullaCambioContatto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Prepara al cambio contatto
     * @param {ContattoApiPreparaCambioContattoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContattoApi
     */
    public preparaCambioContatto(requestParameters: ContattoApiPreparaCambioContattoRequest, options?: AxiosRequestConfig) {
        return ContattoApiFp(this.configuration).preparaCambioContatto(requestParameters.codiceUtente, requestParameters.preparaCambioContatto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Registra l\'avvenuta firma di una disposizione
         * @param {BundleId} bundleId 
         * @param {string} [userAgent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registraDisposizione: async (bundleId: BundleId, userAgent?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bundleId' is not null or undefined
            assertParamExists('registraDisposizione', 'bundleId', bundleId)
            const localVarPath = `/utenti/registra-disposizione`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userAgent != null) {
                localVarHeaderParameter['user-agent'] = String(userAgent);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bundleId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Registra l\'avvenuto completamento di un questionario mifid in self
         * @param {CodiceMifid} [codiceMifid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registraMifid: async (codiceMifid?: CodiceMifid, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utenti/registra-mifid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(codiceMifid, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Registra l\'avvenuta firma di una disposizione
         * @param {BundleId} bundleId 
         * @param {string} [userAgent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registraDisposizione(bundleId: BundleId, userAgent?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registraDisposizione(bundleId, userAgent, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Registra l\'avvenuto completamento di un questionario mifid in self
         * @param {CodiceMifid} [codiceMifid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registraMifid(codiceMifid?: CodiceMifid, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registraMifid(codiceMifid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Registra l\'avvenuta firma di una disposizione
         * @param {BundleId} bundleId 
         * @param {string} [userAgent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registraDisposizione(bundleId: BundleId, userAgent?: string, options?: any): AxiosPromise<void> {
            return localVarFp.registraDisposizione(bundleId, userAgent, options).then((request) => request(axios, basePath));
        },
        /**
         * Registra l\'avvenuto completamento di un questionario mifid in self
         * @param {CodiceMifid} [codiceMifid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registraMifid(codiceMifid?: CodiceMifid, options?: any): AxiosPromise<void> {
            return localVarFp.registraMifid(codiceMifid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for registraDisposizione operation in DefaultApi.
 * @export
 * @interface DefaultApiRegistraDisposizioneRequest
 */
export interface DefaultApiRegistraDisposizioneRequest {
    /**
     * 
     * @type {BundleId}
     * @memberof DefaultApiRegistraDisposizione
     */
    readonly bundleId: BundleId

    /**
     * 
     * @type {string}
     * @memberof DefaultApiRegistraDisposizione
     */
    readonly userAgent?: string
}

/**
 * Request parameters for registraMifid operation in DefaultApi.
 * @export
 * @interface DefaultApiRegistraMifidRequest
 */
export interface DefaultApiRegistraMifidRequest {
    /**
     * 
     * @type {CodiceMifid}
     * @memberof DefaultApiRegistraMifid
     */
    readonly codiceMifid?: CodiceMifid
}

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Registra l\'avvenuta firma di una disposizione
     * @param {DefaultApiRegistraDisposizioneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registraDisposizione(requestParameters: DefaultApiRegistraDisposizioneRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registraDisposizione(requestParameters.bundleId, requestParameters.userAgent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Registra l\'avvenuto completamento di un questionario mifid in self
     * @param {DefaultApiRegistraMifidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registraMifid(requestParameters: DefaultApiRegistraMifidRequest = {}, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registraMifid(requestParameters.codiceMifid, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentAcceptanceApi - axios parameter creator
 * @export
 */
export const DocumentAcceptanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Records the acceptance of a document version by the authenticated user (taken from the JWT). The operation is idempotent: accepting an already accepted version returns 204 without changes. Any existing version can be accepted, even if it is no longer the current one. 
         * @param {DocumentAcceptanceRequest} documentAcceptanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptDocumentVersion: async (documentAcceptanceRequest: DocumentAcceptanceRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentAcceptanceRequest' is not null or undefined
            assertParamExists('acceptDocumentVersion', 'documentAcceptanceRequest', documentAcceptanceRequest)
            const localVarPath = `/utenti/document-acceptances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentAcceptanceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the current version of the requested acceptance document and whether the authenticated user has already accepted it. The user is taken from the JWT. Returns 404 when no version is currently valid for the document type: the app must treat it as \"nothing to accept\". 
         * @param {AcceptanceDocumentType} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentDocumentVersion: async (documentType: AcceptanceDocumentType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('getCurrentDocumentVersion', 'documentType', documentType)
            const localVarPath = `/utenti/document-acceptances/{documentType}`
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentAcceptanceApi - functional programming interface
 * @export
 */
export const DocumentAcceptanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentAcceptanceApiAxiosParamCreator(configuration)
    return {
        /**
         * Records the acceptance of a document version by the authenticated user (taken from the JWT). The operation is idempotent: accepting an already accepted version returns 204 without changes. Any existing version can be accepted, even if it is no longer the current one. 
         * @param {DocumentAcceptanceRequest} documentAcceptanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptDocumentVersion(documentAcceptanceRequest: DocumentAcceptanceRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptDocumentVersion(documentAcceptanceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the current version of the requested acceptance document and whether the authenticated user has already accepted it. The user is taken from the JWT. Returns 404 when no version is currently valid for the document type: the app must treat it as \"nothing to accept\". 
         * @param {AcceptanceDocumentType} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentDocumentVersion(documentType: AcceptanceDocumentType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentDocumentVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentDocumentVersion(documentType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentAcceptanceApi - factory interface
 * @export
 */
export const DocumentAcceptanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentAcceptanceApiFp(configuration)
    return {
        /**
         * Records the acceptance of a document version by the authenticated user (taken from the JWT). The operation is idempotent: accepting an already accepted version returns 204 without changes. Any existing version can be accepted, even if it is no longer the current one. 
         * @param {DocumentAcceptanceRequest} documentAcceptanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptDocumentVersion(documentAcceptanceRequest: DocumentAcceptanceRequest, options?: any): AxiosPromise<void> {
            return localVarFp.acceptDocumentVersion(documentAcceptanceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the current version of the requested acceptance document and whether the authenticated user has already accepted it. The user is taken from the JWT. Returns 404 when no version is currently valid for the document type: the app must treat it as \"nothing to accept\". 
         * @param {AcceptanceDocumentType} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentDocumentVersion(documentType: AcceptanceDocumentType, options?: any): AxiosPromise<CurrentDocumentVersion> {
            return localVarFp.getCurrentDocumentVersion(documentType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for acceptDocumentVersion operation in DocumentAcceptanceApi.
 * @export
 * @interface DocumentAcceptanceApiAcceptDocumentVersionRequest
 */
export interface DocumentAcceptanceApiAcceptDocumentVersionRequest {
    /**
     * 
     * @type {DocumentAcceptanceRequest}
     * @memberof DocumentAcceptanceApiAcceptDocumentVersion
     */
    readonly documentAcceptanceRequest: DocumentAcceptanceRequest
}

/**
 * Request parameters for getCurrentDocumentVersion operation in DocumentAcceptanceApi.
 * @export
 * @interface DocumentAcceptanceApiGetCurrentDocumentVersionRequest
 */
export interface DocumentAcceptanceApiGetCurrentDocumentVersionRequest {
    /**
     * 
     * @type {AcceptanceDocumentType}
     * @memberof DocumentAcceptanceApiGetCurrentDocumentVersion
     */
    readonly documentType: AcceptanceDocumentType
}

/**
 * DocumentAcceptanceApi - object-oriented interface
 * @export
 * @class DocumentAcceptanceApi
 * @extends {BaseAPI}
 */
export class DocumentAcceptanceApi extends BaseAPI {
    /**
     * Records the acceptance of a document version by the authenticated user (taken from the JWT). The operation is idempotent: accepting an already accepted version returns 204 without changes. Any existing version can be accepted, even if it is no longer the current one. 
     * @param {DocumentAcceptanceApiAcceptDocumentVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentAcceptanceApi
     */
    public acceptDocumentVersion(requestParameters: DocumentAcceptanceApiAcceptDocumentVersionRequest, options?: AxiosRequestConfig) {
        return DocumentAcceptanceApiFp(this.configuration).acceptDocumentVersion(requestParameters.documentAcceptanceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the current version of the requested acceptance document and whether the authenticated user has already accepted it. The user is taken from the JWT. Returns 404 when no version is currently valid for the document type: the app must treat it as \"nothing to accept\". 
     * @param {DocumentAcceptanceApiGetCurrentDocumentVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentAcceptanceApi
     */
    public getCurrentDocumentVersion(requestParameters: DocumentAcceptanceApiGetCurrentDocumentVersionRequest, options?: AxiosRequestConfig) {
        return DocumentAcceptanceApiFp(this.configuration).getCurrentDocumentVersion(requestParameters.documentType, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentiApi - axios parameter creator
 * @export
 */
export const DocumentiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Notifica lettura documento
         * @param {NotificaLetturaRequest} notificaLetturaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificaLettura: async (notificaLetturaRequest: NotificaLetturaRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificaLetturaRequest' is not null or undefined
            assertParamExists('notificaLettura', 'notificaLetturaRequest', notificaLetturaRequest)
            const localVarPath = `/documenti/notifica-lettura`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificaLetturaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentiApi - functional programming interface
 * @export
 */
export const DocumentiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentiApiAxiosParamCreator(configuration)
    return {
        /**
         * Notifica lettura documento
         * @param {NotificaLetturaRequest} notificaLetturaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificaLettura(notificaLetturaRequest: NotificaLetturaRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificaLettura(notificaLetturaRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentiApi - factory interface
 * @export
 */
export const DocumentiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentiApiFp(configuration)
    return {
        /**
         * Notifica lettura documento
         * @param {NotificaLetturaRequest} notificaLetturaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificaLettura(notificaLetturaRequest: NotificaLetturaRequest, options?: any): AxiosPromise<void> {
            return localVarFp.notificaLettura(notificaLetturaRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for notificaLettura operation in DocumentiApi.
 * @export
 * @interface DocumentiApiNotificaLetturaRequest
 */
export interface DocumentiApiNotificaLetturaRequest {
    /**
     * 
     * @type {NotificaLetturaRequest}
     * @memberof DocumentiApiNotificaLettura
     */
    readonly notificaLetturaRequest: NotificaLetturaRequest
}

/**
 * DocumentiApi - object-oriented interface
 * @export
 * @class DocumentiApi
 * @extends {BaseAPI}
 */
export class DocumentiApi extends BaseAPI {
    /**
     * Notifica lettura documento
     * @param {DocumentiApiNotificaLetturaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentiApi
     */
    public notificaLettura(requestParameters: DocumentiApiNotificaLetturaRequest, options?: AxiosRequestConfig) {
        return DocumentiApiFp(this.configuration).notificaLettura(requestParameters.notificaLetturaRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FiduciariaApi - axios parameter creator
 * @export
 */
export const FiduciariaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Rubriche associate alla fiduciaria
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRubriche: async (codiceUtente: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('getRubriche', 'codiceUtente', codiceUtente)
            const localVarPath = `/utenti/{codiceUtente}/rubriche`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restituisce informazioni di una specifica rubrica fiduciaria
         * @param {string} customerCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrustCompany: async (customerCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerCode' is not null or undefined
            assertParamExists('getTrustCompany', 'customerCode', customerCode)
            const localVarPath = `/utenti/trustCompany/{customerCode}`
                .replace(`{${"customerCode"}}`, encodeURIComponent(String(customerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generazione di un Token
         * @param {ContextRequest} contextRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setContext: async (contextRequest: ContextRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contextRequest' is not null or undefined
            assertParamExists('setContext', 'contextRequest', contextRequest)
            const localVarPath = `/utenti/set-context`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contextRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FiduciariaApi - functional programming interface
 * @export
 */
export const FiduciariaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FiduciariaApiAxiosParamCreator(configuration)
    return {
        /**
         * Rubriche associate alla fiduciaria
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRubriche(codiceUtente: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Rubriche>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRubriche(codiceUtente, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Restituisce informazioni di una specifica rubrica fiduciaria
         * @param {string} customerCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrustCompany(customerCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrustCompany>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrustCompany(customerCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generazione di un Token
         * @param {ContextRequest} contextRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setContext(contextRequest: ContextRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setContext(contextRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FiduciariaApi - factory interface
 * @export
 */
export const FiduciariaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FiduciariaApiFp(configuration)
    return {
        /**
         * Rubriche associate alla fiduciaria
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRubriche(codiceUtente: string, options?: any): AxiosPromise<Rubriche> {
            return localVarFp.getRubriche(codiceUtente, options).then((request) => request(axios, basePath));
        },
        /**
         * Restituisce informazioni di una specifica rubrica fiduciaria
         * @param {string} customerCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrustCompany(customerCode: string, options?: any): AxiosPromise<TrustCompany> {
            return localVarFp.getTrustCompany(customerCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Generazione di un Token
         * @param {ContextRequest} contextRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setContext(contextRequest: ContextRequest, options?: any): AxiosPromise<SimpleToken> {
            return localVarFp.setContext(contextRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getRubriche operation in FiduciariaApi.
 * @export
 * @interface FiduciariaApiGetRubricheRequest
 */
export interface FiduciariaApiGetRubricheRequest {
    /**
     * 
     * @type {string}
     * @memberof FiduciariaApiGetRubriche
     */
    readonly codiceUtente: string
}

/**
 * Request parameters for getTrustCompany operation in FiduciariaApi.
 * @export
 * @interface FiduciariaApiGetTrustCompanyRequest
 */
export interface FiduciariaApiGetTrustCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof FiduciariaApiGetTrustCompany
     */
    readonly customerCode: string
}

/**
 * Request parameters for setContext operation in FiduciariaApi.
 * @export
 * @interface FiduciariaApiSetContextRequest
 */
export interface FiduciariaApiSetContextRequest {
    /**
     * 
     * @type {ContextRequest}
     * @memberof FiduciariaApiSetContext
     */
    readonly contextRequest: ContextRequest
}

/**
 * FiduciariaApi - object-oriented interface
 * @export
 * @class FiduciariaApi
 * @extends {BaseAPI}
 */
export class FiduciariaApi extends BaseAPI {
    /**
     * Rubriche associate alla fiduciaria
     * @param {FiduciariaApiGetRubricheRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiduciariaApi
     */
    public getRubriche(requestParameters: FiduciariaApiGetRubricheRequest, options?: AxiosRequestConfig) {
        return FiduciariaApiFp(this.configuration).getRubriche(requestParameters.codiceUtente, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restituisce informazioni di una specifica rubrica fiduciaria
     * @param {FiduciariaApiGetTrustCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiduciariaApi
     */
    public getTrustCompany(requestParameters: FiduciariaApiGetTrustCompanyRequest, options?: AxiosRequestConfig) {
        return FiduciariaApiFp(this.configuration).getTrustCompany(requestParameters.customerCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generazione di un Token
     * @param {FiduciariaApiSetContextRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiduciariaApi
     */
    public setContext(requestParameters: FiduciariaApiSetContextRequest, options?: AxiosRequestConfig) {
        return FiduciariaApiFp(this.configuration).setContext(requestParameters.contextRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FondiPensioneApi - axios parameter creator
 * @export
 */
export const FondiPensioneApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Richiedi access token dal portale Previnet Fondi Pensione
         * @param {'FONDI_PENSIONE' | 'SUSTAINABLE_FUTURE'} [polizza] Tipo polizza di cui richiedere access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrevinetAccessToken: async (polizza?: 'FONDI_PENSIONE' | 'SUSTAINABLE_FUTURE', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/previnet-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (polizza !== undefined) {
                localVarQueryParameter['polizza'] = polizza;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FondiPensioneApi - functional programming interface
 * @export
 */
export const FondiPensioneApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FondiPensioneApiAxiosParamCreator(configuration)
    return {
        /**
         * Richiedi access token dal portale Previnet Fondi Pensione
         * @param {'FONDI_PENSIONE' | 'SUSTAINABLE_FUTURE'} [polizza] Tipo polizza di cui richiedere access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrevinetAccessToken(polizza?: 'FONDI_PENSIONE' | 'SUSTAINABLE_FUTURE', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrevinetAccessToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrevinetAccessToken(polizza, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FondiPensioneApi - factory interface
 * @export
 */
export const FondiPensioneApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FondiPensioneApiFp(configuration)
    return {
        /**
         * Richiedi access token dal portale Previnet Fondi Pensione
         * @param {'FONDI_PENSIONE' | 'SUSTAINABLE_FUTURE'} [polizza] Tipo polizza di cui richiedere access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrevinetAccessToken(polizza?: 'FONDI_PENSIONE' | 'SUSTAINABLE_FUTURE', options?: any): AxiosPromise<PrevinetAccessToken> {
            return localVarFp.getPrevinetAccessToken(polizza, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getPrevinetAccessToken operation in FondiPensioneApi.
 * @export
 * @interface FondiPensioneApiGetPrevinetAccessTokenRequest
 */
export interface FondiPensioneApiGetPrevinetAccessTokenRequest {
    /**
     * Tipo polizza di cui richiedere access token
     * @type {'FONDI_PENSIONE' | 'SUSTAINABLE_FUTURE'}
     * @memberof FondiPensioneApiGetPrevinetAccessToken
     */
    readonly polizza?: 'FONDI_PENSIONE' | 'SUSTAINABLE_FUTURE'
}

/**
 * FondiPensioneApi - object-oriented interface
 * @export
 * @class FondiPensioneApi
 * @extends {BaseAPI}
 */
export class FondiPensioneApi extends BaseAPI {
    /**
     * Richiedi access token dal portale Previnet Fondi Pensione
     * @param {FondiPensioneApiGetPrevinetAccessTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FondiPensioneApi
     */
    public getPrevinetAccessToken(requestParameters: FondiPensioneApiGetPrevinetAccessTokenRequest = {}, options?: AxiosRequestConfig) {
        return FondiPensioneApiFp(this.configuration).getPrevinetAccessToken(requestParameters.polizza, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LoginApi - axios parameter creator
 * @export
 */
export const LoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Modifica Password
         * @param {AggiornamentoCredenzialiRequest} aggiornamentoCredenzialiRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cambiaPassword: async (aggiornamentoCredenzialiRequest: AggiornamentoCredenzialiRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggiornamentoCredenzialiRequest' is not null or undefined
            assertParamExists('cambiaPassword', 'aggiornamentoCredenzialiRequest', aggiornamentoCredenzialiRequest)
            const localVarPath = `/utenti/credenziali`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aggiornamentoCredenzialiRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generazione ed inoltro del codice di sblocco
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inizializzazioneSbloccoUtenza: async (codiceUtente: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('inizializzazioneSbloccoUtenza', 'codiceUtente', codiceUtente)
            const localVarPath = `/pub/utenti/{codiceUtente}/sblocco`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generazione di un Token
         * @param {Credenziali} credenziali 
         * @param {string} [userAgent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (credenziali: Credenziali, userAgent?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'credenziali' is not null or undefined
            assertParamExists('login', 'credenziali', credenziali)
            const localVarPath = `/pub/utenti/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userAgent != null) {
                localVarHeaderParameter['user-agent'] = String(userAgent);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(credenziali, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generazione di un Token
         * @param {Credenziali2} credenziali2 
         * @param {string} [userAgent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login2: async (credenziali2: Credenziali2, userAgent?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'credenziali2' is not null or undefined
            assertParamExists('login2', 'credenziali2', credenziali2)
            const localVarPath = `/pub/v2/utenti/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userAgent != null) {
                localVarHeaderParameter['user-agent'] = String(userAgent);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(credenziali2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Primo accesso
         * @param {AggiornamentoCredenzialiRequest} aggiornamentoCredenzialiRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        primoAccesso: async (aggiornamentoCredenzialiRequest: AggiornamentoCredenzialiRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggiornamentoCredenzialiRequest' is not null or undefined
            assertParamExists('primoAccesso', 'aggiornamentoCredenzialiRequest', aggiornamentoCredenzialiRequest)
            const localVarPath = `/pub/utenti/primo-accesso`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aggiornamentoCredenzialiRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera Password
         * @param {RecuperoPasswordRequest} recuperoPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recuperaPassword: async (recuperoPasswordRequest: RecuperoPasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recuperoPasswordRequest' is not null or undefined
            assertParamExists('recuperaPassword', 'recuperoPasswordRequest', recuperoPasswordRequest)
            const localVarPath = `/pub/utenti/credenziali/recupero-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recuperoPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera Username
         * @param {RecuperoUsernameRequest} recuperoUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recuperaUsername: async (recuperoUsernameRequest: RecuperoUsernameRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recuperoUsernameRequest' is not null or undefined
            assertParamExists('recuperaUsername', 'recuperoUsernameRequest', recuperoUsernameRequest)
            const localVarPath = `/pub/utenti/credenziali/recupero-username`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recuperoUsernameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sblocco dell\'utenza
         * @param {string} codiceUtente 
         * @param {string} codice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sbloccoUtenza: async (codiceUtente: string, codice: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('sbloccoUtenza', 'codiceUtente', codiceUtente)
            // verify required parameter 'codice' is not null or undefined
            assertParamExists('sbloccoUtenza', 'codice', codice)
            const localVarPath = `/pub/utenti/{codiceUtente}/sblocco/{codice}`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)))
                .replace(`{${"codice"}}`, encodeURIComponent(String(codice)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns 200 if the provided token is valid, 401 otherwise (missing, expired, revoked). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenIntrospection: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/token/introspection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoginApi - functional programming interface
 * @export
 */
export const LoginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoginApiAxiosParamCreator(configuration)
    return {
        /**
         * Modifica Password
         * @param {AggiornamentoCredenzialiRequest} aggiornamentoCredenzialiRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cambiaPassword(aggiornamentoCredenzialiRequest: AggiornamentoCredenzialiRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cambiaPassword(aggiornamentoCredenzialiRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generazione ed inoltro del codice di sblocco
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inizializzazioneSbloccoUtenza(codiceUtente: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inizializzazioneSbloccoUtenza(codiceUtente, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generazione di un Token
         * @param {Credenziali} credenziali 
         * @param {string} [userAgent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(credenziali: Credenziali, userAgent?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(credenziali, userAgent, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generazione di un Token
         * @param {Credenziali2} credenziali2 
         * @param {string} [userAgent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login2(credenziali2: Credenziali2, userAgent?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login2(credenziali2, userAgent, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Primo accesso
         * @param {AggiornamentoCredenzialiRequest} aggiornamentoCredenzialiRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async primoAccesso(aggiornamentoCredenzialiRequest: AggiornamentoCredenzialiRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.primoAccesso(aggiornamentoCredenzialiRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Recupera Password
         * @param {RecuperoPasswordRequest} recuperoPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recuperaPassword(recuperoPasswordRequest: RecuperoPasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recuperaPassword(recuperoPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Recupera Username
         * @param {RecuperoUsernameRequest} recuperoUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recuperaUsername(recuperoUsernameRequest: RecuperoUsernameRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recuperaUsername(recuperoUsernameRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sblocco dell\'utenza
         * @param {string} codiceUtente 
         * @param {string} codice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sbloccoUtenza(codiceUtente: string, codice: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sbloccoUtenza(codiceUtente, codice, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns 200 if the provided token is valid, 401 otherwise (missing, expired, revoked). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenIntrospection(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenIntrospection(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoginApi - factory interface
 * @export
 */
export const LoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoginApiFp(configuration)
    return {
        /**
         * Modifica Password
         * @param {AggiornamentoCredenzialiRequest} aggiornamentoCredenzialiRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cambiaPassword(aggiornamentoCredenzialiRequest: AggiornamentoCredenzialiRequest, options?: any): AxiosPromise<void> {
            return localVarFp.cambiaPassword(aggiornamentoCredenzialiRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generazione ed inoltro del codice di sblocco
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inizializzazioneSbloccoUtenza(codiceUtente: string, options?: any): AxiosPromise<void> {
            return localVarFp.inizializzazioneSbloccoUtenza(codiceUtente, options).then((request) => request(axios, basePath));
        },
        /**
         * Generazione di un Token
         * @param {Credenziali} credenziali 
         * @param {string} [userAgent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(credenziali: Credenziali, userAgent?: string, options?: any): AxiosPromise<Token> {
            return localVarFp.login(credenziali, userAgent, options).then((request) => request(axios, basePath));
        },
        /**
         * Generazione di un Token
         * @param {Credenziali2} credenziali2 
         * @param {string} [userAgent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login2(credenziali2: Credenziali2, userAgent?: string, options?: any): AxiosPromise<Token2> {
            return localVarFp.login2(credenziali2, userAgent, options).then((request) => request(axios, basePath));
        },
        /**
         * Primo accesso
         * @param {AggiornamentoCredenzialiRequest} aggiornamentoCredenzialiRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        primoAccesso(aggiornamentoCredenzialiRequest: AggiornamentoCredenzialiRequest, options?: any): AxiosPromise<void> {
            return localVarFp.primoAccesso(aggiornamentoCredenzialiRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera Password
         * @param {RecuperoPasswordRequest} recuperoPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recuperaPassword(recuperoPasswordRequest: RecuperoPasswordRequest, options?: any): AxiosPromise<void> {
            return localVarFp.recuperaPassword(recuperoPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera Username
         * @param {RecuperoUsernameRequest} recuperoUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recuperaUsername(recuperoUsernameRequest: RecuperoUsernameRequest, options?: any): AxiosPromise<void> {
            return localVarFp.recuperaUsername(recuperoUsernameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sblocco dell\'utenza
         * @param {string} codiceUtente 
         * @param {string} codice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sbloccoUtenza(codiceUtente: string, codice: string, options?: any): AxiosPromise<string> {
            return localVarFp.sbloccoUtenza(codiceUtente, codice, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns 200 if the provided token is valid, 401 otherwise (missing, expired, revoked). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenIntrospection(options?: any): AxiosPromise<void> {
            return localVarFp.tokenIntrospection(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cambiaPassword operation in LoginApi.
 * @export
 * @interface LoginApiCambiaPasswordRequest
 */
export interface LoginApiCambiaPasswordRequest {
    /**
     * 
     * @type {AggiornamentoCredenzialiRequest}
     * @memberof LoginApiCambiaPassword
     */
    readonly aggiornamentoCredenzialiRequest: AggiornamentoCredenzialiRequest
}

/**
 * Request parameters for inizializzazioneSbloccoUtenza operation in LoginApi.
 * @export
 * @interface LoginApiInizializzazioneSbloccoUtenzaRequest
 */
export interface LoginApiInizializzazioneSbloccoUtenzaRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginApiInizializzazioneSbloccoUtenza
     */
    readonly codiceUtente: string
}

/**
 * Request parameters for login operation in LoginApi.
 * @export
 * @interface LoginApiLoginRequest
 */
export interface LoginApiLoginRequest {
    /**
     * 
     * @type {Credenziali}
     * @memberof LoginApiLogin
     */
    readonly credenziali: Credenziali

    /**
     * 
     * @type {string}
     * @memberof LoginApiLogin
     */
    readonly userAgent?: string
}

/**
 * Request parameters for login2 operation in LoginApi.
 * @export
 * @interface LoginApiLogin2Request
 */
export interface LoginApiLogin2Request {
    /**
     * 
     * @type {Credenziali2}
     * @memberof LoginApiLogin2
     */
    readonly credenziali2: Credenziali2

    /**
     * 
     * @type {string}
     * @memberof LoginApiLogin2
     */
    readonly userAgent?: string
}

/**
 * Request parameters for primoAccesso operation in LoginApi.
 * @export
 * @interface LoginApiPrimoAccessoRequest
 */
export interface LoginApiPrimoAccessoRequest {
    /**
     * 
     * @type {AggiornamentoCredenzialiRequest}
     * @memberof LoginApiPrimoAccesso
     */
    readonly aggiornamentoCredenzialiRequest: AggiornamentoCredenzialiRequest
}

/**
 * Request parameters for recuperaPassword operation in LoginApi.
 * @export
 * @interface LoginApiRecuperaPasswordRequest
 */
export interface LoginApiRecuperaPasswordRequest {
    /**
     * 
     * @type {RecuperoPasswordRequest}
     * @memberof LoginApiRecuperaPassword
     */
    readonly recuperoPasswordRequest: RecuperoPasswordRequest
}

/**
 * Request parameters for recuperaUsername operation in LoginApi.
 * @export
 * @interface LoginApiRecuperaUsernameRequest
 */
export interface LoginApiRecuperaUsernameRequest {
    /**
     * 
     * @type {RecuperoUsernameRequest}
     * @memberof LoginApiRecuperaUsername
     */
    readonly recuperoUsernameRequest: RecuperoUsernameRequest
}

/**
 * Request parameters for sbloccoUtenza operation in LoginApi.
 * @export
 * @interface LoginApiSbloccoUtenzaRequest
 */
export interface LoginApiSbloccoUtenzaRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginApiSbloccoUtenza
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {string}
     * @memberof LoginApiSbloccoUtenza
     */
    readonly codice: string
}

/**
 * LoginApi - object-oriented interface
 * @export
 * @class LoginApi
 * @extends {BaseAPI}
 */
export class LoginApi extends BaseAPI {
    /**
     * Modifica Password
     * @param {LoginApiCambiaPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public cambiaPassword(requestParameters: LoginApiCambiaPasswordRequest, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).cambiaPassword(requestParameters.aggiornamentoCredenzialiRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generazione ed inoltro del codice di sblocco
     * @param {LoginApiInizializzazioneSbloccoUtenzaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public inizializzazioneSbloccoUtenza(requestParameters: LoginApiInizializzazioneSbloccoUtenzaRequest, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).inizializzazioneSbloccoUtenza(requestParameters.codiceUtente, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generazione di un Token
     * @param {LoginApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public login(requestParameters: LoginApiLoginRequest, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).login(requestParameters.credenziali, requestParameters.userAgent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generazione di un Token
     * @param {LoginApiLogin2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public login2(requestParameters: LoginApiLogin2Request, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).login2(requestParameters.credenziali2, requestParameters.userAgent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Primo accesso
     * @param {LoginApiPrimoAccessoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public primoAccesso(requestParameters: LoginApiPrimoAccessoRequest, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).primoAccesso(requestParameters.aggiornamentoCredenzialiRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera Password
     * @param {LoginApiRecuperaPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public recuperaPassword(requestParameters: LoginApiRecuperaPasswordRequest, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).recuperaPassword(requestParameters.recuperoPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera Username
     * @param {LoginApiRecuperaUsernameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public recuperaUsername(requestParameters: LoginApiRecuperaUsernameRequest, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).recuperaUsername(requestParameters.recuperoUsernameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sblocco dell\'utenza
     * @param {LoginApiSbloccoUtenzaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public sbloccoUtenza(requestParameters: LoginApiSbloccoUtenzaRequest, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).sbloccoUtenza(requestParameters.codiceUtente, requestParameters.codice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns 200 if the provided token is valid, 401 otherwise (missing, expired, revoked). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public tokenIntrospection(options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).tokenIntrospection(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LogoutApi - axios parameter creator
 * @export
 */
export const LogoutApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Esegue il logout dell\'utente autenticato: - Invalida il token Firebase ID corrente (blacklist) - Revoca i refresh token Firebase per impedire la generazione di nuovi token ID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utenti/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogoutApi - functional programming interface
 * @export
 */
export const LogoutApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogoutApiAxiosParamCreator(configuration)
    return {
        /**
         * Esegue il logout dell\'utente autenticato: - Invalida il token Firebase ID corrente (blacklist) - Revoca i refresh token Firebase per impedire la generazione di nuovi token ID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Logout200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LogoutApi - factory interface
 * @export
 */
export const LogoutApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogoutApiFp(configuration)
    return {
        /**
         * Esegue il logout dell\'utente autenticato: - Invalida il token Firebase ID corrente (blacklist) - Revoca i refresh token Firebase per impedire la generazione di nuovi token ID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any): AxiosPromise<Logout200Response> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LogoutApi - object-oriented interface
 * @export
 * @class LogoutApi
 * @extends {BaseAPI}
 */
export class LogoutApi extends BaseAPI {
    /**
     * Esegue il logout dell\'utente autenticato: - Invalida il token Firebase ID corrente (blacklist) - Revoca i refresh token Firebase per impedire la generazione di nuovi token ID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogoutApi
     */
    public logout(options?: AxiosRequestConfig) {
        return LogoutApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MarketplaceApi - axios parameter creator
 * @export
 */
export const MarketplaceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Pre-login
         * @param {MarketplaceBaseRequest} marketplaceBaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPreLogin: async (marketplaceBaseRequest: MarketplaceBaseRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'marketplaceBaseRequest' is not null or undefined
            assertParamExists('postPreLogin', 'marketplaceBaseRequest', marketplaceBaseRequest)
            const localVarPath = `/utenti/marketplace/pre-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(marketplaceBaseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sso
         * @param {MarketplaceBaseRequest} marketplaceBaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSso: async (marketplaceBaseRequest: MarketplaceBaseRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'marketplaceBaseRequest' is not null or undefined
            assertParamExists('postSso', 'marketplaceBaseRequest', marketplaceBaseRequest)
            const localVarPath = `/utenti/marketplace/sso`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(marketplaceBaseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketplaceApi - functional programming interface
 * @export
 */
export const MarketplaceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketplaceApiAxiosParamCreator(configuration)
    return {
        /**
         * Pre-login
         * @param {MarketplaceBaseRequest} marketplaceBaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPreLogin(marketplaceBaseRequest: MarketplaceBaseRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPreLogin(marketplaceBaseRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sso
         * @param {MarketplaceBaseRequest} marketplaceBaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSso(marketplaceBaseRequest: MarketplaceBaseRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSso(marketplaceBaseRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MarketplaceApi - factory interface
 * @export
 */
export const MarketplaceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketplaceApiFp(configuration)
    return {
        /**
         * Pre-login
         * @param {MarketplaceBaseRequest} marketplaceBaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPreLogin(marketplaceBaseRequest: MarketplaceBaseRequest, options?: any): AxiosPromise<void> {
            return localVarFp.postPreLogin(marketplaceBaseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sso
         * @param {MarketplaceBaseRequest} marketplaceBaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSso(marketplaceBaseRequest: MarketplaceBaseRequest, options?: any): AxiosPromise<void> {
            return localVarFp.postSso(marketplaceBaseRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for postPreLogin operation in MarketplaceApi.
 * @export
 * @interface MarketplaceApiPostPreLoginRequest
 */
export interface MarketplaceApiPostPreLoginRequest {
    /**
     * 
     * @type {MarketplaceBaseRequest}
     * @memberof MarketplaceApiPostPreLogin
     */
    readonly marketplaceBaseRequest: MarketplaceBaseRequest
}

/**
 * Request parameters for postSso operation in MarketplaceApi.
 * @export
 * @interface MarketplaceApiPostSsoRequest
 */
export interface MarketplaceApiPostSsoRequest {
    /**
     * 
     * @type {MarketplaceBaseRequest}
     * @memberof MarketplaceApiPostSso
     */
    readonly marketplaceBaseRequest: MarketplaceBaseRequest
}

/**
 * MarketplaceApi - object-oriented interface
 * @export
 * @class MarketplaceApi
 * @extends {BaseAPI}
 */
export class MarketplaceApi extends BaseAPI {
    /**
     * Pre-login
     * @param {MarketplaceApiPostPreLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceApi
     */
    public postPreLogin(requestParameters: MarketplaceApiPostPreLoginRequest, options?: AxiosRequestConfig) {
        return MarketplaceApiFp(this.configuration).postPreLogin(requestParameters.marketplaceBaseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sso
     * @param {MarketplaceApiPostSsoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceApi
     */
    public postSso(requestParameters: MarketplaceApiPostSsoRequest, options?: AxiosRequestConfig) {
        return MarketplaceApiFp(this.configuration).postSso(requestParameters.marketplaceBaseRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MediaApi - axios parameter creator
 * @export
 */
export const MediaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API per recuperare video
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideos: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/media/videos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MediaApi - functional programming interface
 * @export
 */
export const MediaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MediaApiAxiosParamCreator(configuration)
    return {
        /**
         * API per recuperare video
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVideos(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoMediaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVideos(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MediaApi - factory interface
 * @export
 */
export const MediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MediaApiFp(configuration)
    return {
        /**
         * API per recuperare video
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideos(options?: any): AxiosPromise<VideoMediaResponse> {
            return localVarFp.getVideos(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MediaApi - object-oriented interface
 * @export
 * @class MediaApi
 * @extends {BaseAPI}
 */
export class MediaApi extends BaseAPI {
    /**
     * API per recuperare video
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public getVideos(options?: AxiosRequestConfig) {
        return MediaApiFp(this.configuration).getVideos(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MifidApi - axios parameter creator
 * @export
 */
export const MifidApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Richiesta dati di precompilazione MIFID dalla pagina di compilazione
         * @param {string} idCliente 
         * @param {string} idIncarico 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMifidPrecompile: async (idCliente: string, idIncarico: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idCliente' is not null or undefined
            assertParamExists('getMifidPrecompile', 'idCliente', idCliente)
            // verify required parameter 'idIncarico' is not null or undefined
            assertParamExists('getMifidPrecompile', 'idIncarico', idIncarico)
            const localVarPath = `/utenti/mifid/{idCliente}/precompile`
                .replace(`{${"idCliente"}}`, encodeURIComponent(String(idCliente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (idIncarico !== undefined) {
                localVarQueryParameter['idIncarico'] = idIncarico;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MifidApi - functional programming interface
 * @export
 */
export const MifidApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MifidApiAxiosParamCreator(configuration)
    return {
        /**
         * Richiesta dati di precompilazione MIFID dalla pagina di compilazione
         * @param {string} idCliente 
         * @param {string} idIncarico 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMifidPrecompile(idCliente: string, idIncarico: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MifidPrecompile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMifidPrecompile(idCliente, idIncarico, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MifidApi - factory interface
 * @export
 */
export const MifidApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MifidApiFp(configuration)
    return {
        /**
         * Richiesta dati di precompilazione MIFID dalla pagina di compilazione
         * @param {string} idCliente 
         * @param {string} idIncarico 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMifidPrecompile(idCliente: string, idIncarico: string, options?: any): AxiosPromise<MifidPrecompile> {
            return localVarFp.getMifidPrecompile(idCliente, idIncarico, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getMifidPrecompile operation in MifidApi.
 * @export
 * @interface MifidApiGetMifidPrecompileRequest
 */
export interface MifidApiGetMifidPrecompileRequest {
    /**
     * 
     * @type {string}
     * @memberof MifidApiGetMifidPrecompile
     */
    readonly idCliente: string

    /**
     * 
     * @type {string}
     * @memberof MifidApiGetMifidPrecompile
     */
    readonly idIncarico: string
}

/**
 * MifidApi - object-oriented interface
 * @export
 * @class MifidApi
 * @extends {BaseAPI}
 */
export class MifidApi extends BaseAPI {
    /**
     * Richiesta dati di precompilazione MIFID dalla pagina di compilazione
     * @param {MifidApiGetMifidPrecompileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MifidApi
     */
    public getMifidPrecompile(requestParameters: MifidApiGetMifidPrecompileRequest, options?: AxiosRequestConfig) {
        return MifidApiFp(this.configuration).getMifidPrecompile(requestParameters.idCliente, requestParameters.idIncarico, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PIRBoxApi - axios parameter creator
 * @export
 */
export const PIRBoxApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Recupera i codici mandato relativo ai pir box dell\'utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pirBoxMandati: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pir-box/mandati`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PIRBoxApi - functional programming interface
 * @export
 */
export const PIRBoxApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PIRBoxApiAxiosParamCreator(configuration)
    return {
        /**
         * Recupera i codici mandato relativo ai pir box dell\'utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pirBoxMandati(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pirBoxMandati(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PIRBoxApi - factory interface
 * @export
 */
export const PIRBoxApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PIRBoxApiFp(configuration)
    return {
        /**
         * Recupera i codici mandato relativo ai pir box dell\'utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pirBoxMandati(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.pirBoxMandati(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PIRBoxApi - object-oriented interface
 * @export
 * @class PIRBoxApi
 * @extends {BaseAPI}
 */
export class PIRBoxApi extends BaseAPI {
    /**
     * Recupera i codici mandato relativo ai pir box dell\'utente
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PIRBoxApi
     */
    public pirBoxMandati(options?: AxiosRequestConfig) {
        return PIRBoxApiFp(this.configuration).pirBoxMandati(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PortafoglioApi - axios parameter creator
 * @export
 */
export const PortafoglioApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Download del report PDF di dettaglio Economia Reale
         * @param {PortafoglioRequest} portafoglioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDettaglioEconomiaReale: async (portafoglioRequest: PortafoglioRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portafoglioRequest' is not null or undefined
            assertParamExists('downloadDettaglioEconomiaReale', 'portafoglioRequest', portafoglioRequest)
            const localVarPath = `/portafoglio/economia-reale/dettaglio/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portafoglioRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download dei movimenti di un prodotto
         * @param {string} prodotto L\&#39;identificativo di un prodotto
         * @param {string} contratto L\&#39;identificativo di un contratto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMovimenti: async (prodotto: string, contratto: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prodotto' is not null or undefined
            assertParamExists('downloadMovimenti', 'prodotto', prodotto)
            // verify required parameter 'contratto' is not null or undefined
            assertParamExists('downloadMovimenti', 'contratto', contratto)
            const localVarPath = `/portafoglio/posizioni/{contratto}/{prodotto}/movimenti/download`
                .replace(`{${"prodotto"}}`, encodeURIComponent(String(prodotto)))
                .replace(`{${"contratto"}}`, encodeURIComponent(String(contratto)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download delle performance del portafoglio del cliente
         * @param {'GESTITO_ASSICURATIVO_FINANZIARIO' | 'AMMINISTRATO' | 'ECONOMIA_REALE' | 'PREVIDENZA'} macroCategoria La macrocategoria dei prodotti
         * @param {PortafoglioRequest} portafoglioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPerformance: async (macroCategoria: 'GESTITO_ASSICURATIVO_FINANZIARIO' | 'AMMINISTRATO' | 'ECONOMIA_REALE' | 'PREVIDENZA', portafoglioRequest: PortafoglioRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'macroCategoria' is not null or undefined
            assertParamExists('downloadPerformance', 'macroCategoria', macroCategoria)
            // verify required parameter 'portafoglioRequest' is not null or undefined
            assertParamExists('downloadPerformance', 'portafoglioRequest', portafoglioRequest)
            const localVarPath = `/portafoglio/performance/macrocategorie/{macroCategoria}/download`
                .replace(`{${"macroCategoria"}}`, encodeURIComponent(String(macroCategoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portafoglioRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download dei file PDF oppure XLSX con l\'elenco posizioni
         * @param {PortafoglioRequest} portafoglioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPosizioni: async (portafoglioRequest: PortafoglioRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portafoglioRequest' is not null or undefined
            assertParamExists('downloadPosizioni', 'portafoglioRequest', portafoglioRequest)
            const localVarPath = `/portafoglio/posizioni/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portafoglioRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download dei sottostanti di un prodotto
         * @param {string} prodotto L\&#39;identificativo di un prodotto
         * @param {string} contratto L\&#39;identificativo di un contratto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSottostanti: async (prodotto: string, contratto: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prodotto' is not null or undefined
            assertParamExists('downloadSottostanti', 'prodotto', prodotto)
            // verify required parameter 'contratto' is not null or undefined
            assertParamExists('downloadSottostanti', 'contratto', contratto)
            const localVarPath = `/portafoglio/posizioni/{contratto}/{prodotto}/sottostanti/download`
                .replace(`{${"prodotto"}}`, encodeURIComponent(String(prodotto)))
                .replace(`{${"contratto"}}`, encodeURIComponent(String(contratto)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera le aziende sottostanti dei prodotti di economia reale del cliente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        erAziendeSottostanti: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portafoglio/economia-reale/aziende-sottostanti`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera la gerarchia dei dossier relativi all\'utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gerarchiaDossier: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portafoglio/dossier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera il factsheet (PDF) di un fondo tramite codice ISIN.
         * @param {string} codiceISIN Codice ISIN del fondo (formato standard 12 caratteri alfanumerici)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedaProdotto: async (codiceISIN: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceISIN' is not null or undefined
            assertParamExists('getSchedaProdotto', 'codiceISIN', codiceISIN)
            const localVarPath = `/portafoglio/posizioni/{codiceISIN}/scheda-prodotto`
                .replace(`{${"codiceISIN"}}`, encodeURIComponent(String(codiceISIN)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Movimenti di un prodotto
         * @param {string} prodotto L\&#39;identificativo di un prodotto
         * @param {string} contratto L\&#39;identificativo di un contratto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        movimenti: async (prodotto: string, contratto: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prodotto' is not null or undefined
            assertParamExists('movimenti', 'prodotto', prodotto)
            // verify required parameter 'contratto' is not null or undefined
            assertParamExists('movimenti', 'contratto', contratto)
            const localVarPath = `/portafoglio/posizioni/{contratto}/{prodotto}/movimenti`
                .replace(`{${"prodotto"}}`, encodeURIComponent(String(prodotto)))
                .replace(`{${"contratto"}}`, encodeURIComponent(String(contratto)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera le performance del portafoglio del cliente
         * @param {'GESTITO_ASSICURATIVO_FINANZIARIO' | 'AMMINISTRATO' | 'ECONOMIA_REALE' | 'PREVIDENZA'} macroCategoria La macrocategoria dei prodotti
         * @param {PortafoglioRequest} portafoglioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performance: async (macroCategoria: 'GESTITO_ASSICURATIVO_FINANZIARIO' | 'AMMINISTRATO' | 'ECONOMIA_REALE' | 'PREVIDENZA', portafoglioRequest: PortafoglioRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'macroCategoria' is not null or undefined
            assertParamExists('performance', 'macroCategoria', macroCategoria)
            // verify required parameter 'portafoglioRequest' is not null or undefined
            assertParamExists('performance', 'portafoglioRequest', portafoglioRequest)
            const localVarPath = `/portafoglio/performance/macrocategorie/{macroCategoria}`
                .replace(`{${"macroCategoria"}}`, encodeURIComponent(String(macroCategoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portafoglioRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download del dettaglio del pirbox in oggetto
         * @param {string} codRapportoPir Il codice rapporto pir
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pirBoxDownload: async (codRapportoPir: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codRapportoPir' is not null or undefined
            assertParamExists('pirBoxDownload', 'codRapportoPir', codRapportoPir)
            const localVarPath = `/pir-box/{codRapportoPir}/download`
                .replace(`{${"codRapportoPir"}}`, encodeURIComponent(String(codRapportoPir)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera il portafoglio del cliente (posizioni + summary)
         * @param {PortafoglioRequest} portafoglioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portafoglio: async (portafoglioRequest: PortafoglioRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portafoglioRequest' is not null or undefined
            assertParamExists('portafoglio', 'portafoglioRequest', portafoglioRequest)
            const localVarPath = `/portafoglio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portafoglioRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sottostanti di un prodotto
         * @param {string} prodotto L\&#39;identificativo di un prodotto
         * @param {string} contratto L\&#39;identificativo di un contratto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sottostanti: async (prodotto: string, contratto: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prodotto' is not null or undefined
            assertParamExists('sottostanti', 'prodotto', prodotto)
            // verify required parameter 'contratto' is not null or undefined
            assertParamExists('sottostanti', 'contratto', contratto)
            const localVarPath = `/portafoglio/posizioni/{contratto}/{prodotto}/sottostanti`
                .replace(`{${"prodotto"}}`, encodeURIComponent(String(prodotto)))
                .replace(`{${"contratto"}}`, encodeURIComponent(String(contratto)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortafoglioApi - functional programming interface
 * @export
 */
export const PortafoglioApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortafoglioApiAxiosParamCreator(configuration)
    return {
        /**
         * Download del report PDF di dettaglio Economia Reale
         * @param {PortafoglioRequest} portafoglioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDettaglioEconomiaReale(portafoglioRequest: PortafoglioRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDettaglioEconomiaReale(portafoglioRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download dei movimenti di un prodotto
         * @param {string} prodotto L\&#39;identificativo di un prodotto
         * @param {string} contratto L\&#39;identificativo di un contratto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadMovimenti(prodotto: string, contratto: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadMovimenti(prodotto, contratto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download delle performance del portafoglio del cliente
         * @param {'GESTITO_ASSICURATIVO_FINANZIARIO' | 'AMMINISTRATO' | 'ECONOMIA_REALE' | 'PREVIDENZA'} macroCategoria La macrocategoria dei prodotti
         * @param {PortafoglioRequest} portafoglioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPerformance(macroCategoria: 'GESTITO_ASSICURATIVO_FINANZIARIO' | 'AMMINISTRATO' | 'ECONOMIA_REALE' | 'PREVIDENZA', portafoglioRequest: PortafoglioRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPerformance(macroCategoria, portafoglioRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download dei file PDF oppure XLSX con l\'elenco posizioni
         * @param {PortafoglioRequest} portafoglioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPosizioni(portafoglioRequest: PortafoglioRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPosizioni(portafoglioRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download dei sottostanti di un prodotto
         * @param {string} prodotto L\&#39;identificativo di un prodotto
         * @param {string} contratto L\&#39;identificativo di un contratto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSottostanti(prodotto: string, contratto: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSottostanti(prodotto, contratto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Recupera le aziende sottostanti dei prodotti di economia reale del cliente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async erAziendeSottostanti(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AziendeSottostantiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.erAziendeSottostanti(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Recupera la gerarchia dei dossier relativi all\'utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gerarchiaDossier(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DossierItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gerarchiaDossier(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Recupera il factsheet (PDF) di un fondo tramite codice ISIN.
         * @param {string} codiceISIN Codice ISIN del fondo (formato standard 12 caratteri alfanumerici)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchedaProdotto(codiceISIN: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchedaProdotto(codiceISIN, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Movimenti di un prodotto
         * @param {string} prodotto L\&#39;identificativo di un prodotto
         * @param {string} contratto L\&#39;identificativo di un contratto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async movimenti(prodotto: string, contratto: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WrapperMovimenti>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.movimenti(prodotto, contratto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Recupera le performance del portafoglio del cliente
         * @param {'GESTITO_ASSICURATIVO_FINANZIARIO' | 'AMMINISTRATO' | 'ECONOMIA_REALE' | 'PREVIDENZA'} macroCategoria La macrocategoria dei prodotti
         * @param {PortafoglioRequest} portafoglioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async performance(macroCategoria: 'GESTITO_ASSICURATIVO_FINANZIARIO' | 'AMMINISTRATO' | 'ECONOMIA_REALE' | 'PREVIDENZA', portafoglioRequest: PortafoglioRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Performance>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.performance(macroCategoria, portafoglioRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download del dettaglio del pirbox in oggetto
         * @param {string} codRapportoPir Il codice rapporto pir
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pirBoxDownload(codRapportoPir: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pirBoxDownload(codRapportoPir, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Recupera il portafoglio del cliente (posizioni + summary)
         * @param {PortafoglioRequest} portafoglioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portafoglio(portafoglioRequest: PortafoglioRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Portafoglio>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portafoglio(portafoglioRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sottostanti di un prodotto
         * @param {string} prodotto L\&#39;identificativo di un prodotto
         * @param {string} contratto L\&#39;identificativo di un contratto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sottostanti(prodotto: string, contratto: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sottostanti>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sottostanti(prodotto, contratto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PortafoglioApi - factory interface
 * @export
 */
export const PortafoglioApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortafoglioApiFp(configuration)
    return {
        /**
         * Download del report PDF di dettaglio Economia Reale
         * @param {PortafoglioRequest} portafoglioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDettaglioEconomiaReale(portafoglioRequest: PortafoglioRequest, options?: any): AxiosPromise<File> {
            return localVarFp.downloadDettaglioEconomiaReale(portafoglioRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download dei movimenti di un prodotto
         * @param {string} prodotto L\&#39;identificativo di un prodotto
         * @param {string} contratto L\&#39;identificativo di un contratto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMovimenti(prodotto: string, contratto: string, options?: any): AxiosPromise<File> {
            return localVarFp.downloadMovimenti(prodotto, contratto, options).then((request) => request(axios, basePath));
        },
        /**
         * Download delle performance del portafoglio del cliente
         * @param {'GESTITO_ASSICURATIVO_FINANZIARIO' | 'AMMINISTRATO' | 'ECONOMIA_REALE' | 'PREVIDENZA'} macroCategoria La macrocategoria dei prodotti
         * @param {PortafoglioRequest} portafoglioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPerformance(macroCategoria: 'GESTITO_ASSICURATIVO_FINANZIARIO' | 'AMMINISTRATO' | 'ECONOMIA_REALE' | 'PREVIDENZA', portafoglioRequest: PortafoglioRequest, options?: any): AxiosPromise<File> {
            return localVarFp.downloadPerformance(macroCategoria, portafoglioRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download dei file PDF oppure XLSX con l\'elenco posizioni
         * @param {PortafoglioRequest} portafoglioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPosizioni(portafoglioRequest: PortafoglioRequest, options?: any): AxiosPromise<File> {
            return localVarFp.downloadPosizioni(portafoglioRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download dei sottostanti di un prodotto
         * @param {string} prodotto L\&#39;identificativo di un prodotto
         * @param {string} contratto L\&#39;identificativo di un contratto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSottostanti(prodotto: string, contratto: string, options?: any): AxiosPromise<File> {
            return localVarFp.downloadSottostanti(prodotto, contratto, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera le aziende sottostanti dei prodotti di economia reale del cliente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        erAziendeSottostanti(options?: any): AxiosPromise<AziendeSottostantiResponse> {
            return localVarFp.erAziendeSottostanti(options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera la gerarchia dei dossier relativi all\'utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gerarchiaDossier(options?: any): AxiosPromise<Array<DossierItem>> {
            return localVarFp.gerarchiaDossier(options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera il factsheet (PDF) di un fondo tramite codice ISIN.
         * @param {string} codiceISIN Codice ISIN del fondo (formato standard 12 caratteri alfanumerici)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedaProdotto(codiceISIN: string, options?: any): AxiosPromise<File> {
            return localVarFp.getSchedaProdotto(codiceISIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Movimenti di un prodotto
         * @param {string} prodotto L\&#39;identificativo di un prodotto
         * @param {string} contratto L\&#39;identificativo di un contratto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        movimenti(prodotto: string, contratto: string, options?: any): AxiosPromise<WrapperMovimenti> {
            return localVarFp.movimenti(prodotto, contratto, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera le performance del portafoglio del cliente
         * @param {'GESTITO_ASSICURATIVO_FINANZIARIO' | 'AMMINISTRATO' | 'ECONOMIA_REALE' | 'PREVIDENZA'} macroCategoria La macrocategoria dei prodotti
         * @param {PortafoglioRequest} portafoglioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performance(macroCategoria: 'GESTITO_ASSICURATIVO_FINANZIARIO' | 'AMMINISTRATO' | 'ECONOMIA_REALE' | 'PREVIDENZA', portafoglioRequest: PortafoglioRequest, options?: any): AxiosPromise<Performance> {
            return localVarFp.performance(macroCategoria, portafoglioRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download del dettaglio del pirbox in oggetto
         * @param {string} codRapportoPir Il codice rapporto pir
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pirBoxDownload(codRapportoPir: string, options?: any): AxiosPromise<File> {
            return localVarFp.pirBoxDownload(codRapportoPir, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera il portafoglio del cliente (posizioni + summary)
         * @param {PortafoglioRequest} portafoglioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portafoglio(portafoglioRequest: PortafoglioRequest, options?: any): AxiosPromise<Portafoglio> {
            return localVarFp.portafoglio(portafoglioRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sottostanti di un prodotto
         * @param {string} prodotto L\&#39;identificativo di un prodotto
         * @param {string} contratto L\&#39;identificativo di un contratto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sottostanti(prodotto: string, contratto: string, options?: any): AxiosPromise<Sottostanti> {
            return localVarFp.sottostanti(prodotto, contratto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for downloadDettaglioEconomiaReale operation in PortafoglioApi.
 * @export
 * @interface PortafoglioApiDownloadDettaglioEconomiaRealeRequest
 */
export interface PortafoglioApiDownloadDettaglioEconomiaRealeRequest {
    /**
     * 
     * @type {PortafoglioRequest}
     * @memberof PortafoglioApiDownloadDettaglioEconomiaReale
     */
    readonly portafoglioRequest: PortafoglioRequest
}

/**
 * Request parameters for downloadMovimenti operation in PortafoglioApi.
 * @export
 * @interface PortafoglioApiDownloadMovimentiRequest
 */
export interface PortafoglioApiDownloadMovimentiRequest {
    /**
     * L\&#39;identificativo di un prodotto
     * @type {string}
     * @memberof PortafoglioApiDownloadMovimenti
     */
    readonly prodotto: string

    /**
     * L\&#39;identificativo di un contratto
     * @type {string}
     * @memberof PortafoglioApiDownloadMovimenti
     */
    readonly contratto: string
}

/**
 * Request parameters for downloadPerformance operation in PortafoglioApi.
 * @export
 * @interface PortafoglioApiDownloadPerformanceRequest
 */
export interface PortafoglioApiDownloadPerformanceRequest {
    /**
     * La macrocategoria dei prodotti
     * @type {'GESTITO_ASSICURATIVO_FINANZIARIO' | 'AMMINISTRATO' | 'ECONOMIA_REALE' | 'PREVIDENZA'}
     * @memberof PortafoglioApiDownloadPerformance
     */
    readonly macroCategoria: 'GESTITO_ASSICURATIVO_FINANZIARIO' | 'AMMINISTRATO' | 'ECONOMIA_REALE' | 'PREVIDENZA'

    /**
     * 
     * @type {PortafoglioRequest}
     * @memberof PortafoglioApiDownloadPerformance
     */
    readonly portafoglioRequest: PortafoglioRequest
}

/**
 * Request parameters for downloadPosizioni operation in PortafoglioApi.
 * @export
 * @interface PortafoglioApiDownloadPosizioniRequest
 */
export interface PortafoglioApiDownloadPosizioniRequest {
    /**
     * 
     * @type {PortafoglioRequest}
     * @memberof PortafoglioApiDownloadPosizioni
     */
    readonly portafoglioRequest: PortafoglioRequest
}

/**
 * Request parameters for downloadSottostanti operation in PortafoglioApi.
 * @export
 * @interface PortafoglioApiDownloadSottostantiRequest
 */
export interface PortafoglioApiDownloadSottostantiRequest {
    /**
     * L\&#39;identificativo di un prodotto
     * @type {string}
     * @memberof PortafoglioApiDownloadSottostanti
     */
    readonly prodotto: string

    /**
     * L\&#39;identificativo di un contratto
     * @type {string}
     * @memberof PortafoglioApiDownloadSottostanti
     */
    readonly contratto: string
}

/**
 * Request parameters for getSchedaProdotto operation in PortafoglioApi.
 * @export
 * @interface PortafoglioApiGetSchedaProdottoRequest
 */
export interface PortafoglioApiGetSchedaProdottoRequest {
    /**
     * Codice ISIN del fondo (formato standard 12 caratteri alfanumerici)
     * @type {string}
     * @memberof PortafoglioApiGetSchedaProdotto
     */
    readonly codiceISIN: string
}

/**
 * Request parameters for movimenti operation in PortafoglioApi.
 * @export
 * @interface PortafoglioApiMovimentiRequest
 */
export interface PortafoglioApiMovimentiRequest {
    /**
     * L\&#39;identificativo di un prodotto
     * @type {string}
     * @memberof PortafoglioApiMovimenti
     */
    readonly prodotto: string

    /**
     * L\&#39;identificativo di un contratto
     * @type {string}
     * @memberof PortafoglioApiMovimenti
     */
    readonly contratto: string
}

/**
 * Request parameters for performance operation in PortafoglioApi.
 * @export
 * @interface PortafoglioApiPerformanceRequest
 */
export interface PortafoglioApiPerformanceRequest {
    /**
     * La macrocategoria dei prodotti
     * @type {'GESTITO_ASSICURATIVO_FINANZIARIO' | 'AMMINISTRATO' | 'ECONOMIA_REALE' | 'PREVIDENZA'}
     * @memberof PortafoglioApiPerformance
     */
    readonly macroCategoria: 'GESTITO_ASSICURATIVO_FINANZIARIO' | 'AMMINISTRATO' | 'ECONOMIA_REALE' | 'PREVIDENZA'

    /**
     * 
     * @type {PortafoglioRequest}
     * @memberof PortafoglioApiPerformance
     */
    readonly portafoglioRequest: PortafoglioRequest
}

/**
 * Request parameters for pirBoxDownload operation in PortafoglioApi.
 * @export
 * @interface PortafoglioApiPirBoxDownloadRequest
 */
export interface PortafoglioApiPirBoxDownloadRequest {
    /**
     * Il codice rapporto pir
     * @type {string}
     * @memberof PortafoglioApiPirBoxDownload
     */
    readonly codRapportoPir: string
}

/**
 * Request parameters for portafoglio operation in PortafoglioApi.
 * @export
 * @interface PortafoglioApiPortafoglioRequest
 */
export interface PortafoglioApiPortafoglioRequest {
    /**
     * 
     * @type {PortafoglioRequest}
     * @memberof PortafoglioApiPortafoglio
     */
    readonly portafoglioRequest: PortafoglioRequest
}

/**
 * Request parameters for sottostanti operation in PortafoglioApi.
 * @export
 * @interface PortafoglioApiSottostantiRequest
 */
export interface PortafoglioApiSottostantiRequest {
    /**
     * L\&#39;identificativo di un prodotto
     * @type {string}
     * @memberof PortafoglioApiSottostanti
     */
    readonly prodotto: string

    /**
     * L\&#39;identificativo di un contratto
     * @type {string}
     * @memberof PortafoglioApiSottostanti
     */
    readonly contratto: string
}

/**
 * PortafoglioApi - object-oriented interface
 * @export
 * @class PortafoglioApi
 * @extends {BaseAPI}
 */
export class PortafoglioApi extends BaseAPI {
    /**
     * Download del report PDF di dettaglio Economia Reale
     * @param {PortafoglioApiDownloadDettaglioEconomiaRealeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortafoglioApi
     */
    public downloadDettaglioEconomiaReale(requestParameters: PortafoglioApiDownloadDettaglioEconomiaRealeRequest, options?: AxiosRequestConfig) {
        return PortafoglioApiFp(this.configuration).downloadDettaglioEconomiaReale(requestParameters.portafoglioRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download dei movimenti di un prodotto
     * @param {PortafoglioApiDownloadMovimentiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortafoglioApi
     */
    public downloadMovimenti(requestParameters: PortafoglioApiDownloadMovimentiRequest, options?: AxiosRequestConfig) {
        return PortafoglioApiFp(this.configuration).downloadMovimenti(requestParameters.prodotto, requestParameters.contratto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download delle performance del portafoglio del cliente
     * @param {PortafoglioApiDownloadPerformanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortafoglioApi
     */
    public downloadPerformance(requestParameters: PortafoglioApiDownloadPerformanceRequest, options?: AxiosRequestConfig) {
        return PortafoglioApiFp(this.configuration).downloadPerformance(requestParameters.macroCategoria, requestParameters.portafoglioRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download dei file PDF oppure XLSX con l\'elenco posizioni
     * @param {PortafoglioApiDownloadPosizioniRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortafoglioApi
     */
    public downloadPosizioni(requestParameters: PortafoglioApiDownloadPosizioniRequest, options?: AxiosRequestConfig) {
        return PortafoglioApiFp(this.configuration).downloadPosizioni(requestParameters.portafoglioRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download dei sottostanti di un prodotto
     * @param {PortafoglioApiDownloadSottostantiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortafoglioApi
     */
    public downloadSottostanti(requestParameters: PortafoglioApiDownloadSottostantiRequest, options?: AxiosRequestConfig) {
        return PortafoglioApiFp(this.configuration).downloadSottostanti(requestParameters.prodotto, requestParameters.contratto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera le aziende sottostanti dei prodotti di economia reale del cliente
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortafoglioApi
     */
    public erAziendeSottostanti(options?: AxiosRequestConfig) {
        return PortafoglioApiFp(this.configuration).erAziendeSottostanti(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera la gerarchia dei dossier relativi all\'utente
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortafoglioApi
     */
    public gerarchiaDossier(options?: AxiosRequestConfig) {
        return PortafoglioApiFp(this.configuration).gerarchiaDossier(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera il factsheet (PDF) di un fondo tramite codice ISIN.
     * @param {PortafoglioApiGetSchedaProdottoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortafoglioApi
     */
    public getSchedaProdotto(requestParameters: PortafoglioApiGetSchedaProdottoRequest, options?: AxiosRequestConfig) {
        return PortafoglioApiFp(this.configuration).getSchedaProdotto(requestParameters.codiceISIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Movimenti di un prodotto
     * @param {PortafoglioApiMovimentiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortafoglioApi
     */
    public movimenti(requestParameters: PortafoglioApiMovimentiRequest, options?: AxiosRequestConfig) {
        return PortafoglioApiFp(this.configuration).movimenti(requestParameters.prodotto, requestParameters.contratto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera le performance del portafoglio del cliente
     * @param {PortafoglioApiPerformanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortafoglioApi
     */
    public performance(requestParameters: PortafoglioApiPerformanceRequest, options?: AxiosRequestConfig) {
        return PortafoglioApiFp(this.configuration).performance(requestParameters.macroCategoria, requestParameters.portafoglioRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download del dettaglio del pirbox in oggetto
     * @param {PortafoglioApiPirBoxDownloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortafoglioApi
     */
    public pirBoxDownload(requestParameters: PortafoglioApiPirBoxDownloadRequest, options?: AxiosRequestConfig) {
        return PortafoglioApiFp(this.configuration).pirBoxDownload(requestParameters.codRapportoPir, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera il portafoglio del cliente (posizioni + summary)
     * @param {PortafoglioApiPortafoglioRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortafoglioApi
     */
    public portafoglio(requestParameters: PortafoglioApiPortafoglioRequest, options?: AxiosRequestConfig) {
        return PortafoglioApiFp(this.configuration).portafoglio(requestParameters.portafoglioRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sottostanti di un prodotto
     * @param {PortafoglioApiSottostantiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortafoglioApi
     */
    public sottostanti(requestParameters: PortafoglioApiSottostantiRequest, options?: AxiosRequestConfig) {
        return PortafoglioApiFp(this.configuration).sottostanti(requestParameters.prodotto, requestParameters.contratto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProspectApi - axios parameter creator
 * @export
 */
export const ProspectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update customer code
         * @param {UpdateCustomerCodeRequest} updateCustomerCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerCode: async (updateCustomerCodeRequest: UpdateCustomerCodeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCustomerCodeRequest' is not null or undefined
            assertParamExists('updateCustomerCode', 'updateCustomerCodeRequest', updateCustomerCodeRequest)
            const localVarPath = `/prospect/update-customer-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomerCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProspectApi - functional programming interface
 * @export
 */
export const ProspectApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProspectApiAxiosParamCreator(configuration)
    return {
        /**
         * Update customer code
         * @param {UpdateCustomerCodeRequest} updateCustomerCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerCode(updateCustomerCodeRequest: UpdateCustomerCodeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerCode(updateCustomerCodeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProspectApi - factory interface
 * @export
 */
export const ProspectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProspectApiFp(configuration)
    return {
        /**
         * Update customer code
         * @param {UpdateCustomerCodeRequest} updateCustomerCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerCode(updateCustomerCodeRequest: UpdateCustomerCodeRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateCustomerCode(updateCustomerCodeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for updateCustomerCode operation in ProspectApi.
 * @export
 * @interface ProspectApiUpdateCustomerCodeRequest
 */
export interface ProspectApiUpdateCustomerCodeRequest {
    /**
     * 
     * @type {UpdateCustomerCodeRequest}
     * @memberof ProspectApiUpdateCustomerCode
     */
    readonly updateCustomerCodeRequest: UpdateCustomerCodeRequest
}

/**
 * ProspectApi - object-oriented interface
 * @export
 * @class ProspectApi
 * @extends {BaseAPI}
 */
export class ProspectApi extends BaseAPI {
    /**
     * Update customer code
     * @param {ProspectApiUpdateCustomerCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProspectApi
     */
    public updateCustomerCode(requestParameters: ProspectApiUpdateCustomerCodeRequest, options?: AxiosRequestConfig) {
        return ProspectApiFp(this.configuration).updateCustomerCode(requestParameters.updateCustomerCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProspectDocumentsApi - axios parameter creator
 * @export
 */
export const ProspectDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Reset documents questionnaire and update status pratica
         * @param {ResetDocumentsQuestionnaireRequest} resetDocumentsQuestionnaireRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetDocumentsQuestionnaire: async (resetDocumentsQuestionnaireRequest: ResetDocumentsQuestionnaireRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetDocumentsQuestionnaireRequest' is not null or undefined
            assertParamExists('resetDocumentsQuestionnaire', 'resetDocumentsQuestionnaireRequest', resetDocumentsQuestionnaireRequest)
            const localVarPath = `/prospect/documents/reset-questionnaire`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetDocumentsQuestionnaireRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProspectDocumentsApi - functional programming interface
 * @export
 */
export const ProspectDocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProspectDocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Reset documents questionnaire and update status pratica
         * @param {ResetDocumentsQuestionnaireRequest} resetDocumentsQuestionnaireRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetDocumentsQuestionnaire(resetDocumentsQuestionnaireRequest: ResetDocumentsQuestionnaireRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetDocumentsQuestionnaire(resetDocumentsQuestionnaireRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProspectDocumentsApi - factory interface
 * @export
 */
export const ProspectDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProspectDocumentsApiFp(configuration)
    return {
        /**
         * Reset documents questionnaire and update status pratica
         * @param {ResetDocumentsQuestionnaireRequest} resetDocumentsQuestionnaireRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetDocumentsQuestionnaire(resetDocumentsQuestionnaireRequest: ResetDocumentsQuestionnaireRequest, options?: any): AxiosPromise<void> {
            return localVarFp.resetDocumentsQuestionnaire(resetDocumentsQuestionnaireRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for resetDocumentsQuestionnaire operation in ProspectDocumentsApi.
 * @export
 * @interface ProspectDocumentsApiResetDocumentsQuestionnaireRequest
 */
export interface ProspectDocumentsApiResetDocumentsQuestionnaireRequest {
    /**
     * 
     * @type {ResetDocumentsQuestionnaireRequest}
     * @memberof ProspectDocumentsApiResetDocumentsQuestionnaire
     */
    readonly resetDocumentsQuestionnaireRequest: ResetDocumentsQuestionnaireRequest
}

/**
 * ProspectDocumentsApi - object-oriented interface
 * @export
 * @class ProspectDocumentsApi
 * @extends {BaseAPI}
 */
export class ProspectDocumentsApi extends BaseAPI {
    /**
     * Reset documents questionnaire and update status pratica
     * @param {ProspectDocumentsApiResetDocumentsQuestionnaireRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProspectDocumentsApi
     */
    public resetDocumentsQuestionnaire(requestParameters: ProspectDocumentsApiResetDocumentsQuestionnaireRequest, options?: AxiosRequestConfig) {
        return ProspectDocumentsApiFp(this.configuration).resetDocumentsQuestionnaire(requestParameters.resetDocumentsQuestionnaireRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RegistrazioneApi - axios parameter creator
 * @export
 */
export const RegistrazioneApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Attiva utenza DOB
         * @param {ActivateDobUserRequest} activateDobUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateDobUser: async (activateDobUserRequest: ActivateDobUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activateDobUserRequest' is not null or undefined
            assertParamExists('activateDobUser', 'activateDobUserRequest', activateDobUserRequest)
            const localVarPath = `/utenti/activate-dob-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activateDobUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aggiornamento del consenso su informativa privacy
         * @param {string} codiceUtente 
         * @param {ConsensoPrivacy} consensoPrivacy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggiornaConsensoPrivacy: async (codiceUtente: string, consensoPrivacy: ConsensoPrivacy, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('aggiornaConsensoPrivacy', 'codiceUtente', codiceUtente)
            // verify required parameter 'consensoPrivacy' is not null or undefined
            assertParamExists('aggiornaConsensoPrivacy', 'consensoPrivacy', consensoPrivacy)
            const localVarPath = `/pub/utenti/{codiceUtente}/privacy`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consensoPrivacy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancellazione utenza temporanea
         * @param {CancellaUtenteTmpRequest} cancellaUtenteTmpRequest Cancellazione dell\&#39;utenza temporanea
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancellaUtenteTmp: async (cancellaUtenteTmpRequest: CancellaUtenteTmpRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cancellaUtenteTmpRequest' is not null or undefined
            assertParamExists('cancellaUtenteTmp', 'cancellaUtenteTmpRequest', cancellaUtenteTmpRequest)
            const localVarPath = `/pub/utenti`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancellaUtenteTmpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Censimento del numero di cellulare dell\'utente
         * @param {string} codiceUtente 
         * @param {Cellulare} cellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        censimentoCellulare: async (codiceUtente: string, cellulare: Cellulare, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('censimentoCellulare', 'codiceUtente', codiceUtente)
            // verify required parameter 'cellulare' is not null or undefined
            assertParamExists('censimentoCellulare', 'cellulare', cellulare)
            const localVarPath = `/pub/utenti/{codiceUtente}/cellulare`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cellulare, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Censimento del numero di cellulare secondario dell\'utente
         * @param {string} codiceUtente 
         * @param {Cellulare} cellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        censimentoCellulareSecondario: async (codiceUtente: string, cellulare: Cellulare, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('censimentoCellulareSecondario', 'codiceUtente', codiceUtente)
            // verify required parameter 'cellulare' is not null or undefined
            assertParamExists('censimentoCellulareSecondario', 'cellulare', cellulare)
            const localVarPath = `/pub/utenti/{codiceUtente}/cellulare-secondario`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cellulare, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Censimento del codice fiscale del legale rappresentante
         * @param {string} codiceUtente 
         * @param {CodiceFiscaleRappresentante} codiceFiscaleRappresentante 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        censimentoCodiceFiscaleRappresentante: async (codiceUtente: string, codiceFiscaleRappresentante: CodiceFiscaleRappresentante, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('censimentoCodiceFiscaleRappresentante', 'codiceUtente', codiceUtente)
            // verify required parameter 'codiceFiscaleRappresentante' is not null or undefined
            assertParamExists('censimentoCodiceFiscaleRappresentante', 'codiceFiscaleRappresentante', codiceFiscaleRappresentante)
            const localVarPath = `/pub/utenti/{codiceUtente}/codice-fiscale-rappresentante`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(codiceFiscaleRappresentante, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Censimento dell\'indirizzo email dell\'utente
         * @param {string} codiceUtente 
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        censimentoEmail: async (codiceUtente: string, email: Email, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('censimentoEmail', 'codiceUtente', codiceUtente)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('censimentoEmail', 'email', email)
            const localVarPath = `/pub/utenti/{codiceUtente}/email`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(email, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Registrazione persona fisica o persona giuridica
         * @param {Persona} persona Inizializzazione dell\&#39;account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creaUtente: async (persona: Persona, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'persona' is not null or undefined
            assertParamExists('creaUtente', 'persona', persona)
            const localVarPath = `/pub/utenti`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persona, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ritorna lo stato della registrazione self per il cliente. Se esiste un bundle ancora valido, ritorna bundleId e temporaryToken per accedere all\'area firma.
         * @param {string} codiceCliente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusRegistrazione: async (codiceCliente: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceCliente' is not null or undefined
            assertParamExists('getStatusRegistrazione', 'codiceCliente', codiceCliente)
            const localVarPath = `/pub/utenti/{codiceCliente}/status-registrazione`
                .replace(`{${"codiceCliente"}}`, encodeURIComponent(String(codiceCliente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * inizializzazione registrazione su ow
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procediAllaRegistrazione: async (codiceUtente: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('procediAllaRegistrazione', 'codiceUtente', codiceUtente)
            const localVarPath = `/pub/utenti/{codiceUtente}/prepareRegistration`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifica del numero di cellulare dell\'utente
         * @param {string} codiceUtente 
         * @param {VerificaCellulare} verificaCellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificaCellulare: async (codiceUtente: string, verificaCellulare: VerificaCellulare, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('verificaCellulare', 'codiceUtente', codiceUtente)
            // verify required parameter 'verificaCellulare' is not null or undefined
            assertParamExists('verificaCellulare', 'verificaCellulare', verificaCellulare)
            const localVarPath = `/pub/utenti/{codiceUtente}/verifica-cellulare`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verificaCellulare, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifica dell\'indirizzo email dell\'utente
         * @param {string} codiceUtente 
         * @param {VerificaEmail} verificaEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificaEmail: async (codiceUtente: string, verificaEmail: VerificaEmail, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('verificaEmail', 'codiceUtente', codiceUtente)
            // verify required parameter 'verificaEmail' is not null or undefined
            assertParamExists('verificaEmail', 'verificaEmail', verificaEmail)
            const localVarPath = `/pub/utenti/{codiceUtente}/verifica-email`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verificaEmail, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistrazioneApi - functional programming interface
 * @export
 */
export const RegistrazioneApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegistrazioneApiAxiosParamCreator(configuration)
    return {
        /**
         * Attiva utenza DOB
         * @param {ActivateDobUserRequest} activateDobUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateDobUser(activateDobUserRequest: ActivateDobUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateDobUser(activateDobUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Aggiornamento del consenso su informativa privacy
         * @param {string} codiceUtente 
         * @param {ConsensoPrivacy} consensoPrivacy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aggiornaConsensoPrivacy(codiceUtente: string, consensoPrivacy: ConsensoPrivacy, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aggiornaConsensoPrivacy(codiceUtente, consensoPrivacy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Cancellazione utenza temporanea
         * @param {CancellaUtenteTmpRequest} cancellaUtenteTmpRequest Cancellazione dell\&#39;utenza temporanea
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancellaUtenteTmp(cancellaUtenteTmpRequest: CancellaUtenteTmpRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancellaUtenteTmp(cancellaUtenteTmpRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Censimento del numero di cellulare dell\'utente
         * @param {string} codiceUtente 
         * @param {Cellulare} cellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async censimentoCellulare(codiceUtente: string, cellulare: Cellulare, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.censimentoCellulare(codiceUtente, cellulare, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Censimento del numero di cellulare secondario dell\'utente
         * @param {string} codiceUtente 
         * @param {Cellulare} cellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async censimentoCellulareSecondario(codiceUtente: string, cellulare: Cellulare, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.censimentoCellulareSecondario(codiceUtente, cellulare, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Censimento del codice fiscale del legale rappresentante
         * @param {string} codiceUtente 
         * @param {CodiceFiscaleRappresentante} codiceFiscaleRappresentante 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async censimentoCodiceFiscaleRappresentante(codiceUtente: string, codiceFiscaleRappresentante: CodiceFiscaleRappresentante, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CodiceClienteRappresentante>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.censimentoCodiceFiscaleRappresentante(codiceUtente, codiceFiscaleRappresentante, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Censimento dell\'indirizzo email dell\'utente
         * @param {string} codiceUtente 
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async censimentoEmail(codiceUtente: string, email: Email, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.censimentoEmail(codiceUtente, email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Registrazione persona fisica o persona giuridica
         * @param {Persona} persona Inizializzazione dell\&#39;account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creaUtente(persona: Persona, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Persona>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creaUtente(persona, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Ritorna lo stato della registrazione self per il cliente. Se esiste un bundle ancora valido, ritorna bundleId e temporaryToken per accedere all\'area firma.
         * @param {string} codiceCliente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatusRegistrazione(codiceCliente: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusRegistrazione>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatusRegistrazione(codiceCliente, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * inizializzazione registrazione su ow
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async procediAllaRegistrazione(codiceUtente: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.procediAllaRegistrazione(codiceUtente, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verifica del numero di cellulare dell\'utente
         * @param {string} codiceUtente 
         * @param {VerificaCellulare} verificaCellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verificaCellulare(codiceUtente: string, verificaCellulare: VerificaCellulare, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerificaCellulareResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verificaCellulare(codiceUtente, verificaCellulare, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verifica dell\'indirizzo email dell\'utente
         * @param {string} codiceUtente 
         * @param {VerificaEmail} verificaEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verificaEmail(codiceUtente: string, verificaEmail: VerificaEmail, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerificaEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verificaEmail(codiceUtente, verificaEmail, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegistrazioneApi - factory interface
 * @export
 */
export const RegistrazioneApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegistrazioneApiFp(configuration)
    return {
        /**
         * Attiva utenza DOB
         * @param {ActivateDobUserRequest} activateDobUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateDobUser(activateDobUserRequest: ActivateDobUserRequest, options?: any): AxiosPromise<void> {
            return localVarFp.activateDobUser(activateDobUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Aggiornamento del consenso su informativa privacy
         * @param {string} codiceUtente 
         * @param {ConsensoPrivacy} consensoPrivacy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggiornaConsensoPrivacy(codiceUtente: string, consensoPrivacy: ConsensoPrivacy, options?: any): AxiosPromise<void> {
            return localVarFp.aggiornaConsensoPrivacy(codiceUtente, consensoPrivacy, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancellazione utenza temporanea
         * @param {CancellaUtenteTmpRequest} cancellaUtenteTmpRequest Cancellazione dell\&#39;utenza temporanea
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancellaUtenteTmp(cancellaUtenteTmpRequest: CancellaUtenteTmpRequest, options?: any): AxiosPromise<void> {
            return localVarFp.cancellaUtenteTmp(cancellaUtenteTmpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Censimento del numero di cellulare dell\'utente
         * @param {string} codiceUtente 
         * @param {Cellulare} cellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        censimentoCellulare(codiceUtente: string, cellulare: Cellulare, options?: any): AxiosPromise<void> {
            return localVarFp.censimentoCellulare(codiceUtente, cellulare, options).then((request) => request(axios, basePath));
        },
        /**
         * Censimento del numero di cellulare secondario dell\'utente
         * @param {string} codiceUtente 
         * @param {Cellulare} cellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        censimentoCellulareSecondario(codiceUtente: string, cellulare: Cellulare, options?: any): AxiosPromise<void> {
            return localVarFp.censimentoCellulareSecondario(codiceUtente, cellulare, options).then((request) => request(axios, basePath));
        },
        /**
         * Censimento del codice fiscale del legale rappresentante
         * @param {string} codiceUtente 
         * @param {CodiceFiscaleRappresentante} codiceFiscaleRappresentante 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        censimentoCodiceFiscaleRappresentante(codiceUtente: string, codiceFiscaleRappresentante: CodiceFiscaleRappresentante, options?: any): AxiosPromise<CodiceClienteRappresentante> {
            return localVarFp.censimentoCodiceFiscaleRappresentante(codiceUtente, codiceFiscaleRappresentante, options).then((request) => request(axios, basePath));
        },
        /**
         * Censimento dell\'indirizzo email dell\'utente
         * @param {string} codiceUtente 
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        censimentoEmail(codiceUtente: string, email: Email, options?: any): AxiosPromise<void> {
            return localVarFp.censimentoEmail(codiceUtente, email, options).then((request) => request(axios, basePath));
        },
        /**
         * Registrazione persona fisica o persona giuridica
         * @param {Persona} persona Inizializzazione dell\&#39;account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creaUtente(persona: Persona, options?: any): AxiosPromise<Persona> {
            return localVarFp.creaUtente(persona, options).then((request) => request(axios, basePath));
        },
        /**
         * Ritorna lo stato della registrazione self per il cliente. Se esiste un bundle ancora valido, ritorna bundleId e temporaryToken per accedere all\'area firma.
         * @param {string} codiceCliente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusRegistrazione(codiceCliente: string, options?: any): AxiosPromise<StatusRegistrazione> {
            return localVarFp.getStatusRegistrazione(codiceCliente, options).then((request) => request(axios, basePath));
        },
        /**
         * inizializzazione registrazione su ow
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procediAllaRegistrazione(codiceUtente: string, options?: any): AxiosPromise<void> {
            return localVarFp.procediAllaRegistrazione(codiceUtente, options).then((request) => request(axios, basePath));
        },
        /**
         * Verifica del numero di cellulare dell\'utente
         * @param {string} codiceUtente 
         * @param {VerificaCellulare} verificaCellulare 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificaCellulare(codiceUtente: string, verificaCellulare: VerificaCellulare, options?: any): AxiosPromise<VerificaCellulareResponse> {
            return localVarFp.verificaCellulare(codiceUtente, verificaCellulare, options).then((request) => request(axios, basePath));
        },
        /**
         * Verifica dell\'indirizzo email dell\'utente
         * @param {string} codiceUtente 
         * @param {VerificaEmail} verificaEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificaEmail(codiceUtente: string, verificaEmail: VerificaEmail, options?: any): AxiosPromise<VerificaEmailResponse> {
            return localVarFp.verificaEmail(codiceUtente, verificaEmail, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for activateDobUser operation in RegistrazioneApi.
 * @export
 * @interface RegistrazioneApiActivateDobUserRequest
 */
export interface RegistrazioneApiActivateDobUserRequest {
    /**
     * 
     * @type {ActivateDobUserRequest}
     * @memberof RegistrazioneApiActivateDobUser
     */
    readonly activateDobUserRequest: ActivateDobUserRequest
}

/**
 * Request parameters for aggiornaConsensoPrivacy operation in RegistrazioneApi.
 * @export
 * @interface RegistrazioneApiAggiornaConsensoPrivacyRequest
 */
export interface RegistrazioneApiAggiornaConsensoPrivacyRequest {
    /**
     * 
     * @type {string}
     * @memberof RegistrazioneApiAggiornaConsensoPrivacy
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {ConsensoPrivacy}
     * @memberof RegistrazioneApiAggiornaConsensoPrivacy
     */
    readonly consensoPrivacy: ConsensoPrivacy
}

/**
 * Request parameters for cancellaUtenteTmp operation in RegistrazioneApi.
 * @export
 * @interface RegistrazioneApiCancellaUtenteTmpRequest
 */
export interface RegistrazioneApiCancellaUtenteTmpRequest {
    /**
     * Cancellazione dell\&#39;utenza temporanea
     * @type {CancellaUtenteTmpRequest}
     * @memberof RegistrazioneApiCancellaUtenteTmp
     */
    readonly cancellaUtenteTmpRequest: CancellaUtenteTmpRequest
}

/**
 * Request parameters for censimentoCellulare operation in RegistrazioneApi.
 * @export
 * @interface RegistrazioneApiCensimentoCellulareRequest
 */
export interface RegistrazioneApiCensimentoCellulareRequest {
    /**
     * 
     * @type {string}
     * @memberof RegistrazioneApiCensimentoCellulare
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {Cellulare}
     * @memberof RegistrazioneApiCensimentoCellulare
     */
    readonly cellulare: Cellulare
}

/**
 * Request parameters for censimentoCellulareSecondario operation in RegistrazioneApi.
 * @export
 * @interface RegistrazioneApiCensimentoCellulareSecondarioRequest
 */
export interface RegistrazioneApiCensimentoCellulareSecondarioRequest {
    /**
     * 
     * @type {string}
     * @memberof RegistrazioneApiCensimentoCellulareSecondario
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {Cellulare}
     * @memberof RegistrazioneApiCensimentoCellulareSecondario
     */
    readonly cellulare: Cellulare
}

/**
 * Request parameters for censimentoCodiceFiscaleRappresentante operation in RegistrazioneApi.
 * @export
 * @interface RegistrazioneApiCensimentoCodiceFiscaleRappresentanteRequest
 */
export interface RegistrazioneApiCensimentoCodiceFiscaleRappresentanteRequest {
    /**
     * 
     * @type {string}
     * @memberof RegistrazioneApiCensimentoCodiceFiscaleRappresentante
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {CodiceFiscaleRappresentante}
     * @memberof RegistrazioneApiCensimentoCodiceFiscaleRappresentante
     */
    readonly codiceFiscaleRappresentante: CodiceFiscaleRappresentante
}

/**
 * Request parameters for censimentoEmail operation in RegistrazioneApi.
 * @export
 * @interface RegistrazioneApiCensimentoEmailRequest
 */
export interface RegistrazioneApiCensimentoEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof RegistrazioneApiCensimentoEmail
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {Email}
     * @memberof RegistrazioneApiCensimentoEmail
     */
    readonly email: Email
}

/**
 * Request parameters for creaUtente operation in RegistrazioneApi.
 * @export
 * @interface RegistrazioneApiCreaUtenteRequest
 */
export interface RegistrazioneApiCreaUtenteRequest {
    /**
     * Inizializzazione dell\&#39;account
     * @type {Persona}
     * @memberof RegistrazioneApiCreaUtente
     */
    readonly persona: Persona
}

/**
 * Request parameters for getStatusRegistrazione operation in RegistrazioneApi.
 * @export
 * @interface RegistrazioneApiGetStatusRegistrazioneRequest
 */
export interface RegistrazioneApiGetStatusRegistrazioneRequest {
    /**
     * 
     * @type {string}
     * @memberof RegistrazioneApiGetStatusRegistrazione
     */
    readonly codiceCliente: string
}

/**
 * Request parameters for procediAllaRegistrazione operation in RegistrazioneApi.
 * @export
 * @interface RegistrazioneApiProcediAllaRegistrazioneRequest
 */
export interface RegistrazioneApiProcediAllaRegistrazioneRequest {
    /**
     * 
     * @type {string}
     * @memberof RegistrazioneApiProcediAllaRegistrazione
     */
    readonly codiceUtente: string
}

/**
 * Request parameters for verificaCellulare operation in RegistrazioneApi.
 * @export
 * @interface RegistrazioneApiVerificaCellulareRequest
 */
export interface RegistrazioneApiVerificaCellulareRequest {
    /**
     * 
     * @type {string}
     * @memberof RegistrazioneApiVerificaCellulare
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {VerificaCellulare}
     * @memberof RegistrazioneApiVerificaCellulare
     */
    readonly verificaCellulare: VerificaCellulare
}

/**
 * Request parameters for verificaEmail operation in RegistrazioneApi.
 * @export
 * @interface RegistrazioneApiVerificaEmailRequest
 */
export interface RegistrazioneApiVerificaEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof RegistrazioneApiVerificaEmail
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {VerificaEmail}
     * @memberof RegistrazioneApiVerificaEmail
     */
    readonly verificaEmail: VerificaEmail
}

/**
 * RegistrazioneApi - object-oriented interface
 * @export
 * @class RegistrazioneApi
 * @extends {BaseAPI}
 */
export class RegistrazioneApi extends BaseAPI {
    /**
     * Attiva utenza DOB
     * @param {RegistrazioneApiActivateDobUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrazioneApi
     */
    public activateDobUser(requestParameters: RegistrazioneApiActivateDobUserRequest, options?: AxiosRequestConfig) {
        return RegistrazioneApiFp(this.configuration).activateDobUser(requestParameters.activateDobUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aggiornamento del consenso su informativa privacy
     * @param {RegistrazioneApiAggiornaConsensoPrivacyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrazioneApi
     */
    public aggiornaConsensoPrivacy(requestParameters: RegistrazioneApiAggiornaConsensoPrivacyRequest, options?: AxiosRequestConfig) {
        return RegistrazioneApiFp(this.configuration).aggiornaConsensoPrivacy(requestParameters.codiceUtente, requestParameters.consensoPrivacy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancellazione utenza temporanea
     * @param {RegistrazioneApiCancellaUtenteTmpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrazioneApi
     */
    public cancellaUtenteTmp(requestParameters: RegistrazioneApiCancellaUtenteTmpRequest, options?: AxiosRequestConfig) {
        return RegistrazioneApiFp(this.configuration).cancellaUtenteTmp(requestParameters.cancellaUtenteTmpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Censimento del numero di cellulare dell\'utente
     * @param {RegistrazioneApiCensimentoCellulareRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrazioneApi
     */
    public censimentoCellulare(requestParameters: RegistrazioneApiCensimentoCellulareRequest, options?: AxiosRequestConfig) {
        return RegistrazioneApiFp(this.configuration).censimentoCellulare(requestParameters.codiceUtente, requestParameters.cellulare, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Censimento del numero di cellulare secondario dell\'utente
     * @param {RegistrazioneApiCensimentoCellulareSecondarioRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrazioneApi
     */
    public censimentoCellulareSecondario(requestParameters: RegistrazioneApiCensimentoCellulareSecondarioRequest, options?: AxiosRequestConfig) {
        return RegistrazioneApiFp(this.configuration).censimentoCellulareSecondario(requestParameters.codiceUtente, requestParameters.cellulare, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Censimento del codice fiscale del legale rappresentante
     * @param {RegistrazioneApiCensimentoCodiceFiscaleRappresentanteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrazioneApi
     */
    public censimentoCodiceFiscaleRappresentante(requestParameters: RegistrazioneApiCensimentoCodiceFiscaleRappresentanteRequest, options?: AxiosRequestConfig) {
        return RegistrazioneApiFp(this.configuration).censimentoCodiceFiscaleRappresentante(requestParameters.codiceUtente, requestParameters.codiceFiscaleRappresentante, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Censimento dell\'indirizzo email dell\'utente
     * @param {RegistrazioneApiCensimentoEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrazioneApi
     */
    public censimentoEmail(requestParameters: RegistrazioneApiCensimentoEmailRequest, options?: AxiosRequestConfig) {
        return RegistrazioneApiFp(this.configuration).censimentoEmail(requestParameters.codiceUtente, requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Registrazione persona fisica o persona giuridica
     * @param {RegistrazioneApiCreaUtenteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrazioneApi
     */
    public creaUtente(requestParameters: RegistrazioneApiCreaUtenteRequest, options?: AxiosRequestConfig) {
        return RegistrazioneApiFp(this.configuration).creaUtente(requestParameters.persona, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ritorna lo stato della registrazione self per il cliente. Se esiste un bundle ancora valido, ritorna bundleId e temporaryToken per accedere all\'area firma.
     * @param {RegistrazioneApiGetStatusRegistrazioneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrazioneApi
     */
    public getStatusRegistrazione(requestParameters: RegistrazioneApiGetStatusRegistrazioneRequest, options?: AxiosRequestConfig) {
        return RegistrazioneApiFp(this.configuration).getStatusRegistrazione(requestParameters.codiceCliente, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * inizializzazione registrazione su ow
     * @param {RegistrazioneApiProcediAllaRegistrazioneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrazioneApi
     */
    public procediAllaRegistrazione(requestParameters: RegistrazioneApiProcediAllaRegistrazioneRequest, options?: AxiosRequestConfig) {
        return RegistrazioneApiFp(this.configuration).procediAllaRegistrazione(requestParameters.codiceUtente, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifica del numero di cellulare dell\'utente
     * @param {RegistrazioneApiVerificaCellulareRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrazioneApi
     */
    public verificaCellulare(requestParameters: RegistrazioneApiVerificaCellulareRequest, options?: AxiosRequestConfig) {
        return RegistrazioneApiFp(this.configuration).verificaCellulare(requestParameters.codiceUtente, requestParameters.verificaCellulare, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifica dell\'indirizzo email dell\'utente
     * @param {RegistrazioneApiVerificaEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrazioneApi
     */
    public verificaEmail(requestParameters: RegistrazioneApiVerificaEmailRequest, options?: AxiosRequestConfig) {
        return RegistrazioneApiFp(this.configuration).verificaEmail(requestParameters.codiceUtente, requestParameters.verificaEmail, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SigningApi - axios parameter creator
 * @export
 */
export const SigningApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Starts the document signing process for DIY onboarding. Transitions the pratica to DA_FIRMARE state and triggers the girofirma process to generate documents.
         * @param {string} codiceUtente 
         * @param {string} processId Process ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSigningProcess: async (codiceUtente: string, processId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('startSigningProcess', 'codiceUtente', codiceUtente)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('startSigningProcess', 'processId', processId)
            const localVarPath = `/utenti/{codiceUtente}/onboarding/sign`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (processId !== undefined) {
                localVarQueryParameter['processId'] = processId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SigningApi - functional programming interface
 * @export
 */
export const SigningApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SigningApiAxiosParamCreator(configuration)
    return {
        /**
         * Starts the document signing process for DIY onboarding. Transitions the pratica to DA_FIRMARE state and triggers the girofirma process to generate documents.
         * @param {string} codiceUtente 
         * @param {string} processId Process ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startSigningProcess(codiceUtente: string, processId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startSigningProcess(codiceUtente, processId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SigningApi - factory interface
 * @export
 */
export const SigningApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SigningApiFp(configuration)
    return {
        /**
         * Starts the document signing process for DIY onboarding. Transitions the pratica to DA_FIRMARE state and triggers the girofirma process to generate documents.
         * @param {string} codiceUtente 
         * @param {string} processId Process ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSigningProcess(codiceUtente: string, processId: string, options?: any): AxiosPromise<Status> {
            return localVarFp.startSigningProcess(codiceUtente, processId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for startSigningProcess operation in SigningApi.
 * @export
 * @interface SigningApiStartSigningProcessRequest
 */
export interface SigningApiStartSigningProcessRequest {
    /**
     * 
     * @type {string}
     * @memberof SigningApiStartSigningProcess
     */
    readonly codiceUtente: string

    /**
     * Process ID
     * @type {string}
     * @memberof SigningApiStartSigningProcess
     */
    readonly processId: string
}

/**
 * SigningApi - object-oriented interface
 * @export
 * @class SigningApi
 * @extends {BaseAPI}
 */
export class SigningApi extends BaseAPI {
    /**
     * Starts the document signing process for DIY onboarding. Transitions the pratica to DA_FIRMARE state and triggers the girofirma process to generate documents.
     * @param {SigningApiStartSigningProcessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SigningApi
     */
    public startSigningProcess(requestParameters: SigningApiStartSigningProcessRequest, options?: AxiosRequestConfig) {
        return SigningApiFp(this.configuration).startSigningProcess(requestParameters.codiceUtente, requestParameters.processId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SignroomApi - axios parameter creator
 * @export
 */
export const SignroomApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Api chiamata da Orchestratore Firma per notificare cambi di stato (signed, expired) dei documenti di iscrizione
         * @param {string} codiceUtente Il codice utente
         * @param {'SIGNED' | 'EXPIRED'} [stato] Stato del bundle che genera la chiamata di callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endRegistrazione: async (codiceUtente: string, stato?: 'SIGNED' | 'EXPIRED', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('endRegistrazione', 'codiceUtente', codiceUtente)
            const localVarPath = `/pub/callback/registrazione`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (codiceUtente !== undefined) {
                localVarQueryParameter['codiceUtente'] = codiceUtente;
            }

            if (stato !== undefined) {
                localVarQueryParameter['stato'] = stato;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera i dettagli di un ordine RTO
         * @param {string} ordineRto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdineRto: async (ordineRto: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ordineRto' is not null or undefined
            assertParamExists('getOrdineRto', 'ordineRto', ordineRto)
            const localVarPath = `/signature-area/ordine-rto/{ordineRto}`
                .replace(`{${"ordineRto"}}`, encodeURIComponent(String(ordineRto)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Api chiamata da Orchestratore Firma per notificare cambi di stato (signed, expired) dei documenti di cambio recapito cell
         * @param {string} codiceUtente Il codice utente
         * @param {'SIGNED' | 'EXPIRED'} [stato] Stato del bundle che genera la chiamata di callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificaCell: async (codiceUtente: string, stato?: 'SIGNED' | 'EXPIRED', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('modificaCell', 'codiceUtente', codiceUtente)
            const localVarPath = `/pub/callback/modifica_cell`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (codiceUtente !== undefined) {
                localVarQueryParameter['codiceUtente'] = codiceUtente;
            }

            if (stato !== undefined) {
                localVarQueryParameter['stato'] = stato;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Api chiamata da Orchestratore Firma per notificare cambi di stato (signed, expired) dei documenti di iscrizione o cambio recapiti
         * @param {string} codiceUtente Il codice utente
         * @param {'SIGNED' | 'EXPIRED'} [stato] Stato del bundle che genera la chiamata di callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificaEmail: async (codiceUtente: string, stato?: 'SIGNED' | 'EXPIRED', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('modificaEmail', 'codiceUtente', codiceUtente)
            const localVarPath = `/pub/callback/modifica_email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (codiceUtente !== undefined) {
                localVarQueryParameter['codiceUtente'] = codiceUtente;
            }

            if (stato !== undefined) {
                localVarQueryParameter['stato'] = stato;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SignroomApi - functional programming interface
 * @export
 */
export const SignroomApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SignroomApiAxiosParamCreator(configuration)
    return {
        /**
         * Api chiamata da Orchestratore Firma per notificare cambi di stato (signed, expired) dei documenti di iscrizione
         * @param {string} codiceUtente Il codice utente
         * @param {'SIGNED' | 'EXPIRED'} [stato] Stato del bundle che genera la chiamata di callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endRegistrazione(codiceUtente: string, stato?: 'SIGNED' | 'EXPIRED', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endRegistrazione(codiceUtente, stato, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Recupera i dettagli di un ordine RTO
         * @param {string} ordineRto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrdineRto(ordineRto: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DettaglioOrdineRto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrdineRto(ordineRto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Api chiamata da Orchestratore Firma per notificare cambi di stato (signed, expired) dei documenti di cambio recapito cell
         * @param {string} codiceUtente Il codice utente
         * @param {'SIGNED' | 'EXPIRED'} [stato] Stato del bundle che genera la chiamata di callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modificaCell(codiceUtente: string, stato?: 'SIGNED' | 'EXPIRED', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modificaCell(codiceUtente, stato, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Api chiamata da Orchestratore Firma per notificare cambi di stato (signed, expired) dei documenti di iscrizione o cambio recapiti
         * @param {string} codiceUtente Il codice utente
         * @param {'SIGNED' | 'EXPIRED'} [stato] Stato del bundle che genera la chiamata di callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modificaEmail(codiceUtente: string, stato?: 'SIGNED' | 'EXPIRED', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modificaEmail(codiceUtente, stato, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SignroomApi - factory interface
 * @export
 */
export const SignroomApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SignroomApiFp(configuration)
    return {
        /**
         * Api chiamata da Orchestratore Firma per notificare cambi di stato (signed, expired) dei documenti di iscrizione
         * @param {string} codiceUtente Il codice utente
         * @param {'SIGNED' | 'EXPIRED'} [stato] Stato del bundle che genera la chiamata di callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endRegistrazione(codiceUtente: string, stato?: 'SIGNED' | 'EXPIRED', options?: any): AxiosPromise<void> {
            return localVarFp.endRegistrazione(codiceUtente, stato, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera i dettagli di un ordine RTO
         * @param {string} ordineRto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdineRto(ordineRto: string, options?: any): AxiosPromise<DettaglioOrdineRto> {
            return localVarFp.getOrdineRto(ordineRto, options).then((request) => request(axios, basePath));
        },
        /**
         * Api chiamata da Orchestratore Firma per notificare cambi di stato (signed, expired) dei documenti di cambio recapito cell
         * @param {string} codiceUtente Il codice utente
         * @param {'SIGNED' | 'EXPIRED'} [stato] Stato del bundle che genera la chiamata di callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificaCell(codiceUtente: string, stato?: 'SIGNED' | 'EXPIRED', options?: any): AxiosPromise<void> {
            return localVarFp.modificaCell(codiceUtente, stato, options).then((request) => request(axios, basePath));
        },
        /**
         * Api chiamata da Orchestratore Firma per notificare cambi di stato (signed, expired) dei documenti di iscrizione o cambio recapiti
         * @param {string} codiceUtente Il codice utente
         * @param {'SIGNED' | 'EXPIRED'} [stato] Stato del bundle che genera la chiamata di callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modificaEmail(codiceUtente: string, stato?: 'SIGNED' | 'EXPIRED', options?: any): AxiosPromise<void> {
            return localVarFp.modificaEmail(codiceUtente, stato, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for endRegistrazione operation in SignroomApi.
 * @export
 * @interface SignroomApiEndRegistrazioneRequest
 */
export interface SignroomApiEndRegistrazioneRequest {
    /**
     * Il codice utente
     * @type {string}
     * @memberof SignroomApiEndRegistrazione
     */
    readonly codiceUtente: string

    /**
     * Stato del bundle che genera la chiamata di callback
     * @type {'SIGNED' | 'EXPIRED'}
     * @memberof SignroomApiEndRegistrazione
     */
    readonly stato?: 'SIGNED' | 'EXPIRED'
}

/**
 * Request parameters for getOrdineRto operation in SignroomApi.
 * @export
 * @interface SignroomApiGetOrdineRtoRequest
 */
export interface SignroomApiGetOrdineRtoRequest {
    /**
     * 
     * @type {string}
     * @memberof SignroomApiGetOrdineRto
     */
    readonly ordineRto: string
}

/**
 * Request parameters for modificaCell operation in SignroomApi.
 * @export
 * @interface SignroomApiModificaCellRequest
 */
export interface SignroomApiModificaCellRequest {
    /**
     * Il codice utente
     * @type {string}
     * @memberof SignroomApiModificaCell
     */
    readonly codiceUtente: string

    /**
     * Stato del bundle che genera la chiamata di callback
     * @type {'SIGNED' | 'EXPIRED'}
     * @memberof SignroomApiModificaCell
     */
    readonly stato?: 'SIGNED' | 'EXPIRED'
}

/**
 * Request parameters for modificaEmail operation in SignroomApi.
 * @export
 * @interface SignroomApiModificaEmailRequest
 */
export interface SignroomApiModificaEmailRequest {
    /**
     * Il codice utente
     * @type {string}
     * @memberof SignroomApiModificaEmail
     */
    readonly codiceUtente: string

    /**
     * Stato del bundle che genera la chiamata di callback
     * @type {'SIGNED' | 'EXPIRED'}
     * @memberof SignroomApiModificaEmail
     */
    readonly stato?: 'SIGNED' | 'EXPIRED'
}

/**
 * SignroomApi - object-oriented interface
 * @export
 * @class SignroomApi
 * @extends {BaseAPI}
 */
export class SignroomApi extends BaseAPI {
    /**
     * Api chiamata da Orchestratore Firma per notificare cambi di stato (signed, expired) dei documenti di iscrizione
     * @param {SignroomApiEndRegistrazioneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignroomApi
     */
    public endRegistrazione(requestParameters: SignroomApiEndRegistrazioneRequest, options?: AxiosRequestConfig) {
        return SignroomApiFp(this.configuration).endRegistrazione(requestParameters.codiceUtente, requestParameters.stato, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera i dettagli di un ordine RTO
     * @param {SignroomApiGetOrdineRtoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignroomApi
     */
    public getOrdineRto(requestParameters: SignroomApiGetOrdineRtoRequest, options?: AxiosRequestConfig) {
        return SignroomApiFp(this.configuration).getOrdineRto(requestParameters.ordineRto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Api chiamata da Orchestratore Firma per notificare cambi di stato (signed, expired) dei documenti di cambio recapito cell
     * @param {SignroomApiModificaCellRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignroomApi
     */
    public modificaCell(requestParameters: SignroomApiModificaCellRequest, options?: AxiosRequestConfig) {
        return SignroomApiFp(this.configuration).modificaCell(requestParameters.codiceUtente, requestParameters.stato, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Api chiamata da Orchestratore Firma per notificare cambi di stato (signed, expired) dei documenti di iscrizione o cambio recapiti
     * @param {SignroomApiModificaEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignroomApi
     */
    public modificaEmail(requestParameters: SignroomApiModificaEmailRequest, options?: AxiosRequestConfig) {
        return SignroomApiFp(this.configuration).modificaEmail(requestParameters.codiceUtente, requestParameters.stato, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StatoApi - axios parameter creator
 * @export
 */
export const StatoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Informazioni sullo stato dell\'utenza
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statusUtenza: async (codiceUtente: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('statusUtenza', 'codiceUtente', codiceUtente)
            const localVarPath = `/utenti/{codiceUtente}/status`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatoApi - functional programming interface
 * @export
 */
export const StatoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatoApiAxiosParamCreator(configuration)
    return {
        /**
         * Informazioni sullo stato dell\'utenza
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statusUtenza(codiceUtente: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusUtente>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statusUtenza(codiceUtente, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StatoApi - factory interface
 * @export
 */
export const StatoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatoApiFp(configuration)
    return {
        /**
         * Informazioni sullo stato dell\'utenza
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statusUtenza(codiceUtente: string, options?: any): AxiosPromise<StatusUtente> {
            return localVarFp.statusUtenza(codiceUtente, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for statusUtenza operation in StatoApi.
 * @export
 * @interface StatoApiStatusUtenzaRequest
 */
export interface StatoApiStatusUtenzaRequest {
    /**
     * 
     * @type {string}
     * @memberof StatoApiStatusUtenza
     */
    readonly codiceUtente: string
}

/**
 * StatoApi - object-oriented interface
 * @export
 * @class StatoApi
 * @extends {BaseAPI}
 */
export class StatoApi extends BaseAPI {
    /**
     * Informazioni sullo stato dell\'utenza
     * @param {StatoApiStatusUtenzaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatoApi
     */
    public statusUtenza(requestParameters: StatoApiStatusUtenzaRequest, options?: AxiosRequestConfig) {
        return StatoApiFp(this.configuration).statusUtenza(requestParameters.codiceUtente, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StatoQuestionariApi - axios parameter creator
 * @export
 */
export const StatoQuestionariApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Aggiorna lo stato dei questionari AML FACTA/CRS e MIFID
         * @param {string} codiceUtente 
         * @param {QuestionnairesStatus} questionnairesStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionnairesStatus: async (codiceUtente: string, questionnairesStatus: QuestionnairesStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('updateQuestionnairesStatus', 'codiceUtente', codiceUtente)
            // verify required parameter 'questionnairesStatus' is not null or undefined
            assertParamExists('updateQuestionnairesStatus', 'questionnairesStatus', questionnairesStatus)
            const localVarPath = `/utenti/{codiceUtente}/questionnaires-status`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionnairesStatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatoQuestionariApi - functional programming interface
 * @export
 */
export const StatoQuestionariApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatoQuestionariApiAxiosParamCreator(configuration)
    return {
        /**
         * Aggiorna lo stato dei questionari AML FACTA/CRS e MIFID
         * @param {string} codiceUtente 
         * @param {QuestionnairesStatus} questionnairesStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQuestionnairesStatus(codiceUtente: string, questionnairesStatus: QuestionnairesStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuestionnairesStatus(codiceUtente, questionnairesStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StatoQuestionariApi - factory interface
 * @export
 */
export const StatoQuestionariApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatoQuestionariApiFp(configuration)
    return {
        /**
         * Aggiorna lo stato dei questionari AML FACTA/CRS e MIFID
         * @param {string} codiceUtente 
         * @param {QuestionnairesStatus} questionnairesStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionnairesStatus(codiceUtente: string, questionnairesStatus: QuestionnairesStatus, options?: any): AxiosPromise<void> {
            return localVarFp.updateQuestionnairesStatus(codiceUtente, questionnairesStatus, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for updateQuestionnairesStatus operation in StatoQuestionariApi.
 * @export
 * @interface StatoQuestionariApiUpdateQuestionnairesStatusRequest
 */
export interface StatoQuestionariApiUpdateQuestionnairesStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof StatoQuestionariApiUpdateQuestionnairesStatus
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {QuestionnairesStatus}
     * @memberof StatoQuestionariApiUpdateQuestionnairesStatus
     */
    readonly questionnairesStatus: QuestionnairesStatus
}

/**
 * StatoQuestionariApi - object-oriented interface
 * @export
 * @class StatoQuestionariApi
 * @extends {BaseAPI}
 */
export class StatoQuestionariApi extends BaseAPI {
    /**
     * Aggiorna lo stato dei questionari AML FACTA/CRS e MIFID
     * @param {StatoQuestionariApiUpdateQuestionnairesStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatoQuestionariApi
     */
    public updateQuestionnairesStatus(requestParameters: StatoQuestionariApiUpdateQuestionnairesStatusRequest, options?: AxiosRequestConfig) {
        return StatoQuestionariApiFp(this.configuration).updateQuestionnairesStatus(requestParameters.codiceUtente, requestParameters.questionnairesStatus, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TasksApi - axios parameter creator
 * @export
 */
export const TasksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the status of activities required for signing and completing a DIY Onboarding process (AML/FATCA/CRS, MIFID, signature specimen upload)
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTasks: async (codiceUtente: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('getTasks', 'codiceUtente', codiceUtente)
            const localVarPath = `/utenti/{codiceUtente}/tasks`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads the user\'s signature specimen image
         * @param {string} codiceUtente 
         * @param {SpecimenUploadRequest} specimenUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSpecimen: async (codiceUtente: string, specimenUploadRequest: SpecimenUploadRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceUtente' is not null or undefined
            assertParamExists('uploadSpecimen', 'codiceUtente', codiceUtente)
            // verify required parameter 'specimenUploadRequest' is not null or undefined
            assertParamExists('uploadSpecimen', 'specimenUploadRequest', specimenUploadRequest)
            const localVarPath = `/utenti/{codiceUtente}/tasks/specimen`
                .replace(`{${"codiceUtente"}}`, encodeURIComponent(String(codiceUtente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(specimenUploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TasksApi - functional programming interface
 * @export
 */
export const TasksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TasksApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the status of activities required for signing and completing a DIY Onboarding process (AML/FATCA/CRS, MIFID, signature specimen upload)
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTasks(codiceUtente: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTasksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTasks(codiceUtente, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Uploads the user\'s signature specimen image
         * @param {string} codiceUtente 
         * @param {SpecimenUploadRequest} specimenUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadSpecimen(codiceUtente: string, specimenUploadRequest: SpecimenUploadRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecimenUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadSpecimen(codiceUtente, specimenUploadRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TasksApi - factory interface
 * @export
 */
export const TasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TasksApiFp(configuration)
    return {
        /**
         * Returns the status of activities required for signing and completing a DIY Onboarding process (AML/FATCA/CRS, MIFID, signature specimen upload)
         * @param {string} codiceUtente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTasks(codiceUtente: string, options?: any): AxiosPromise<GetTasksResponse> {
            return localVarFp.getTasks(codiceUtente, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads the user\'s signature specimen image
         * @param {string} codiceUtente 
         * @param {SpecimenUploadRequest} specimenUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSpecimen(codiceUtente: string, specimenUploadRequest: SpecimenUploadRequest, options?: any): AxiosPromise<SpecimenUploadResponse> {
            return localVarFp.uploadSpecimen(codiceUtente, specimenUploadRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getTasks operation in TasksApi.
 * @export
 * @interface TasksApiGetTasksRequest
 */
export interface TasksApiGetTasksRequest {
    /**
     * 
     * @type {string}
     * @memberof TasksApiGetTasks
     */
    readonly codiceUtente: string
}

/**
 * Request parameters for uploadSpecimen operation in TasksApi.
 * @export
 * @interface TasksApiUploadSpecimenRequest
 */
export interface TasksApiUploadSpecimenRequest {
    /**
     * 
     * @type {string}
     * @memberof TasksApiUploadSpecimen
     */
    readonly codiceUtente: string

    /**
     * 
     * @type {SpecimenUploadRequest}
     * @memberof TasksApiUploadSpecimen
     */
    readonly specimenUploadRequest: SpecimenUploadRequest
}

/**
 * TasksApi - object-oriented interface
 * @export
 * @class TasksApi
 * @extends {BaseAPI}
 */
export class TasksApi extends BaseAPI {
    /**
     * Returns the status of activities required for signing and completing a DIY Onboarding process (AML/FATCA/CRS, MIFID, signature specimen upload)
     * @param {TasksApiGetTasksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public getTasks(requestParameters: TasksApiGetTasksRequest, options?: AxiosRequestConfig) {
        return TasksApiFp(this.configuration).getTasks(requestParameters.codiceUtente, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads the user\'s signature specimen image
     * @param {TasksApiUploadSpecimenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public uploadSpecimen(requestParameters: TasksApiUploadSpecimenRequest, options?: AxiosRequestConfig) {
        return TasksApiFp(this.configuration).uploadSpecimen(requestParameters.codiceUtente, requestParameters.specimenUploadRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WebCollaborationApi - axios parameter creator
 * @export
 */
export const WebCollaborationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API per creare la room
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoom: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/web-collaboration/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API per accettare l\'answer
         * @param {string} roomId Stanza
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccept: async (roomId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('postAccept', 'roomId', roomId)
            const localVarPath = `/web-collaboration/{roomId}/accept`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API per memorizzare l\'answer
         * @param {string} roomId Stanza
         * @param {WebCollaborationAnswerRequest} webCollaborationAnswerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAnswer: async (roomId: string, webCollaborationAnswerRequest: WebCollaborationAnswerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('postAnswer', 'roomId', roomId)
            // verify required parameter 'webCollaborationAnswerRequest' is not null or undefined
            assertParamExists('postAnswer', 'webCollaborationAnswerRequest', webCollaborationAnswerRequest)
            const localVarPath = `/web-collaboration/{roomId}/answer`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webCollaborationAnswerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API per memorizzare l\'ice-candidate
         * @param {string} roomId Stanza
         * @param {WebCollaborationIceCandidateRequest} webCollaborationIceCandidateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postIceCandidate: async (roomId: string, webCollaborationIceCandidateRequest: WebCollaborationIceCandidateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('postIceCandidate', 'roomId', roomId)
            // verify required parameter 'webCollaborationIceCandidateRequest' is not null or undefined
            assertParamExists('postIceCandidate', 'webCollaborationIceCandidateRequest', webCollaborationIceCandidateRequest)
            const localVarPath = `/web-collaboration/{roomId}/ice-candidate`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webCollaborationIceCandidateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API per memorizzare la offer
         * @param {string} roomId Stanza
         * @param {WebCollaborationOfferRequest} webCollaborationOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOffer: async (roomId: string, webCollaborationOfferRequest: WebCollaborationOfferRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('postOffer', 'roomId', roomId)
            // verify required parameter 'webCollaborationOfferRequest' is not null or undefined
            assertParamExists('postOffer', 'webCollaborationOfferRequest', webCollaborationOfferRequest)
            const localVarPath = `/web-collaboration/{roomId}/offer`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webCollaborationOfferRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stato della stanza
         * @param {'prospect' | 'consultant'} role Ruolo del partecipante
         * @param {string} roomId Stanza
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webCollaborationRoomIdStatusGet: async (role: 'prospect' | 'consultant', roomId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'role' is not null or undefined
            assertParamExists('webCollaborationRoomIdStatusGet', 'role', role)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('webCollaborationRoomIdStatusGet', 'roomId', roomId)
            const localVarPath = `/web-collaboration/{roomId}/status`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication FirebaseToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebCollaborationApi - functional programming interface
 * @export
 */
export const WebCollaborationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebCollaborationApiAxiosParamCreator(configuration)
    return {
        /**
         * API per creare la room
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoom(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebCollaborationCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoom(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API per accettare l\'answer
         * @param {string} roomId Stanza
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAccept(roomId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAccept(roomId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API per memorizzare l\'answer
         * @param {string} roomId Stanza
         * @param {WebCollaborationAnswerRequest} webCollaborationAnswerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAnswer(roomId: string, webCollaborationAnswerRequest: WebCollaborationAnswerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAnswer(roomId, webCollaborationAnswerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API per memorizzare l\'ice-candidate
         * @param {string} roomId Stanza
         * @param {WebCollaborationIceCandidateRequest} webCollaborationIceCandidateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postIceCandidate(roomId: string, webCollaborationIceCandidateRequest: WebCollaborationIceCandidateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postIceCandidate(roomId, webCollaborationIceCandidateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API per memorizzare la offer
         * @param {string} roomId Stanza
         * @param {WebCollaborationOfferRequest} webCollaborationOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postOffer(roomId: string, webCollaborationOfferRequest: WebCollaborationOfferRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postOffer(roomId, webCollaborationOfferRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Stato della stanza
         * @param {'prospect' | 'consultant'} role Ruolo del partecipante
         * @param {string} roomId Stanza
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webCollaborationRoomIdStatusGet(role: 'prospect' | 'consultant', roomId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebCollaborationRoomStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webCollaborationRoomIdStatusGet(role, roomId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WebCollaborationApi - factory interface
 * @export
 */
export const WebCollaborationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebCollaborationApiFp(configuration)
    return {
        /**
         * API per creare la room
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoom(options?: any): AxiosPromise<WebCollaborationCreateResponse> {
            return localVarFp.createRoom(options).then((request) => request(axios, basePath));
        },
        /**
         * API per accettare l\'answer
         * @param {string} roomId Stanza
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccept(roomId: string, options?: any): AxiosPromise<void> {
            return localVarFp.postAccept(roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * API per memorizzare l\'answer
         * @param {string} roomId Stanza
         * @param {WebCollaborationAnswerRequest} webCollaborationAnswerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAnswer(roomId: string, webCollaborationAnswerRequest: WebCollaborationAnswerRequest, options?: any): AxiosPromise<void> {
            return localVarFp.postAnswer(roomId, webCollaborationAnswerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API per memorizzare l\'ice-candidate
         * @param {string} roomId Stanza
         * @param {WebCollaborationIceCandidateRequest} webCollaborationIceCandidateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postIceCandidate(roomId: string, webCollaborationIceCandidateRequest: WebCollaborationIceCandidateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.postIceCandidate(roomId, webCollaborationIceCandidateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API per memorizzare la offer
         * @param {string} roomId Stanza
         * @param {WebCollaborationOfferRequest} webCollaborationOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOffer(roomId: string, webCollaborationOfferRequest: WebCollaborationOfferRequest, options?: any): AxiosPromise<void> {
            return localVarFp.postOffer(roomId, webCollaborationOfferRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stato della stanza
         * @param {'prospect' | 'consultant'} role Ruolo del partecipante
         * @param {string} roomId Stanza
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webCollaborationRoomIdStatusGet(role: 'prospect' | 'consultant', roomId: string, options?: any): AxiosPromise<WebCollaborationRoomStatus> {
            return localVarFp.webCollaborationRoomIdStatusGet(role, roomId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for postAccept operation in WebCollaborationApi.
 * @export
 * @interface WebCollaborationApiPostAcceptRequest
 */
export interface WebCollaborationApiPostAcceptRequest {
    /**
     * Stanza
     * @type {string}
     * @memberof WebCollaborationApiPostAccept
     */
    readonly roomId: string
}

/**
 * Request parameters for postAnswer operation in WebCollaborationApi.
 * @export
 * @interface WebCollaborationApiPostAnswerRequest
 */
export interface WebCollaborationApiPostAnswerRequest {
    /**
     * Stanza
     * @type {string}
     * @memberof WebCollaborationApiPostAnswer
     */
    readonly roomId: string

    /**
     * 
     * @type {WebCollaborationAnswerRequest}
     * @memberof WebCollaborationApiPostAnswer
     */
    readonly webCollaborationAnswerRequest: WebCollaborationAnswerRequest
}

/**
 * Request parameters for postIceCandidate operation in WebCollaborationApi.
 * @export
 * @interface WebCollaborationApiPostIceCandidateRequest
 */
export interface WebCollaborationApiPostIceCandidateRequest {
    /**
     * Stanza
     * @type {string}
     * @memberof WebCollaborationApiPostIceCandidate
     */
    readonly roomId: string

    /**
     * 
     * @type {WebCollaborationIceCandidateRequest}
     * @memberof WebCollaborationApiPostIceCandidate
     */
    readonly webCollaborationIceCandidateRequest: WebCollaborationIceCandidateRequest
}

/**
 * Request parameters for postOffer operation in WebCollaborationApi.
 * @export
 * @interface WebCollaborationApiPostOfferRequest
 */
export interface WebCollaborationApiPostOfferRequest {
    /**
     * Stanza
     * @type {string}
     * @memberof WebCollaborationApiPostOffer
     */
    readonly roomId: string

    /**
     * 
     * @type {WebCollaborationOfferRequest}
     * @memberof WebCollaborationApiPostOffer
     */
    readonly webCollaborationOfferRequest: WebCollaborationOfferRequest
}

/**
 * Request parameters for webCollaborationRoomIdStatusGet operation in WebCollaborationApi.
 * @export
 * @interface WebCollaborationApiWebCollaborationRoomIdStatusGetRequest
 */
export interface WebCollaborationApiWebCollaborationRoomIdStatusGetRequest {
    /**
     * Ruolo del partecipante
     * @type {'prospect' | 'consultant'}
     * @memberof WebCollaborationApiWebCollaborationRoomIdStatusGet
     */
    readonly role: 'prospect' | 'consultant'

    /**
     * Stanza
     * @type {string}
     * @memberof WebCollaborationApiWebCollaborationRoomIdStatusGet
     */
    readonly roomId: string
}

/**
 * WebCollaborationApi - object-oriented interface
 * @export
 * @class WebCollaborationApi
 * @extends {BaseAPI}
 */
export class WebCollaborationApi extends BaseAPI {
    /**
     * API per creare la room
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebCollaborationApi
     */
    public createRoom(options?: AxiosRequestConfig) {
        return WebCollaborationApiFp(this.configuration).createRoom(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API per accettare l\'answer
     * @param {WebCollaborationApiPostAcceptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebCollaborationApi
     */
    public postAccept(requestParameters: WebCollaborationApiPostAcceptRequest, options?: AxiosRequestConfig) {
        return WebCollaborationApiFp(this.configuration).postAccept(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API per memorizzare l\'answer
     * @param {WebCollaborationApiPostAnswerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebCollaborationApi
     */
    public postAnswer(requestParameters: WebCollaborationApiPostAnswerRequest, options?: AxiosRequestConfig) {
        return WebCollaborationApiFp(this.configuration).postAnswer(requestParameters.roomId, requestParameters.webCollaborationAnswerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API per memorizzare l\'ice-candidate
     * @param {WebCollaborationApiPostIceCandidateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebCollaborationApi
     */
    public postIceCandidate(requestParameters: WebCollaborationApiPostIceCandidateRequest, options?: AxiosRequestConfig) {
        return WebCollaborationApiFp(this.configuration).postIceCandidate(requestParameters.roomId, requestParameters.webCollaborationIceCandidateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API per memorizzare la offer
     * @param {WebCollaborationApiPostOfferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebCollaborationApi
     */
    public postOffer(requestParameters: WebCollaborationApiPostOfferRequest, options?: AxiosRequestConfig) {
        return WebCollaborationApiFp(this.configuration).postOffer(requestParameters.roomId, requestParameters.webCollaborationOfferRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stato della stanza
     * @param {WebCollaborationApiWebCollaborationRoomIdStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebCollaborationApi
     */
    public webCollaborationRoomIdStatusGet(requestParameters: WebCollaborationApiWebCollaborationRoomIdStatusGetRequest, options?: AxiosRequestConfig) {
        return WebCollaborationApiFp(this.configuration).webCollaborationRoomIdStatusGet(requestParameters.role, requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }
}


